import { fi } from "date-fns/locale";
import React from "react";

export const ClosedEye = (fill) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none">
      <path
        d="M7.89172 12.7333C7.73339 12.7333 7.57506 12.6749 7.45006 12.5499C6.76672 11.8666 6.39172 10.9583 6.39172 9.99993C6.39172 8.00827 8.00839 6.3916 10.0001 6.3916C10.9584 6.3916 11.8667 6.7666 12.5501 7.44993C12.6667 7.5666 12.7334 7.72494 12.7334 7.8916C12.7334 8.05827 12.6667 8.2166 12.5501 8.33327L8.33339 12.5499C8.20839 12.6749 8.05006 12.7333 7.89172 12.7333ZM10.0001 7.6416C8.70006 7.6416 7.64172 8.69993 7.64172 9.99993C7.64172 10.4166 7.75006 10.8166 7.95006 11.1666L11.1667 7.94993C10.8167 7.74993 10.4167 7.6416 10.0001 7.6416Z"
        fill="#5A5B62"
      />
      <path
        d="M4.66666 15.4251C4.52499 15.4251 4.37499 15.3751 4.25833 15.2751C3.36666 14.5167 2.56666 13.5834 1.88333 12.5001C0.999992 11.1251 0.999992 8.8834 1.88333 7.50007C3.91666 4.31673 6.87499 2.4834 9.99999 2.4834C11.8333 2.4834 13.6417 3.11673 15.225 4.3084C15.5 4.51673 15.5583 4.9084 15.35 5.1834C15.1417 5.4584 14.75 5.51673 14.475 5.3084C13.1083 4.27507 11.5583 3.7334 9.99999 3.7334C7.30832 3.7334 4.73333 5.35007 2.93333 8.17507C2.30833 9.15007 2.30833 10.8501 2.93333 11.8251C3.55833 12.8001 4.27499 13.6417 5.06666 14.3251C5.32499 14.5501 5.35833 14.9417 5.13332 15.2084C5.01666 15.3501 4.84166 15.4251 4.66666 15.4251Z"
        fill="#5A5B62"
      />
      <path
        d="M10 17.5166C8.89168 17.5166 7.80834 17.2916 6.76668 16.8499C6.45001 16.7166 6.30001 16.3499 6.43334 16.0333C6.56668 15.7166 6.93334 15.5666 7.25001 15.6999C8.13334 16.0749 9.05834 16.2666 9.99168 16.2666C12.6833 16.2666 15.2583 14.6499 17.0583 11.8249C17.6833 10.8499 17.6833 9.14992 17.0583 8.17492C16.8 7.76658 16.5167 7.37492 16.2167 7.00825C16 6.74158 16.0417 6.34992 16.3083 6.12492C16.575 5.90825 16.9667 5.94158 17.1917 6.21658C17.5167 6.61658 17.8333 7.04992 18.1167 7.49992C19 8.87492 19 11.1166 18.1167 12.4999C16.0833 15.6833 13.125 17.5166 10 17.5166Z"
        fill="#5A5B62"
      />
      <path
        d="M10.575 13.5584C10.2834 13.5584 10.0167 13.35 9.95836 13.05C9.89169 12.7084 10.1167 12.3834 10.4584 12.325C11.375 12.1584 12.1417 11.3917 12.3084 10.475C12.375 10.1334 12.7 9.91671 13.0417 9.97504C13.3834 10.0417 13.6084 10.3667 13.5417 10.7084C13.275 12.15 12.125 13.2917 10.6917 13.5584C10.65 13.55 10.6167 13.5584 10.575 13.5584Z"
        fill="#5A5B62"
      />
      <path
        d="M1.66662 18.9583C1.50828 18.9583 1.34995 18.8999 1.22495 18.7749C0.983285 18.5333 0.983285 18.1333 1.22495 17.8916L7.44995 11.6666C7.69162 11.4249 8.09162 11.4249 8.33328 11.6666C8.57495 11.9083 8.57495 12.3083 8.33328 12.5499L2.10828 18.7749C1.98328 18.8999 1.82495 18.9583 1.66662 18.9583Z"
        fill="#5A5B62"
      />
      <path
        d="M12.1084 8.51662C11.9501 8.51662 11.7917 8.45828 11.6667 8.33328C11.4251 8.09162 11.4251 7.69162 11.6667 7.44995L17.8917 1.22495C18.1334 0.983285 18.5334 0.983285 18.7751 1.22495C19.0167 1.46662 19.0167 1.86662 18.7751 2.10828L12.5501 8.33328C12.4251 8.45828 12.2667 8.51662 12.1084 8.51662Z"
        fill="#5A5B62"
      />
    </svg>
  );
};

export const DropdownBelow = (fill) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="8"
      viewBox="0 0 12 8"
      fill="none">
      <path
        d="M1.41 0L6 4.58L10.59 0L12 1.41L6 7.41L0 1.41L1.41 0Z"
        fill="white"
      />
    </svg>
  );
};
export const DropdownIcon = (fill) => {
  return (
    <svg
      width="18"
      height="19"
      viewBox="0 0 18 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path d="M4 7L9.5 13L15 7H4Z" fill="#A6A5B4" />
    </svg>
  );
};

export const BoostIcon = (fill) => {
  return (
    <svg
      width="13"
      height="14"
      viewBox="0 0 13 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path d="M0 13.41H13V0.41H0V13.41Z" fill="white" />
    </svg>
  );
};
export const OpenEye = (fill) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none">
      <path
        d="M9.99993 1.66675V3.33341M17.4999 4.16675L16.2499 5.41675M2.49993 4.16675L3.74993 5.41675M9.99996 18.3334C13.0035 18.3334 15.6778 16.3788 17.3976 14.7325C18.6452 13.5382 18.6452 11.4619 17.3976 10.2677C15.6778 8.62134 13.0035 6.66675 9.99996 6.66675C6.99646 6.66675 4.32214 8.62134 2.6023 10.2677C1.35474 11.4619 1.35474 13.5382 2.6023 14.7325C4.32214 16.3788 6.99646 18.3334 9.99996 18.3334ZM12.4999 12.5001C12.4999 13.8808 11.3806 15.0001 9.99993 15.0001C8.61922 15.0001 7.49993 13.8808 7.49993 12.5001C7.49993 11.1194 8.61922 10.0001 9.99993 10.0001C11.3806 10.0001 12.4999 11.1194 12.4999 12.5001Z"
        stroke="#5A5B62"
        strokeWidth="1.25"
        strokeLinecap="round"
      />
    </svg>
  );
};

export const Search = (fill) => {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <ellipse
        cx="7.82491"
        cy="7.8254"
        rx="6.74142"
        ry="6.74142"
        stroke="#090A14"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.5137 12.8643L15.1567 15.5004"
        stroke="#090A14"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const Facebook = (fill) => {
  return (
    <svg height="16" width="16" viewBox="0 0 320 512">
      <path d="M279.14 288l14.22-92.66h-88.91v-60.13c0-25.35 12.42-50.06 52.24-50.06h40.42V6.26S260.43 0 225.36 0c-73.22 0-121.08 44.38-121.08 124.72v70.62H22.89V288h81.39v224h100.17V288z" />
    </svg>
  );
};

export const Google = (fill) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="16"
      width="16"
      viewBox="0 0 488 512">
      <path d="M488 261.8C488 403.3 391.1 504 248 504 110.8 504 0 393.2 0 256S110.8 8 248 8c66.8 0 123 24.5 166.3 64.9l-67.5 64.9C258.5 52.6 94.3 116.6 94.3 256c0 86.5 69.1 156.6 153.7 156.6 98.2 0 135-70.4 140.8-106.9H248v-85.3h236.1c2.3 12.7 3.9 24.9 3.9 41.4z" />
    </svg>
  );
};

export const Twitter = (fill) => {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4 0.5C1.79086 0.5 0 2.29086 0 4.5V20.5C0 22.7091 1.79086 24.5 4 24.5H20C22.2091 24.5 24 22.7091 24 20.5V4.5C24 2.29086 22.2091 0.5 20 0.5H4ZM5.19197 5.64286H9.72768L12.9487 10.2199L16.8571 5.64286H18.2857L13.5938 11.1362L19.3795 19.3571H14.8449L11.1071 14.0469L6.57143 19.3571H5.14286L10.4621 13.1306L5.19197 5.64286ZM7.37946 6.78571L15.4408 18.2143H17.192L9.13058 6.78571H7.37946Z"
        fill="#090A14"
      />
    </svg>
  );
};

export const SendReminder = (fill) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.4318 11.7946V8.30069C12.4318 8.1536 12.3734 8.01254 12.2694 7.90853C12.1654 7.80452 12.0243 7.74609 11.8772 7.74609C11.7301 7.74609 11.5891 7.80452 11.4851 7.90853C11.3811 8.01254 11.3226 8.1536 11.3226 8.30069V12.0535C11.3232 12.1349 11.3417 12.2152 11.3769 12.2887C11.412 12.3622 11.4629 12.4271 11.526 12.4787L13.504 14.1055C13.6182 14.1811 13.7564 14.2118 13.8919 14.1916C14.0273 14.1714 14.1506 14.1019 14.2378 13.9963C14.325 13.8907 14.3701 13.7565 14.3643 13.6197C14.3586 13.4828 14.3023 13.353 14.2065 13.2551L12.4318 11.7946Z"
        fill="white"
      />
      <path
        d="M17.3307 5.21278C16.6327 5.209 15.9615 5.48147 15.4636 5.97073C14.4021 5.33548 13.1882 5 11.9512 5C10.7141 5 9.50021 5.33548 8.43872 5.97073C8.16659 5.719 7.84456 5.52731 7.49353 5.40812C7.14251 5.28894 6.77034 5.24491 6.4012 5.2789C6.03205 5.31288 5.67418 5.42413 5.35082 5.60541C5.02747 5.78669 4.74585 6.03396 4.52426 6.33115C4.30267 6.62834 4.14607 6.96881 4.06461 7.33045C3.98315 7.6921 3.97867 8.06684 4.05144 8.43033C4.12422 8.79382 4.27264 9.13794 4.48705 9.44035C4.70146 9.74276 4.97708 9.99669 5.296 10.1857C5.01002 11.3301 5.02486 12.529 5.33906 13.6659C5.65327 14.8029 6.25617 15.8393 7.0892 16.6744L5.88757 18.2643C5.79932 18.382 5.76143 18.5299 5.78223 18.6755C5.80303 18.8211 5.88082 18.9525 5.99849 19.0407C6.11616 19.129 6.26407 19.1669 6.40968 19.1461C6.55529 19.1253 6.68667 19.0475 6.77493 18.9298L7.93958 17.3954C9.10365 18.2388 10.5044 18.6929 11.9419 18.6929C13.3794 18.6929 14.7802 18.2388 15.9443 17.3954L17.1274 18.9298C17.2157 19.0475 17.347 19.1253 17.4926 19.1461C17.6383 19.1669 17.7862 19.129 17.9038 19.0407C18.0215 18.9525 18.0993 18.8211 18.1201 18.6755C18.1409 18.5299 18.103 18.382 18.0148 18.2643L16.8131 16.6744C17.6462 15.8393 18.2491 14.8029 18.5633 13.6659C18.8775 12.529 18.8923 11.3301 18.6063 10.1857C19.1273 9.90614 19.5395 9.46008 19.7771 8.91874C20.0147 8.37741 20.064 7.77205 19.9171 7.1994C19.7702 6.62675 19.4356 6.11987 18.9668 5.75974C18.4979 5.39962 17.9219 5.20704 17.3307 5.21278ZM5.03719 7.85635C5.03539 7.56822 5.11476 7.28539 5.26622 7.04027C5.41767 6.79514 5.63509 6.59761 5.89358 6.47029C6.15207 6.34298 6.44118 6.29102 6.72783 6.32037C7.01447 6.34972 7.28706 6.45918 7.51439 6.63624C6.71818 7.311 6.086 8.15813 5.66573 9.11344C5.4695 8.96809 5.31032 8.7785 5.2011 8.56008C5.09189 8.34165 5.03574 8.10055 5.03719 7.85635ZM11.9512 17.5803C10.8133 17.5803 9.70097 17.2426 8.7551 16.6101C7.80923 15.9775 7.07234 15.0785 6.63774 14.0268C6.20314 12.9752 6.09036 11.8183 6.31371 10.7025C6.53705 9.58675 7.08646 8.56236 7.89236 7.75904C8.69827 6.95573 9.72443 6.40962 10.8409 6.18987C11.9574 5.97013 13.1139 6.08662 14.1642 6.52461C15.2144 6.9626 16.111 7.70238 16.7405 8.65028C17.3701 9.59818 17.7041 10.7116 17.7005 11.8495C17.6956 13.3711 17.0877 14.8287 16.01 15.9029C14.9323 16.9771 13.4728 17.5803 11.9512 17.5803ZM18.2366 9.11344C17.8163 8.15813 17.1841 7.311 16.3879 6.63624C16.7164 6.3911 17.1289 6.28648 17.5345 6.34542C17.7353 6.3746 17.9285 6.44306 18.1029 6.54688C18.2772 6.6507 18.4295 6.78786 18.5509 6.95051C18.6722 7.11317 18.7604 7.29814 18.8103 7.49487C18.8602 7.69159 18.8709 7.89622 18.8417 8.09706C18.8125 8.29791 18.744 8.49104 18.6402 8.66543C18.5364 8.83982 18.3992 8.99206 18.2366 9.11344Z"
        fill="white"
      />
    </svg>
  );
};

export const TwitterBlack = (fill) => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1.48198 0.856445C0.821813 0.856445 0.287109 1.39115 0.287109 2.05131V12.8051C0.287109 13.4653 0.821813 14 1.48198 14H12.2358C12.896 14 13.4307 13.4653 13.4307 12.8051V2.05131C13.4307 1.39115 12.896 0.856445 12.2358 0.856445H1.48198ZM3.06425 3.84362H5.81921L7.42715 6.14234L9.41665 3.84362H10.2836L7.81688 6.7001L10.8344 11.0128H8.07943L6.29529 8.46206L4.09225 11.0128H3.21127L5.90322 7.90314L3.06425 3.84362ZM4.3968 4.55074L8.43182 10.3022H9.50067L5.46448 4.55074H4.3968Z"
        fill="#090A14"
      />
    </svg>
  );
};

export const TwitterHover = (fill) => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1.48198 0.856445C0.821813 0.856445 0.287109 1.39115 0.287109 2.05131V12.8051C0.287109 13.4653 0.821813 14 1.48198 14H12.2358C12.896 14 13.4307 13.4653 13.4307 12.8051V2.05131C13.4307 1.39115 12.896 0.856445 12.2358 0.856445H1.48198ZM3.06425 3.84362H5.81921L7.42715 6.14234L9.41665 3.84362H10.2836L7.81688 6.7001L10.8344 11.0128H8.07943L6.29529 8.46206L4.09225 11.0128H3.21127L5.90322 7.90314L3.06425 3.84362ZM4.3968 4.55074L8.43182 10.3022H9.50067L5.46448 4.55074H4.3968Z"
        fill="#1977F2"
      />
    </svg>
  );
};

export const DashboardIcon = ({ className, fill, isActive }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.6076 4.25H9.67733C5.69954 4.25 4 5.94954 4 9.92733V14.3227C4 18.3005 5.69954 20 9.67733 20H14.0727C18.0505 20 19.75 18.3005 19.75 14.3227V11.3924C19.75 11.0921 19.5009 10.843 19.2006 10.843C18.9002 10.843 18.6512 11.0921 18.6512 11.3924V14.3227C18.6512 17.6998 17.4498 18.9012 14.0727 18.9012H9.67733C6.30023 18.9012 5.09884 17.6998 5.09884 14.3227V9.92733C5.09884 6.55023 6.30023 5.34884 9.67733 5.34884H12.6076C12.9079 5.34884 13.157 5.09977 13.157 4.79942C13.157 4.49907 12.9079 4.25 12.6076 4.25Z"
        fill="#5A5B62"
      />
      <path
        d="M8.45402 14.5067C8.33682 14.5067 8.21961 14.4701 8.11705 14.3895C7.87531 14.2064 7.83137 13.8621 8.01451 13.6203L9.75798 11.3567C9.97042 11.0857 10.2708 10.9099 10.6151 10.8659C10.9594 10.822 11.2964 10.9172 11.5674 11.1296L12.908 12.1845C12.9593 12.2285 13.0106 12.2211 13.0472 12.2211C13.0765 12.2211 13.1277 12.2065 13.1717 12.1479L14.8639 9.96485C15.047 9.72311 15.3914 9.67916 15.6331 9.86962C15.8749 10.0528 15.9188 10.3971 15.7283 10.6388L14.0361 12.8218C13.8237 13.0929 13.5233 13.2687 13.179 13.3053C12.8421 13.3493 12.4977 13.254 12.234 13.0416L10.8935 11.9867C10.8422 11.9428 10.7836 11.9428 10.7543 11.9501C10.725 11.9501 10.6737 11.9647 10.6297 12.0233L8.88625 14.2869C8.7837 14.4335 8.62251 14.5067 8.45402 14.5067Z"
        fill="#5A5B62"
      />
      <circle cx="18" cy="6" r="2" fill="#5A5B62" />
    </svg>
  );
};
export const DashboardIconActive = ({ className, fill, isActive }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14.649 4.75049C14.6076 4.96312 14.587 5.17925 14.5874 5.39585C14.5874 7.33922 16.1652 8.91463 18.1114 8.91463C18.3257 8.91358 18.5394 8.89301 18.75 8.85317V15.8293C18.75 18.7641 17.0188 20.5005 14.0796 20.5005H7.67807C4.73119 20.5005 3 18.7641 3 15.8293V9.43707C3 6.5022 4.73119 4.75049 7.67807 4.75049H14.649ZM14.7547 9.99546L14.6521 10.0019C14.481 10.0265 14.3272 10.1193 14.2258 10.2591L12.1176 12.9712L9.71702 11.0812C9.57997 10.9744 9.40562 10.9273 9.23333 10.9504C9.06105 10.9736 8.90536 11.065 8.80142 11.2041L6.21617 14.5385C6.1253 14.6518 6.07638 14.7929 6.07767 14.938L6.07995 15.0346C6.10501 15.2884 6.27905 15.5076 6.52833 15.5863C6.80877 15.6748 7.11371 15.5631 7.27027 15.3145L9.43234 12.5179L11.8329 14.4002C11.9695 14.5103 12.145 14.5602 12.3191 14.5385C12.4932 14.5168 12.651 14.4253 12.7562 14.285L15.2568 11.0582V11.0428C15.4709 10.7551 15.4163 10.3495 15.1337 10.1285C14.997 10.023 14.8232 9.97726 14.6521 10.0019L14.7547 9.99546Z"
        fill="#090A14"
      />
      <path
        d="M18.3124 7.375C19.5205 7.375 20.4999 6.39562 20.4999 5.1875C20.4999 3.97938 19.5205 3 18.3124 3C17.1043 3 16.1249 3.97938 16.1249 5.1875C16.1249 6.39562 17.1043 7.375 18.3124 7.375Z"
        fill="#090A14"
      />
    </svg>
  );
};

export const CampaignsIcon = ({ className, fill }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M20.7333 11.863C20.7333 10.2949 19.5102 8.98984 17.9115 8.7414V5.54732C17.9115 5.36871 17.8231 5.20125 17.675 5.09881C17.5269 4.99637 17.3372 4.97186 17.1672 5.03336L8.24508 8.25393H5.43235C4.09104 8.25393 3 9.33131 3 10.6558V13.0704C3 14.3949 4.09104 15.4723 5.43235 15.4723H5.78701V18.4528C5.78701 18.7551 6.03506 19 6.34118 19H8.34305C8.64918 19 8.89722 18.7551 8.89722 18.4528V15.7079L17.1669 18.6929C17.2288 18.7152 17.2931 18.7262 17.3571 18.7262C17.4693 18.7262 17.5803 18.6927 17.6748 18.6274C17.8231 18.525 17.9113 18.3578 17.9113 18.1789V14.9849C19.5102 14.7362 20.7333 13.4312 20.7333 11.863ZM4.10833 13.0704V10.6558C4.10833 9.9348 4.7024 9.34839 5.43235 9.34839H7.78889V14.3779H5.43235C4.7024 14.3779 4.10833 13.7915 4.10833 13.0704ZM6.89535 17.9055V15.4723H7.78889V17.9055H6.89535ZM16.8032 17.3962L8.89722 14.5425V9.18378L16.8032 6.33008V17.3962ZM17.9115 13.8705V9.85578C18.8948 10.0821 19.625 10.8962 19.625 11.863C19.625 12.8299 18.8948 13.6441 17.9115 13.8705Z"
        fill="#5A5B62"
      />
    </svg>
  );
};
export const CampaignsIconActive = ({ className, fill }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M20.7333 11.863C20.7333 10.2949 19.5102 8.98984 17.9115 8.7414V5.54732C17.9115 5.36871 17.8231 5.20125 17.675 5.09881C17.5269 4.99637 17.3372 4.97186 17.1672 5.03336L8.24508 8.25393H5.43235C4.09104 8.25393 3 9.33131 3 10.6558V13.0704C3 14.3949 4.09104 15.4723 5.43235 15.4723H5.78701V18.4528C5.78701 18.7551 6.03506 19 6.34118 19H8.34305C8.64918 19 8.89722 18.7551 8.89722 18.4528V15.7079L17.1669 18.6929C17.2288 18.7152 17.2931 18.7262 17.3571 18.7262C17.4693 18.7262 17.5803 18.6927 17.6748 18.6274C17.8231 18.525 17.9113 18.3578 17.9113 18.1789V14.9849C19.5102 14.7362 20.7333 13.4312 20.7333 11.863ZM4.10833 13.0704V10.6558C4.10833 9.9348 4.7024 9.34839 5.43235 9.34839H7.78889V14.3779H5.43235C4.7024 14.3779 4.10833 13.7915 4.10833 13.0704ZM6.89535 17.9055V15.4723H7.78889V17.9055H6.89535ZM17.9115 13.8705V9.85578C18.8948 10.0821 19.625 10.8962 19.625 11.863C19.625 12.8299 18.8948 13.6441 17.9115 13.8705Z"
        fill="#090A14"
      />
    </svg>
  );
};

export const ReportsIcon = ({ className, fill, isActive }) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none">
      <path
        d="M14.2326 20H9.76744C5.72651 20 4 18.2735 4 14.2326V9.76744C4 5.72651 5.72651 4 9.76744 4H14.2326C18.2735 4 20 5.72651 20 9.76744V14.2326C20 18.2735 18.2735 20 14.2326 20ZM9.76744 5.11628C6.33674 5.11628 5.11628 6.33674 5.11628 9.76744V14.2326C5.11628 17.6633 6.33674 18.8837 9.76744 18.8837H14.2326C17.6633 18.8837 18.8837 17.6633 18.8837 14.2326V9.76744C18.8837 6.33674 17.6633 5.11628 14.2326 5.11628H9.76744Z"
        fill={fill}
      />

      <g>
        <path
          d="M14.6046 17.3962C13.4735 17.3962 12.5581 16.4808 12.5581 15.3497V8.65198C12.5581 7.52082 13.4735 6.60547 14.6046 6.60547C15.7358 6.60547 16.6512 7.52082 16.6512 8.65198V15.3497C16.6512 16.4808 15.7358 17.3962 14.6046 17.3962ZM14.6046 7.72175C14.0912 7.72175 13.6744 8.13849 13.6744 8.65198V15.3497C13.6744 15.8631 14.0912 16.2799 14.6046 16.2799C15.1181 16.2799 15.5349 15.8631 15.5349 15.3497V8.65198C15.5349 8.13849 15.1181 7.72175 14.6046 7.72175Z"
          fill={fill}
        />
        <path
          d="M9.39536 17.3949C8.2642 17.3949 7.34885 16.4796 7.34885 15.3484V12.7438C7.34885 11.6126 8.2642 10.6973 9.39536 10.6973C10.5265 10.6973 11.4419 11.6126 11.4419 12.7438V15.3484C11.4419 16.4796 10.5265 17.3949 9.39536 17.3949ZM9.39536 11.8135C8.88187 11.8135 8.46513 12.2303 8.46513 12.7438V15.3484C8.46513 15.8619 8.88187 16.2787 9.39536 16.2787C9.90885 16.2787 10.3256 15.8619 10.3256 15.3484V12.7438C10.3256 12.2303 9.90885 11.8135 9.39536 11.8135Z"
          fill={fill}
        />
      </g>
    </svg>
  );
};

export const TransactionIcon = ({ className, fill }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M16.4249 13.1988C16.089 13.5267 15.8972 13.9984 15.9451 14.5021C16.0171 15.3656 16.8086 15.9972 17.6721 15.9972H19.1913V16.9487C19.1913 18.6037 17.84 19.955 16.185 19.955H7.00627C5.35122 19.955 4 18.6037 4 16.9487V11.5678C4 9.91275 5.35122 8.56152 7.00627 8.56152H16.185C17.84 8.56152 19.1913 9.91275 19.1913 11.5678V12.7191H17.5762C17.1284 12.7191 16.7207 12.895 16.4249 13.1988Z"
        stroke="#5A5B62"
        strokeWidth="1.19931"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4 10.5095V8.63289C4 7.68144 4.58366 6.83389 5.47115 6.49809L11.8195 4.09947C12.8109 3.72368 13.8743 4.45928 13.8743 5.52267V7.35943"
        stroke="#5A5B62"
        strokeWidth="1.19931"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M20.0378 13.5342V15.1813C20.0378 15.6211 19.686 15.9809 19.2383 15.9968H17.6712C16.8077 15.9968 16.0161 15.3652 15.9442 14.5017C15.8962 13.998 16.0881 13.5263 16.4239 13.1985C16.7197 12.8946 17.1275 12.7188 17.5752 12.7188H19.2383C19.686 12.7347 20.0378 13.0945 20.0378 13.5342Z"
        stroke="#5A5B62"
        strokeWidth="1.19931"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.5979 11.958H13.1947"
        stroke="#5A5B62"
        strokeWidth="1.19931"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const TransactionIconActive = ({ className, fill }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M16.4249 13.1988C16.089 13.5267 15.8972 13.9984 15.9451 14.5021C16.0171 15.3656 16.8086 15.9972 17.6721 15.9972H19.1913V16.9487C19.1913 18.6037 17.84 19.955 16.185 19.955H7.00627C5.35122 19.955 4 18.6037 4 16.9487V11.5678C4 9.91275 5.35122 8.56152 7.00627 8.56152H16.185C17.84 8.56152 19.1913 9.91275 19.1913 11.5678V12.7191H17.5762C17.1284 12.7191 16.7207 12.895 16.4249 13.1988Z"
        fill="#090A14"
        stroke="#090A14"
        strokeWidth="1.19931"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4 10.5095V8.63289C4 7.68144 4.58366 6.83389 5.47115 6.49809L11.8195 4.09947C12.8109 3.72368 13.8743 4.45928 13.8743 5.52267V7.35943"
        stroke="#090A14"
        strokeWidth="1.19931"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M20.0378 13.5342V15.1813C20.0378 15.6211 19.686 15.9809 19.2383 15.9968H17.6712C16.8077 15.9968 16.0161 15.3652 15.9442 14.5017C15.8962 13.998 16.0881 13.5263 16.4239 13.1985C16.7197 12.8946 17.1275 12.7188 17.5752 12.7188H19.2383C19.686 12.7347 20.0378 13.0945 20.0378 13.5342Z"
        stroke="#090A14"
        strokeWidth="1.19931"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.5979 11.958H13.1947"
        stroke="#F0F3F9"
        strokeWidth="1.19931"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ManageTeamIcon = ({ className, fill }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.50443 11.1637C9.42366 11.1557 9.32673 11.1557 9.23789 11.1637C7.31559 11.0991 5.78906 9.52423 5.78906 7.5859C5.78906 5.6072 7.38828 4 9.3752 4C11.354 4 12.9613 5.6072 12.9613 7.5859C12.9533 9.52423 11.4267 11.0991 9.50443 11.1637Z"
        stroke="#5A5B62"
        strokeWidth="1.21149"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.3601 5.61621C16.927 5.61621 18.187 6.8842 18.187 8.44294C18.187 9.96937 16.9755 11.2131 15.4651 11.2697C15.4005 11.2616 15.3278 11.2616 15.2551 11.2697"
        stroke="#5A5B62"
        strokeWidth="1.21149"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.46595 14.1446C3.51135 15.453 3.51135 17.5851 5.46595 18.8854C7.68709 20.3715 11.3298 20.3715 13.5509 18.8854C15.5055 17.5771 15.5055 15.4449 13.5509 14.1446C11.3378 12.6666 7.69517 12.6666 5.46595 14.1446Z"
        stroke="#5A5B62"
        strokeWidth="1.21149"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.9189 18.5382C17.5005 18.4171 18.0497 18.1828 18.502 17.8356C19.762 16.8906 19.762 15.3319 18.502 14.3869C18.0578 14.0477 17.5166 13.8216 16.9432 13.6924"
        stroke="#5A5B62"
        strokeWidth="1.21149"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const ManageTeamIconActive = ({ className, fill }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 11C12.2091 11 14 9.20914 14 7C14 4.79086 12.2091 3 10 3C7.79086 3 6 4.79086 6 7C6 9.20914 7.79086 11 10 11ZM10 21.0008C13.866 21.0008 17 19.2099 17 17.0008C17 14.7916 13.866 13.0008 10 13.0008C6.13401 13.0008 3 14.7916 3 17.0008C3 19.2099 6.13401 21.0008 10 21.0008ZM13.9614 10.8155C14.9141 9.82657 15.5 8.48177 15.5 7.00013C15.5 6.29553 15.3675 5.62188 15.1261 5.00273C16.7244 5.06884 17.9999 6.38553 17.9999 8.00013C17.9999 9.65698 16.6568 11.0001 14.9999 11.0001C14.6349 11.0001 14.285 10.9349 13.9614 10.8155ZM18.4999 16.9999C18.4999 17.5387 18.3802 18.0594 18.1569 18.5515C19.8634 18.0225 20.9999 17.0776 20.9999 15.9999C20.9999 14.4937 18.7799 13.2467 15.8867 13.0324C17.4974 14.0333 18.4999 15.4408 18.4999 16.9999Z"
        fill="#090A14"
      />
    </svg>
  );
};

export const SettingIcon = ({ className, fill }) => {
  return (
    <svg
      className={className}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <g id="Huge-icon">
        <path
          id="Vector"
          d="M19.7724 15.3072L19.2038 14.959V14.959L19.7724 15.3072ZM18.9239 16.6928L19.4924 17.041V17.041L18.9239 16.6928ZM4.22764 8.69281L3.65909 8.34467H3.65909L4.22764 8.69281ZM5.07612 7.30717L5.64467 7.65532V7.65532L5.07612 7.30717ZM7.39424 6.72153L7.71298 6.136L7.71298 6.136L7.39424 6.72153ZM4.84877 10.8785L4.53003 11.464H4.53003L4.84877 10.8785ZM16.6058 17.2785L16.287 17.864H16.287L16.6058 17.2785ZM19.1512 13.1215L18.8325 13.7071L19.1512 13.1215ZM5.07612 16.6928L4.50758 17.041H4.50758L5.07612 16.6928ZM4.22763 15.3072L4.79618 14.959H4.79618L4.22763 15.3072ZM18.9239 7.30719L19.4924 6.95904V6.95904L18.9239 7.30719ZM19.7724 8.69283L19.2038 9.04097V9.04097L19.7724 8.69283ZM19.1512 10.8785L19.47 11.464L19.1512 10.8785ZM16.6058 6.72154L16.9245 7.30708V7.30708L16.6058 6.72154ZM4.84877 13.1215L5.16751 13.7071H5.16751L4.84877 13.1215ZM7.39424 17.2785L7.0755 16.6929L7.0755 16.6929L7.39424 17.2785ZM16.5156 6.77065L16.1968 6.18511L16.5156 6.77065ZM7.48444 6.77064L7.1657 7.35617L7.16571 7.35617L7.48444 6.77064ZM16.5156 17.2294L16.8343 16.6438H16.8343L16.5156 17.2294ZM7.48444 17.2294L7.80318 17.8149L7.80318 17.8149L7.48444 17.2294ZM11.1515 4.66667H12.8485V3.33333H11.1515V4.66667ZM12.8485 19.3333H11.1515V20.6667H12.8485V19.3333ZM11.1515 19.3333C10.545 19.3333 10.1212 18.8791 10.1212 18.4H8.78787C8.78787 19.6883 9.88361 20.6667 11.1515 20.6667V19.3333ZM13.8788 18.4C13.8788 18.8791 13.455 19.3333 12.8485 19.3333V20.6667C14.1164 20.6667 15.2121 19.6883 15.2121 18.4H13.8788ZM12.8485 4.66667C13.455 4.66667 13.8788 5.12095 13.8788 5.6H15.2121C15.2121 4.31174 14.1164 3.33333 12.8485 3.33333V4.66667ZM11.1515 3.33333C9.88361 3.33333 8.78787 4.31174 8.78787 5.6H10.1212C10.1212 5.12095 10.545 4.66667 11.1515 4.66667V3.33333ZM19.2038 14.959L18.3553 16.3447L19.4924 17.041L20.3409 15.6553L19.2038 14.959ZM4.79618 9.04096L5.64467 7.65532L4.50758 6.95903L3.65909 8.34467L4.79618 9.04096ZM5.64467 7.65532C5.91901 7.20729 6.56049 7.02672 7.0755 7.30707L7.71298 6.136C6.60468 5.53269 5.17045 5.87652 4.50758 6.95903L5.64467 7.65532ZM5.16751 10.2929C4.6733 10.0239 4.53715 9.46396 4.79618 9.04096L3.65909 8.34467C2.9809 9.4522 3.40094 10.8494 4.53003 11.464L5.16751 10.2929ZM18.3553 16.3447C18.081 16.7927 17.4395 16.9733 16.9245 16.6929L16.287 17.864C17.3953 18.4673 18.8296 18.1235 19.4924 17.041L18.3553 16.3447ZM20.3409 15.6553C21.0191 14.5478 20.5991 13.1506 19.47 12.536L18.8325 13.7071C19.3267 13.9761 19.4628 14.536 19.2038 14.959L20.3409 15.6553ZM5.64467 16.3447L4.79618 14.959L3.65909 15.6553L4.50758 17.041L5.64467 16.3447ZM18.3553 7.65533L19.2038 9.04097L20.3409 8.34468L19.4924 6.95904L18.3553 7.65533ZM19.2038 9.04097C19.4628 9.46398 19.3267 10.0239 18.8325 10.2929L19.47 11.464C20.5991 10.8494 21.0191 9.45221 20.3409 8.34468L19.2038 9.04097ZM16.9245 7.30708C17.4395 7.02673 18.081 7.2073 18.3553 7.65533L19.4924 6.95904C18.8296 5.87653 17.3953 5.5327 16.287 6.13601L16.9245 7.30708ZM4.79618 14.959C4.53715 14.536 4.6733 13.9761 5.16751 13.7071L4.53003 12.536C3.40094 13.1506 2.9809 14.5478 3.65909 15.6553L4.79618 14.959ZM4.50758 17.041C5.17045 18.1235 6.60468 18.4673 7.71297 17.864L7.0755 16.6929C6.56049 16.9733 5.91901 16.7927 5.64467 16.3447L4.50758 17.041ZM16.8343 7.35618L16.9245 7.30708L16.287 6.13601L16.1968 6.18511L16.8343 7.35618ZM7.0755 7.30707L7.1657 7.35617L7.80318 6.18511L7.71298 6.136L7.0755 7.30707ZM16.9245 16.6929L16.8343 16.6438L16.1968 17.8149L16.287 17.864L16.9245 16.6929ZM7.16571 16.6438L7.0755 16.6929L7.71297 17.864L7.80318 17.8149L7.16571 16.6438ZM4.53003 11.464C4.9547 11.6952 4.9547 12.3048 4.53003 12.536L5.16751 13.7071C6.51998 12.9709 6.51999 11.0292 5.16751 10.2929L4.53003 11.464ZM7.80318 17.8149C8.2471 17.5732 8.78787 17.8946 8.78787 18.4H10.1212C10.1212 16.883 8.49809 15.9185 7.1657 16.6438L7.80318 17.8149ZM15.2121 18.4C15.2121 17.8946 15.7529 17.5732 16.1968 17.8149L16.8343 16.6438C15.5019 15.9185 13.8788 16.883 13.8788 18.4H15.2121ZM19.47 12.536C19.0453 12.3048 19.0453 11.6952 19.47 11.464L18.8325 10.2929C17.48 11.0292 17.48 12.9708 18.8325 13.7071L19.47 12.536ZM7.16571 7.35617C8.49809 8.08146 10.1212 7.117 10.1212 5.6H8.78787C8.78787 6.10542 8.2471 6.42675 7.80318 6.18511L7.16571 7.35617ZM16.1968 6.18511C15.7529 6.42676 15.2121 6.10543 15.2121 5.6H13.8788C13.8788 7.11701 15.5019 8.08147 16.8343 7.35618L16.1968 6.18511ZM14 12C14 13.1046 13.1046 14 12 14V15.3333C13.841 15.3333 15.3333 13.8409 15.3333 12H14ZM12 14C10.8954 14 10 13.1046 10 12H8.66667C8.66667 13.8409 10.1591 15.3333 12 15.3333V14ZM10 12C10 10.8954 10.8954 10 12 10V8.66667C10.1591 8.66667 8.66667 10.1591 8.66667 12H10ZM12 10C13.1046 10 14 10.8954 14 12H15.3333C15.3333 10.1591 13.841 8.66667 12 8.66667V10Z"
          fill={fill}
        />
      </g>
    </svg>
  );
};

export const UserIcon = (fill) => {
  return (
    <svg
      version="1.1"
      id="Capa_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      height="19"
      width="20"
      viewBox="0 0 489 489"
      enable-background="new 0 0 489 489">
      <g>
        <g>
          <path
            d="M417.4,71.6C371.2,25.4,309.8,0,244.5,0S117.8,25.4,71.6,71.6S0,179.2,0,244.5s25.4,126.7,71.6,172.9S179.2,489,244.5,489
			s126.7-25.4,172.9-71.6S489,309.8,489,244.5S463.6,117.8,417.4,71.6z M244.5,462C124.6,462,27,364.4,27,244.5S124.6,27,244.5,27
			S462,124.6,462,244.5S364.4,462,244.5,462z"
          />
          <path
            d="M244.5,203.2c35.1,0,63.6-28.6,63.6-63.6s-28.5-63.7-63.6-63.7s-63.6,28.6-63.6,63.6S209.4,203.2,244.5,203.2z
			 M244.5,102.9c20.2,0,36.6,16.4,36.6,36.6s-16.4,36.6-36.6,36.6s-36.6-16.4-36.6-36.6S224.3,102.9,244.5,102.9z"
          />
          <path
            d="M340.9,280.5c-22.3-32.8-54.7-49.5-96.4-49.5s-74.1,16.6-96.4,49.5c-16.6,24.4-27.2,57.7-31.4,98.7
			c-0.8,7.4,4.6,14.1,12,14.8c7.4,0.8,14.1-4.6,14.8-12c8.5-82.3,42.5-124,101-124s92.5,41.7,101,124c0.7,6.9,6.6,12.1,13.4,12.1
			c0.5,0,0.9,0,1.4-0.1c7.4-0.8,12.8-7.4,12-14.8C368.1,338.1,357.5,304.9,340.9,280.5z"
          />
        </g>
      </g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
    </svg>
  );
};
export const NotificationsIcon = (fill) => {
  return (
    <svg
      width="46"
      height="46"
      viewBox="0 0 46 46"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <circle cx="23" cy="23" r="23" fill="#F0F3F9" />
      <path
        d="M29.2395 19.9752L28.4943 20.0598L29.2395 19.9752ZM29.6867 23.9153L30.4319 23.8307V23.8307L29.6867 23.9153ZM16.3133 23.9153L15.5681 23.8307L15.5681 23.8307L16.3133 23.9153ZM16.7605 19.9752L17.5057 20.0598L16.7605 19.9752ZM15.4478 25.8721L14.8767 25.386H14.8767L15.4478 25.8721ZM30.5522 25.8721L29.9811 26.3583L30.5522 25.8721ZM25.2699 15.3737H24.5199C24.5199 15.6942 24.7237 15.9794 25.027 16.0832L25.2699 15.3737ZM20.7301 15.3737L20.973 16.0832C21.2763 15.9794 21.4801 15.6942 21.4801 15.3737H20.7301ZM26.7023 31.2632C26.8477 30.8753 26.6511 30.4431 26.2632 30.2977C25.8753 30.1523 25.4431 30.3489 25.2977 30.7368L26.7023 31.2632ZM20.7023 30.7368C20.5569 30.3489 20.1247 30.1523 19.7368 30.2977C19.3489 30.4431 19.1523 30.8753 19.2977 31.2632L20.7023 30.7368ZM28.7772 28.25H17.2228V29.75H28.7772V28.25ZM28.4943 20.0598L28.9415 23.9998L30.4319 23.8307L29.9848 19.8906L28.4943 20.0598ZM17.0585 23.9998L17.5057 20.0598L16.0152 19.8906L15.5681 23.8307L17.0585 23.9998ZM16.0189 26.3583C16.5962 25.6801 16.9603 24.8652 17.0585 23.9998L15.5681 23.8307C15.5052 24.3846 15.2707 24.9231 14.8767 25.386L16.0189 26.3583ZM28.9415 23.9998C29.0397 24.8652 29.4038 25.6801 29.9811 26.3583L31.1233 25.386C30.7293 24.9231 30.4948 24.3846 30.4319 23.8307L28.9415 23.9998ZM17.2228 28.25C16.5678 28.25 16.1044 27.926 15.8906 27.5492C15.6841 27.1854 15.6871 26.748 16.0189 26.3583L14.8767 25.386C14.1114 26.285 14.0878 27.4116 14.586 28.2895C15.0768 29.1544 16.0495 29.75 17.2228 29.75V28.25ZM28.7772 29.75C29.9505 29.75 30.9232 29.1544 31.414 28.2895C31.9122 27.4116 31.8886 26.285 31.1233 25.386L29.9811 26.3583C30.3129 26.748 30.3159 27.1854 30.1094 27.5492C29.8956 27.926 29.4322 28.25 28.7772 28.25V29.75ZM26.0199 15.3737V15.2699H24.5199V15.3737H26.0199ZM29.9848 19.8906C29.7055 17.4303 27.8806 15.4748 25.5129 14.6641L25.027 16.0832C26.9441 16.7396 28.2913 18.271 28.4943 20.0598L29.9848 19.8906ZM21.4801 15.3737V15.2699H19.9801V15.3737H21.4801ZM17.5057 20.0598C17.7087 18.271 19.0559 16.7396 20.973 16.0832L20.4871 14.6641C18.1194 15.4748 16.2945 17.4303 16.0152 19.8906L17.5057 20.0598ZM23 13.75C23.8394 13.75 24.5199 14.4305 24.5199 15.2699H26.0199C26.0199 13.6021 24.6679 12.25 23 12.25V13.75ZM23 12.25C21.3321 12.25 19.9801 13.6021 19.9801 15.2699H21.4801C21.4801 14.4305 22.1606 13.75 23 13.75V12.25ZM25.2977 30.7368C24.975 31.5979 24.0846 32.25 23 32.25V33.75C24.6855 33.75 26.1516 32.7325 26.7023 31.2632L25.2977 30.7368ZM23 32.25C21.9154 32.25 21.025 31.5979 20.7023 30.7368L19.2977 31.2632C19.8484 32.7325 21.3145 33.75 23 33.75V32.25Z"
        fill="#8E8E93"
      />
      <circle cx="28" cy="19" r="4" fill="#1977F2" />
    </svg>
  );
};

export const ProfileDropDownIcon = (fill) => {
  return (
    <svg
      width="14"
      height="9"
      viewBox="0 0 14 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.2601 1.84708L7.06314 7.15234L1.86614 1.84708"
        stroke="#8E8E93"
        strokeWidth="2.02105"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const SearchFilterIcons = (fill) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.40013 15.4941H3.14929C2.80429 15.4941 2.52429 15.2141 2.52429 14.8691C2.52429 14.5241 2.80429 14.2441 3.14929 14.2441H8.40013C8.74513 14.2441 9.02513 14.5241 9.02513 14.8691C9.02513 15.2141 8.74513 15.4941 8.40013 15.4941Z"
        fill="#ECEBF6"
        fill-opacity="0.62"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.9924 7.41699H10.7424C10.3974 7.41699 10.1174 7.13699 10.1174 6.79199C10.1174 6.44699 10.3974 6.16699 10.7424 6.16699H15.9924C16.3374 6.16699 16.6174 6.44699 16.6174 6.79199C16.6174 7.13699 16.3374 7.41699 15.9924 7.41699Z"
        fill="#ECEBF6"
        fill-opacity="0.62"
      />
      <mask
        id="mask0_428_989"
        style="mask-type:luminance"
        maskUnits="userSpaceOnUse"
        x="2"
        y="4"
        width="6"
        height="6">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.5 4.16602H7.68817V9.32568H2.5V4.16602Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_428_989)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.09404 5.41602C4.35321 5.41602 3.74988 6.01268 3.74988 6.74685C3.74988 7.48018 4.35321 8.07602 5.09404 8.07602C5.83571 8.07602 6.43821 7.48018 6.43821 6.74685C6.43821 6.01268 5.83571 5.41602 5.09404 5.41602ZM5.09404 9.32602C3.66404 9.32602 2.49988 8.16935 2.49988 6.74685C2.49988 5.32435 3.66404 4.16602 5.09404 4.16602C6.52488 4.16602 7.68821 5.32435 7.68821 6.74685C7.68821 8.16935 6.52488 9.32602 5.09404 9.32602Z"
          fill="#ECEBF6"
          fill-opacity="0.62"
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.4898 13.5057C13.7481 13.5057 13.1448 14.1024 13.1448 14.8357C13.1448 15.5699 13.7481 16.1657 14.4898 16.1657C15.2306 16.1657 15.8331 15.5699 15.8331 14.8357C15.8331 14.1024 15.2306 13.5057 14.4898 13.5057ZM14.4898 17.4159C13.0589 17.4159 11.8948 16.2584 11.8948 14.8359C11.8948 13.4134 13.0589 12.2559 14.4898 12.2559C15.9198 12.2559 17.0831 13.4134 17.0831 14.8359C17.0831 16.2584 15.9198 17.4159 14.4898 17.4159Z"
        fill="#ECEBF6"
        fill-opacity="0.62"
      />
    </svg>
  );
};

export const FallBackIcon = (fill) => {
  return (
    <svg
      width="381"
      height="206"
      viewBox="0 0 381 206"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M99.5164 204.863C53.8926 205.605 32.9724 204.788 49.5157 203.008C66.1331 201.228 49.4415 201.005 23.6993 201.228C-2.04293 201.45 -13.3932 199.225 24.6637 196.925C62.7206 194.625 202.263 192.251 186.239 195.219C170.215 198.186 158.419 198.854 168.138 199.966C177.856 201.079 162.277 203.824 99.5164 204.863Z"
        fill="#E8F1FE"
      />
      <path
        d="M289.504 190.248C242.174 190.693 220.512 192.103 237.723 193.512C255.008 194.922 247.219 195.441 220.438 195.886C193.657 196.331 172.589 199.15 212.055 200.634C251.596 202.044 396.257 200.782 379.565 198.038C362.873 195.293 350.633 194.922 360.648 193.438C370.811 192.029 354.639 189.655 289.504 190.248Z"
        fill="#E8F1FE"
      />
      <path
        d="M176.372 195.516H37.7945C36.6076 195.516 35.569 194.552 35.569 193.29V187.652C35.569 186.465 36.5334 185.427 37.7945 185.427H176.446C177.633 185.427 178.672 186.391 178.672 187.652V193.29C178.598 194.552 177.633 195.516 176.372 195.516Z"
        fill="white"
      />
      <path
        d="M179.191 195.516H92.7657C91.5788 195.516 90.5402 194.552 90.5402 193.29V187.652C90.5402 186.465 91.5046 185.427 92.7657 185.427H179.191C180.378 185.427 181.417 186.391 181.417 187.652V193.29C181.417 194.552 180.452 195.516 179.191 195.516Z"
        fill="#E6E7E8"
      />
      <path
        d="M140.912 185.575H40.0201C38.388 185.575 36.9043 184.537 36.3108 182.979L13.3135 119.402C12.3491 116.806 14.2779 114.135 17.0227 114.135H117.914C119.546 114.135 121.03 115.174 121.624 116.732L144.621 180.308C145.511 182.831 143.657 185.575 140.912 185.575Z"
        fill="#E6E7E8"
      />
      <path
        d="M134.754 181.941H42.5424C40.9103 181.941 39.4266 180.902 38.8332 179.344L18.5065 123.038C17.5421 120.441 19.4709 117.771 22.2157 117.771H114.502C116.134 117.771 117.618 118.809 118.211 120.367L138.538 176.673C139.428 179.196 137.499 181.941 134.754 181.941Z"
        fill="white"
      />
      <path
        d="M51.593 191.956H41.9489C41.578 191.956 41.2812 191.659 41.2812 191.288V189.656C41.2812 189.285 41.578 188.988 41.9489 188.988H51.593C51.9639 188.988 52.2606 189.285 52.2606 189.656V191.288C52.2606 191.659 51.9639 191.956 51.593 191.956Z"
        fill="#E6E7E8"
      />
      <path
        d="M65.0205 191.956H55.3764C55.0055 191.956 54.7087 191.659 54.7087 191.288V189.656C54.7087 189.285 55.0055 188.988 55.3764 188.988H65.0205C65.3914 188.988 65.6881 189.285 65.6881 189.656V191.288C65.7623 191.659 65.3914 191.956 65.0205 191.956Z"
        fill="#E6E7E8"
      />
      <path
        d="M242.916 109.386C241.803 110.796 240.32 112.428 238.762 114.208C230.601 123.11 217.545 135.351 210.794 138.986C202.708 143.289 195.586 144.327 192.248 139.579C188.909 134.832 188.687 131.122 193.806 125.41C198.924 119.698 218.138 94.2524 228.302 85.9437C235.498 80.083 244.474 82.7537 247.812 88.5401C251.225 94.1782 249.815 100.855 242.916 109.386Z"
        fill="#B8D5FB"
      />
      <path
        d="M238.762 114.134C230.601 123.036 217.545 135.276 210.794 138.911C202.708 143.214 195.586 144.253 192.248 139.505C204.785 138.466 228.524 111.611 228.524 111.611L238.762 114.134Z"
        fill="#95C0F9"
      />
      <path
        d="M208.568 136.094C201.669 149.299 189.503 141.064 180.007 131.791C170.511 122.518 159.903 107.755 158.345 103.378C157.826 101.969 157.677 100.485 157.826 99.0013C158.048 95.9597 159.606 93.2891 161.758 93.2891C164.948 93.2891 189.948 110.055 198.257 116.954C204.414 122.073 209.013 126.45 209.607 131.049C209.755 132.756 209.459 134.388 208.568 136.094Z"
        fill="#B8D5FB"
      />
      <path
        d="M208.568 136.094C201.669 149.299 189.503 141.064 180.007 131.791C170.511 122.518 159.903 107.755 158.345 103.378C157.826 101.969 157.677 100.485 157.826 99.0015C159.532 99.224 161.312 100.188 163.093 102.117C163.093 102.117 184.384 130.011 195.141 135.5C198.924 137.429 204.266 135.055 209.533 131.049C209.755 132.756 209.459 134.388 208.568 136.094Z"
        fill="#95C0F9"
      />
      <path
        d="M164.28 103.007C163.538 106.642 161.906 115.396 158.79 116.806C155.6 118.215 149.962 116.657 148.553 113.022C147.143 109.313 150.778 104.491 154.339 99.8914C157.9 95.292 160.126 93.289 162.129 93.4373C164.131 93.5857 165.022 99.0754 164.28 103.007Z"
        fill="#B8D5FB"
      />
      <path
        d="M148.924 110.945C148.924 111.316 148.553 109.09 148.924 111.316C149.294 113.541 152.855 113.319 153.375 112.354C155.081 109.313 161.461 96.0334 160.274 94.9949C159.087 93.9563 149.146 104.713 148.924 110.945Z"
        fill="#E8F1FE"
      />
      <path
        d="M316.508 167.918C316.508 167.918 334.757 166.36 343.437 151.894C352.116 137.428 338.17 103.526 337.354 90.0981C336.538 76.6706 347.591 66.1363 359.164 76.6706C370.737 87.2049 370.44 121.923 366.286 138.17C362.057 154.491 349.52 166.954 332.828 172.814C321.033 176.969 314.282 174.372 314.282 174.372L316.508 167.918Z"
        fill="#B8D5FB"
      />
      <path
        d="M263.985 175.187C259.979 188.169 249.37 194.92 238.094 196.107C226.818 197.294 206.788 198.184 204.859 196.923C203.969 196.33 203.524 195.069 203.672 193.659C203.82 191.953 204.785 189.95 206.639 188.392C210.052 185.499 222.293 185.499 222.293 185.499C222.293 185.499 220.067 185.202 216.877 182.754C213.687 180.232 206.194 175.261 212.129 156.863C218.064 138.465 235.497 134.237 252.857 140.32C256.863 141.73 259.83 144.92 261.833 148.926C265.839 156.567 266.358 167.546 263.985 175.187Z"
        fill="#B8D5FB"
      />
      <path
        d="M233.42 185.276C233.42 185.944 232.827 186.389 232.233 186.389C232.085 186.389 214.948 186.092 209.681 187.576C205.304 188.837 205.082 191.582 205.007 193.288V193.659C204.859 195.143 205.675 195.291 205.824 195.291C206.491 195.366 206.936 195.959 206.862 196.627C206.788 197.22 206.269 197.665 205.675 197.665C205.601 197.665 205.601 197.665 205.527 197.665C204.191 197.517 202.337 196.256 202.634 193.437V193.066C202.782 191.211 203.079 186.983 209.013 185.276C211.165 184.683 215.097 184.312 219.028 184.164C217.1 183.57 215.393 182.902 214.206 182.086C207.975 177.709 206.862 170.662 210.423 157.828C213.094 148.258 218.509 142.991 223.999 140.023C224.592 139.727 225.334 139.949 225.557 140.617C225.779 141.136 225.557 141.73 225.037 142.026C220.067 144.697 215.097 149.593 212.649 158.421C208.865 172.146 211.091 176.968 215.542 180.158C219.696 183.051 232.159 184.015 232.308 184.015C232.901 184.089 233.42 184.609 233.42 185.276Z"
        fill="#B8D5FB"
      />
      <path
        d="M263.985 175.187C259.979 188.17 249.37 194.92 238.094 196.107C226.818 197.294 206.788 198.185 204.859 196.923C203.969 196.33 203.524 195.069 203.672 193.659C207.826 194.104 223.183 195.069 242.026 185.87C259.904 177.19 261.833 156.567 261.907 148.852C265.839 156.567 266.358 167.546 263.985 175.187Z"
        fill="#B8D5FB"
      />
      <path
        d="M212.055 163.095C212.055 163.095 217.841 172.072 226.15 177.19C234.459 182.309 239.058 183.348 239.058 183.348C239.058 183.348 231.566 185.054 224.37 184.906C217.174 184.757 211.758 180.677 209.904 174.149C207.975 167.546 212.055 163.095 212.055 163.095Z"
        fill="#B8D5FB"
      />
      <path
        d="M265.988 193.958C264.875 193.958 263.836 193.958 262.798 193.958C260.201 193.958 257.605 193.883 255.157 193.735C251.076 193.512 247.293 193.067 243.732 192.474C221.996 188.616 210.275 177.043 211.165 152.191C211.907 132.013 218.064 107.829 222.589 92.5466C223.034 91.0629 223.405 89.7276 223.851 88.4664C225.334 83.5702 226.595 80.0094 227.115 78.3031C227.337 77.6354 227.486 77.2645 227.486 77.2645L289.949 66.3593L290.543 66.2109C290.543 66.2109 292.768 71.3297 296.033 79.4159C296.626 80.8254 297.219 82.3091 297.813 83.867C298.481 85.5732 299.223 87.3537 299.964 89.2825C305.231 102.487 311.76 119.55 317.027 135.203C318.585 139.802 319.994 144.254 321.255 148.408C322.442 152.34 323.481 156.123 324.297 159.536C329.787 181.717 301.893 193.587 265.988 193.958Z"
        fill="#E8F1FE"
      />
      <path
        d="M291.136 185.871H277.486C273.184 185.871 266.062 186.094 263.91 190.174C263.243 191.361 262.946 192.696 262.872 193.958C260.275 193.958 257.679 193.883 255.231 193.735L254.637 190.619C254.637 190.619 254.637 190.619 257.605 186.836C260.498 183.201 269.919 163.764 270.439 162.8C270.216 163.467 266.729 173.26 272.59 179.491C278.302 185.723 289.875 185.871 291.136 185.871Z"
        fill="#B8D5FB"
      />
      <path
        d="M247.441 190.397C247.367 190.471 247.293 190.471 247.219 190.545C246.18 191.213 244.993 191.88 243.732 192.474C221.922 188.616 210.275 177.043 211.165 152.191C211.758 136.464 215.616 118.363 219.399 103.897C220.512 99.7425 221.551 95.959 222.589 92.5465C225.334 89.8759 229.266 87.502 234.607 87.502C246.996 87.502 254.044 90.9145 259.088 129.862C263.985 168.438 257.605 183.497 247.441 190.397Z"
        fill="white"
      />
      <path
        opacity="0.5"
        d="M247.441 190.397C247.367 190.471 247.293 190.471 247.219 190.545C246.18 191.213 244.993 191.88 243.732 192.474C221.922 188.616 210.275 177.043 211.165 152.191C211.758 136.464 215.616 118.363 219.399 103.897C218.658 114.58 217.916 142.251 228.524 164.803C234.904 178.379 241.877 186.094 247.441 190.397Z"
        fill="#E8F1FE"
      />
      <path
        d="M296.107 79.4158C291.507 82.6058 282.234 88.0213 269.845 91.2112C265.097 92.3982 259.904 93.2884 254.341 93.5851C236.314 94.5495 227.634 90.9145 223.851 88.318C225.334 83.4218 226.595 79.8609 227.115 78.1547C230.75 79.3416 240.023 81.493 255.453 79.8609C258.198 79.5642 260.943 79.0449 263.614 78.3772C274.741 75.5582 284.534 69.7718 289.949 66.1367L290.543 66.0625C290.617 66.1367 292.768 71.3296 296.107 79.4158Z"
        fill="#E6E7E8"
      />
      <path
        d="M269.845 91.2109C265.097 92.3978 259.904 93.288 254.341 93.5848C236.314 94.5492 227.634 90.9141 223.851 88.3177C225.334 83.4214 226.595 79.8606 227.115 78.1543C230.75 79.3413 240.023 81.4926 255.453 79.8605C258.198 79.5638 260.943 79.0445 263.614 78.3768L269.845 91.2109Z"
        fill="#B3B3B6"
      />
      <path
        d="M241.581 96.9976C241.581 97.4427 241.581 97.8878 241.507 98.3329C240.913 102.932 237.278 106.493 232.827 106.493C228.005 106.493 224.073 102.191 224.073 96.9234C224.073 94.4753 224.889 92.2498 226.373 90.5435C228.005 88.6147 230.305 87.4277 232.827 87.4277C237.649 87.5019 241.581 91.7305 241.581 96.9976Z"
        fill="#E6E7E8"
      />
      <path
        d="M241.581 96.9971C241.581 97.4423 241.581 97.8874 241.507 98.3325C239.949 100.261 237.575 101.448 235.052 101.448C230.23 101.448 226.299 97.1455 226.299 91.9526C226.299 91.5075 226.299 91.0623 226.373 90.6172C228.005 88.6884 230.305 87.5015 232.827 87.5015C237.649 87.5015 241.581 91.73 241.581 96.9971Z"
        fill="#E6E7E8"
      />
      <path
        d="M232.233 99.0747C235.306 99.0747 237.797 97.879 237.797 96.4041C237.797 94.9291 235.306 93.7334 232.233 93.7334C229.161 93.7334 226.67 94.9291 226.67 96.4041C226.67 97.879 229.161 99.0747 232.233 99.0747Z"
        fill="#090A14"
      />
      <path
        d="M230.898 105.381V98.333C230.898 97.7395 231.417 97.2202 232.085 97.2202C232.753 97.2202 233.272 97.7395 233.272 98.333V105.381C233.272 105.974 232.753 106.493 232.085 106.493C231.417 106.493 230.898 105.974 230.898 105.381Z"
        fill="#090A14"
      />
      <path
        d="M317.101 135.202C315.172 137.057 312.576 138.615 309.238 138.17C300.41 136.983 301.374 133.199 299.668 124.371C297.961 115.543 285.573 116.582 286.611 99.2226C287.279 87.6497 293.733 84.6081 297.961 83.9404C298.629 85.6467 299.371 87.4271 300.113 89.356C305.306 102.487 311.834 119.549 317.101 135.202Z"
        fill="#B8D5FB"
      />
      <path
        d="M323.333 175.187C319.327 188.169 308.718 194.92 297.442 196.107C286.166 197.294 266.136 198.184 264.207 196.923C263.317 196.33 262.872 195.069 263.02 193.659C263.169 191.953 264.133 189.95 265.988 188.392C269.4 185.499 281.641 185.499 281.641 185.499C281.641 185.499 279.415 185.202 276.225 182.754C273.035 180.232 265.543 175.261 271.477 156.863C277.412 138.465 294.846 134.237 312.205 140.32C316.211 141.73 319.178 144.92 321.181 148.926C325.187 156.567 325.707 167.546 323.333 175.187Z"
        fill="#E8F1FE"
      />
      <path
        d="M292.768 185.276C292.768 185.944 292.175 186.389 291.581 186.389C291.433 186.389 274.296 186.092 269.029 187.576C264.652 188.837 264.43 191.582 264.356 193.288V193.659C264.207 195.143 265.023 195.291 265.172 195.291C265.839 195.366 266.284 195.959 266.21 196.627C266.136 197.22 265.617 197.665 265.023 197.665C264.949 197.665 264.949 197.665 264.875 197.665C263.54 197.517 261.685 196.256 261.982 193.437V193.066C262.13 191.211 262.427 186.983 268.362 185.276C270.513 184.683 274.445 184.312 278.377 184.164C276.448 183.57 274.741 182.902 273.555 182.086C267.323 177.709 266.21 170.662 269.771 157.828C272.442 148.258 277.857 142.991 283.347 140.023C283.94 139.727 284.682 139.949 284.905 140.617C285.127 141.136 284.905 141.73 284.386 142.026C279.415 144.697 274.445 149.593 271.997 158.421C268.213 172.146 270.439 176.968 274.89 180.158C279.044 183.051 291.507 184.015 291.656 184.015C292.249 184.089 292.768 184.609 292.768 185.276Z"
        fill="#B8D5FB"
      />
      <path
        d="M323.333 175.187C319.327 188.17 308.718 194.92 297.442 196.107C286.166 197.294 266.136 198.185 264.207 196.923C263.317 196.33 262.872 195.069 263.02 193.659C267.175 194.104 282.531 195.069 301.374 185.87C319.253 177.19 321.181 156.567 321.256 148.852C325.187 156.567 325.707 167.546 323.333 175.187Z"
        fill="#B8D5FB"
      />
      <path
        d="M271.403 163.095C271.403 163.095 277.19 172.072 285.498 177.19C293.807 182.309 298.406 183.348 298.406 183.348C298.406 183.348 290.914 185.054 283.718 184.906C276.522 184.757 271.106 180.677 269.252 174.149C267.323 167.546 271.403 163.095 271.403 163.095Z"
        fill="#B8D5FB"
      />
      <path
        d="M255.75 190.62C255.75 190.62 254.563 192.178 255.528 194.552C256.492 196.925 256.344 199.448 253.97 200.635C252.783 201.228 248.628 201.302 244.4 201.228C243.955 201.228 243.435 201.228 242.99 201.154C240.468 201.08 238.094 200.931 236.314 200.783C235.646 200.709 235.052 200.709 234.607 200.635C234.533 200.635 234.533 200.635 234.459 200.635C231.417 200.338 228.821 198.335 228.821 195.516C228.821 194.848 228.969 194.106 229.34 193.365C231.121 189.433 238.613 186.243 238.613 186.243C238.613 186.243 245.142 176.005 249.667 155.679C254.192 135.352 253.97 126.301 254.786 116.435C255.305 110.5 255.379 99.6689 267.026 98.4819C273.777 97.8143 277.931 99.8173 280.231 103.378C281.937 105.975 282.753 109.387 282.976 113.245C283.569 122.518 282.012 130.827 275.483 150.708C268.955 170.664 255.75 190.62 255.75 190.62Z"
        fill="#E8F1FE"
      />
      <path
        d="M255.75 190.62C255.75 190.62 254.563 192.178 255.528 194.552C256.492 196.926 256.344 199.448 253.97 200.635C252.783 201.229 248.628 201.303 244.4 201.229C243.955 201.229 243.435 201.229 242.99 201.154C240.468 201.08 238.094 200.932 236.314 200.783C235.646 200.709 235.052 200.709 234.607 200.635C234.533 200.635 234.533 200.635 234.459 200.635C231.417 200.338 228.821 198.335 228.821 195.516C230.23 195.368 231.788 195.368 233.272 195.516C237.055 195.887 249.073 197.519 250.26 194.923C251.447 192.326 249.667 189.211 249.667 189.211C249.667 189.211 258.347 173.854 266.433 154.121C274.074 135.426 279.712 106.494 280.231 103.453C281.937 106.049 282.753 109.462 282.976 113.319C283.569 122.592 282.012 130.901 275.483 150.783C268.955 170.664 255.75 190.62 255.75 190.62Z"
        fill="#B8D5FB"
      />
      <path
        d="M251.818 202.266C248.109 202.266 234.682 201.896 232.456 201.45C230.972 201.154 229.637 200.115 228.747 198.706C227.782 197.222 227.56 195.441 228.005 193.661C228.895 190.249 236.239 186.539 237.723 185.797C238.317 185.501 238.984 185.723 239.281 186.317C239.578 186.91 239.355 187.578 238.762 187.875C235.498 189.432 230.75 192.474 230.305 194.18C230.008 195.293 230.23 196.406 230.824 197.37C231.343 198.261 232.159 198.854 232.975 199.077C235.127 199.522 251.225 199.967 252.56 199.818C253.302 199.744 254.712 199.151 254.934 197.222C255.157 195.516 254.044 192.919 253.599 192.103C253.376 191.732 253.45 191.213 253.673 190.842C253.673 190.768 256.863 186.465 261.907 178.082C267.249 169.254 273.851 152.192 279.118 133.423C284.46 114.654 279.86 104.787 279.786 104.713C279.489 104.12 279.712 103.452 280.305 103.155C280.899 102.859 281.566 103.081 281.863 103.675C282.086 104.12 286.908 114.357 281.344 134.09C276.003 153.008 269.326 170.367 263.836 179.343C259.756 186.02 256.937 190.174 255.898 191.658C256.418 192.845 257.456 195.367 257.16 197.519C256.789 200.56 254.563 202.044 252.634 202.192C252.56 202.267 252.263 202.266 251.818 202.266Z"
        fill="#B8D5FB"
      />
      <path
        d="M239.133 190.396C239.133 190.396 236.462 192.029 235.794 194.848C235.275 197.37 236.091 200.189 236.314 200.857C235.646 200.782 235.052 200.782 234.607 200.708C234.236 199.447 233.717 196.925 234.236 194.477C234.978 191.064 238.168 189.135 238.317 189.061C238.688 188.839 239.207 188.987 239.429 189.358C239.578 189.655 239.504 190.174 239.133 190.396Z"
        fill="#B8D5FB"
      />
      <path
        d="M246.774 190.768C246.699 190.842 244.697 192.251 244.251 195.516C243.806 198.928 244.474 200.486 244.474 200.486C244.548 200.708 244.548 201.005 244.4 201.228C243.955 201.228 243.435 201.228 242.99 201.154C242.916 200.931 242.1 199.151 242.619 195.293C243.139 191.213 245.735 189.507 245.809 189.432C246.18 189.21 246.625 189.284 246.922 189.655C247.219 190.026 247.07 190.545 246.774 190.768Z"
        fill="#B8D5FB"
      />
      <path
        d="M290.617 66.1356C290.617 66.1356 288.911 67.6935 285.721 69.9933C282.531 72.293 268.139 80.5275 249.073 81.121C233.124 81.6403 209.978 81.492 202.559 65.3938C201.076 62.2038 200.26 58.3462 200.186 53.8209C199.815 26.2241 232.901 15.6898 246.329 15.3189C260.721 14.948 275.78 16.58 281.789 26.4466C284.756 31.3429 287.353 42.7674 288.688 50.8535C290.024 59.0881 290.617 66.1356 290.617 66.1356Z"
        fill="#E8F1FE"
      />
      <path
        d="M245.883 17.1741C243.955 19.3996 241.432 20.7349 238.91 21.551C232.159 23.7023 224.889 22.1445 224.889 22.1445C224.889 22.1445 224.147 13.539 224.221 8.93951C224.296 7.08489 224.444 5.74956 224.815 4.78516C225.408 3.30146 226.299 2.70798 227.708 2.55961C230.082 2.33705 245.883 17.1741 245.883 17.1741Z"
        fill="#E8F1FE"
      />
      <path
        d="M237.352 19.9192C231.343 19.1032 226.966 20.5869 226.966 20.5869C226.966 20.5869 225.631 13.5393 225.705 9.90424C225.705 8.42054 225.928 7.38195 226.224 6.56592C227.263 7.38195 229.266 9.1624 231.937 12.3524C234.533 15.6165 236.388 18.4355 237.352 19.9192Z"
        fill="white"
      />
      <path
        d="M284.386 33.198L276.448 30.0822L258.495 23.0346C258.495 23.0346 260.572 8.49437 263.91 3.74653C263.91 3.67235 263.985 3.67235 263.985 3.59816C267.397 -1.00131 270.587 -0.630381 271.997 1.59517C273.406 3.82072 279.193 16.7289 281.566 23.7765C284.015 30.9724 284.386 33.198 284.386 33.198Z"
        fill="#E8F1FE"
      />
      <path
        d="M274.741 20.3636L261.759 19.5476C261.759 19.5476 263.243 9.68099 265.691 5.89755C266.655 5.67499 267.62 5.82336 268.51 6.71358C270.661 8.93913 273.629 16.2834 274.519 19.4734C274.593 19.696 274.667 20.0669 274.741 20.3636Z"
        fill="white"
      />
      <path
        d="M264.43 49.4442C263.91 49.4442 263.391 49.0733 263.317 48.554C263.169 47.8863 263.54 47.2928 264.207 47.1445L275.928 44.3254C276.596 44.1771 277.19 44.548 277.338 45.2157C277.486 45.8833 277.115 46.4768 276.448 46.6252L264.727 49.4442C264.652 49.37 264.504 49.4442 264.43 49.4442Z"
        fill="#B8D5FB"
      />
      <path
        d="M275.854 59.6821C275.78 59.6821 275.706 59.6821 275.632 59.6821L264.801 57.5307C264.133 57.3824 263.762 56.7889 263.836 56.1212C263.985 55.4536 264.578 55.0826 265.246 55.1568L276.077 57.3082C276.744 57.4566 277.115 58.05 277.041 58.7177C276.893 59.3112 276.448 59.6821 275.854 59.6821Z"
        fill="#B8D5FB"
      />
      <path
        d="M203.153 56.4918C202.559 56.4918 202.04 56.0466 201.966 55.4532C201.892 54.7855 202.337 54.192 203.005 54.1178L213.761 52.8567C214.429 52.7825 215.022 53.2276 215.097 53.8953C215.171 54.563 214.726 55.1564 214.058 55.2306L203.301 56.4918C203.227 56.4918 203.227 56.4918 203.153 56.4918Z"
        fill="#B8D5FB"
      />
      <path
        d="M213.836 47.7384C213.687 47.7384 213.613 47.7384 213.465 47.6642L202.856 44.0291C202.263 43.8066 201.892 43.1389 202.114 42.5454C202.337 41.9519 203.005 41.581 203.598 41.8036L214.206 45.4386C214.8 45.6612 215.171 46.3288 214.948 46.9223C214.726 47.4416 214.281 47.7384 213.836 47.7384Z"
        fill="#B8D5FB"
      />
      <path
        d="M266.136 20.8827H258.643C257.976 20.8827 257.456 20.3634 257.456 19.6957C257.456 19.0281 257.976 18.5088 258.643 18.5088H266.136C266.804 18.5088 267.323 19.0281 267.323 19.6957C267.323 20.3634 266.804 20.8827 266.136 20.8827Z"
        fill="#B8D5FB"
      />
      <path
        d="M239.726 20.8827H232.233C231.566 20.8827 231.046 20.3634 231.046 19.6957C231.046 19.0281 231.566 18.5088 232.233 18.5088H239.726C240.394 18.5088 240.913 19.0281 240.913 19.6957C240.839 20.3634 240.32 20.8827 239.726 20.8827Z"
        fill="#B8D5FB"
      />
      <path
        d="M290.617 66.1356C290.617 66.1356 288.911 67.6935 285.721 69.9933C282.531 72.293 268.139 80.5275 249.073 81.121C233.124 81.6403 209.978 81.4919 202.559 65.3938C204.637 67.2484 215.022 74.8895 244.993 73.5541C273.332 72.2188 285.424 56.269 288.688 50.8535C290.024 59.0881 290.617 66.1356 290.617 66.1356Z"
        fill="#B8D5FB"
      />
      <path
        d="M233.865 61.6855C233.643 61.6855 233.42 61.6113 233.272 61.5371C232.679 61.1662 232.53 60.4985 232.901 59.9051L235.127 56.1958C235.794 55.083 236.981 54.4154 238.242 54.3412C239.504 54.267 240.765 54.8605 241.507 55.8991L244.326 59.7567C244.697 60.276 244.622 61.0178 244.029 61.3888C243.51 61.7597 242.768 61.6855 242.397 61.092L239.578 57.2344C239.281 56.7893 238.836 56.6409 238.317 56.6409C237.797 56.6409 237.352 56.9377 237.13 57.3828L234.904 61.092C234.682 61.463 234.311 61.6855 233.865 61.6855Z"
        fill="#090A14"
      />
      <path
        d="M218.658 33.2723C218.658 36.759 220.29 39.578 222.218 39.578C224.221 39.578 225.779 36.759 225.779 33.2723C225.779 31.9369 225.557 30.6758 225.112 29.6372L219.103 30.1565C218.806 31.0467 218.658 32.1595 218.658 33.2723Z"
        fill="#090A14"
      />
      <path
        d="M226.966 31.4179H219.474C218.806 31.4179 218.287 30.8986 218.287 30.2309C218.287 29.5632 218.806 29.0439 219.474 29.0439H226.966C227.634 29.0439 228.153 29.5632 228.153 30.2309C228.153 30.8986 227.56 31.4179 226.966 31.4179Z"
        fill="#090A14"
      />
      <path
        d="M259.014 34.9796C259.014 38.9114 257.308 42.1013 255.157 42.1013C253.005 42.1013 251.299 38.9114 251.299 34.9796C251.299 33.4217 251.596 32.0122 252.041 30.8252L258.569 31.4187C258.792 32.4573 259.014 33.7184 259.014 34.9796Z"
        fill="#090A14"
      />
      <path
        d="M259.534 32.6801H252.041C251.373 32.6801 250.854 32.1608 250.854 31.4931C250.854 30.8255 251.373 30.3062 252.041 30.3062H259.534C260.201 30.3062 260.721 30.8255 260.721 31.4931C260.721 32.1608 260.127 32.6801 259.534 32.6801Z"
        fill="#090A14"
      />
    </svg>
  );
};
export const FallBackSmallIcon = (fill) => {
  return (
    <svg
      width="310"
      height="210"
      viewBox="0 0 381 206"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M99.5164 204.863C53.8926 205.605 32.9724 204.788 49.5157 203.008C66.1331 201.228 49.4415 201.005 23.6993 201.228C-2.04293 201.45 -13.3932 199.225 24.6637 196.925C62.7206 194.625 202.263 192.251 186.239 195.219C170.215 198.186 158.419 198.854 168.138 199.966C177.856 201.079 162.277 203.824 99.5164 204.863Z"
        fill="#E8F1FE"
      />
      <path
        d="M289.504 190.248C242.174 190.693 220.512 192.103 237.723 193.512C255.008 194.922 247.219 195.441 220.438 195.886C193.657 196.331 172.589 199.15 212.055 200.634C251.596 202.044 396.257 200.782 379.565 198.038C362.873 195.293 350.633 194.922 360.648 193.438C370.811 192.029 354.639 189.655 289.504 190.248Z"
        fill="#E8F1FE"
      />
      <path
        d="M176.372 195.516H37.7945C36.6076 195.516 35.569 194.552 35.569 193.29V187.652C35.569 186.465 36.5334 185.427 37.7945 185.427H176.446C177.633 185.427 178.672 186.391 178.672 187.652V193.29C178.598 194.552 177.633 195.516 176.372 195.516Z"
        fill="white"
      />
      <path
        d="M179.191 195.516H92.7657C91.5788 195.516 90.5402 194.552 90.5402 193.29V187.652C90.5402 186.465 91.5046 185.427 92.7657 185.427H179.191C180.378 185.427 181.417 186.391 181.417 187.652V193.29C181.417 194.552 180.452 195.516 179.191 195.516Z"
        fill="#E6E7E8"
      />
      <path
        d="M140.912 185.575H40.0201C38.388 185.575 36.9043 184.537 36.3108 182.979L13.3135 119.402C12.3491 116.806 14.2779 114.135 17.0227 114.135H117.914C119.546 114.135 121.03 115.174 121.624 116.732L144.621 180.308C145.511 182.831 143.657 185.575 140.912 185.575Z"
        fill="#E6E7E8"
      />
      <path
        d="M134.754 181.941H42.5424C40.9103 181.941 39.4266 180.902 38.8332 179.344L18.5065 123.038C17.5421 120.441 19.4709 117.771 22.2157 117.771H114.502C116.134 117.771 117.618 118.809 118.211 120.367L138.538 176.673C139.428 179.196 137.499 181.941 134.754 181.941Z"
        fill="white"
      />
      <path
        d="M51.593 191.956H41.9489C41.578 191.956 41.2812 191.659 41.2812 191.288V189.656C41.2812 189.285 41.578 188.988 41.9489 188.988H51.593C51.9639 188.988 52.2606 189.285 52.2606 189.656V191.288C52.2606 191.659 51.9639 191.956 51.593 191.956Z"
        fill="#E6E7E8"
      />
      <path
        d="M65.0205 191.956H55.3764C55.0055 191.956 54.7087 191.659 54.7087 191.288V189.656C54.7087 189.285 55.0055 188.988 55.3764 188.988H65.0205C65.3914 188.988 65.6881 189.285 65.6881 189.656V191.288C65.7623 191.659 65.3914 191.956 65.0205 191.956Z"
        fill="#E6E7E8"
      />
      <path
        d="M242.916 109.386C241.803 110.796 240.32 112.428 238.762 114.208C230.601 123.11 217.545 135.351 210.794 138.986C202.708 143.289 195.586 144.327 192.248 139.579C188.909 134.832 188.687 131.122 193.806 125.41C198.924 119.698 218.138 94.2524 228.302 85.9437C235.498 80.083 244.474 82.7537 247.812 88.5401C251.225 94.1782 249.815 100.855 242.916 109.386Z"
        fill="#B8D5FB"
      />
      <path
        d="M238.762 114.134C230.601 123.036 217.545 135.276 210.794 138.911C202.708 143.214 195.586 144.253 192.248 139.505C204.785 138.466 228.524 111.611 228.524 111.611L238.762 114.134Z"
        fill="#95C0F9"
      />
      <path
        d="M208.568 136.094C201.669 149.299 189.503 141.064 180.007 131.791C170.511 122.518 159.903 107.755 158.345 103.378C157.826 101.969 157.677 100.485 157.826 99.0013C158.048 95.9597 159.606 93.2891 161.758 93.2891C164.948 93.2891 189.948 110.055 198.257 116.954C204.414 122.073 209.013 126.45 209.607 131.049C209.755 132.756 209.459 134.388 208.568 136.094Z"
        fill="#B8D5FB"
      />
      <path
        d="M208.568 136.094C201.669 149.299 189.503 141.064 180.007 131.791C170.511 122.518 159.903 107.755 158.345 103.378C157.826 101.969 157.677 100.485 157.826 99.0015C159.532 99.224 161.312 100.188 163.093 102.117C163.093 102.117 184.384 130.011 195.141 135.5C198.924 137.429 204.266 135.055 209.533 131.049C209.755 132.756 209.459 134.388 208.568 136.094Z"
        fill="#95C0F9"
      />
      <path
        d="M164.28 103.007C163.538 106.642 161.906 115.396 158.79 116.806C155.6 118.215 149.962 116.657 148.553 113.022C147.143 109.313 150.778 104.491 154.339 99.8914C157.9 95.292 160.126 93.289 162.129 93.4373C164.131 93.5857 165.022 99.0754 164.28 103.007Z"
        fill="#B8D5FB"
      />
      <path
        d="M148.924 110.945C148.924 111.316 148.553 109.09 148.924 111.316C149.294 113.541 152.855 113.319 153.375 112.354C155.081 109.313 161.461 96.0334 160.274 94.9949C159.087 93.9563 149.146 104.713 148.924 110.945Z"
        fill="#E8F1FE"
      />
      <path
        d="M316.508 167.918C316.508 167.918 334.757 166.36 343.437 151.894C352.116 137.428 338.17 103.526 337.354 90.0981C336.538 76.6706 347.591 66.1363 359.164 76.6706C370.737 87.2049 370.44 121.923 366.286 138.17C362.057 154.491 349.52 166.954 332.828 172.814C321.033 176.969 314.282 174.372 314.282 174.372L316.508 167.918Z"
        fill="#B8D5FB"
      />
      <path
        d="M263.985 175.187C259.979 188.169 249.37 194.92 238.094 196.107C226.818 197.294 206.788 198.184 204.859 196.923C203.969 196.33 203.524 195.069 203.672 193.659C203.82 191.953 204.785 189.95 206.639 188.392C210.052 185.499 222.293 185.499 222.293 185.499C222.293 185.499 220.067 185.202 216.877 182.754C213.687 180.232 206.194 175.261 212.129 156.863C218.064 138.465 235.497 134.237 252.857 140.32C256.863 141.73 259.83 144.92 261.833 148.926C265.839 156.567 266.358 167.546 263.985 175.187Z"
        fill="#B8D5FB"
      />
      <path
        d="M233.42 185.276C233.42 185.944 232.827 186.389 232.233 186.389C232.085 186.389 214.948 186.092 209.681 187.576C205.304 188.837 205.082 191.582 205.007 193.288V193.659C204.859 195.143 205.675 195.291 205.824 195.291C206.491 195.366 206.936 195.959 206.862 196.627C206.788 197.22 206.269 197.665 205.675 197.665C205.601 197.665 205.601 197.665 205.527 197.665C204.191 197.517 202.337 196.256 202.634 193.437V193.066C202.782 191.211 203.079 186.983 209.013 185.276C211.165 184.683 215.097 184.312 219.028 184.164C217.1 183.57 215.393 182.902 214.206 182.086C207.975 177.709 206.862 170.662 210.423 157.828C213.094 148.258 218.509 142.991 223.999 140.023C224.592 139.727 225.334 139.949 225.557 140.617C225.779 141.136 225.557 141.73 225.037 142.026C220.067 144.697 215.097 149.593 212.649 158.421C208.865 172.146 211.091 176.968 215.542 180.158C219.696 183.051 232.159 184.015 232.308 184.015C232.901 184.089 233.42 184.609 233.42 185.276Z"
        fill="#B8D5FB"
      />
      <path
        d="M263.985 175.187C259.979 188.17 249.37 194.92 238.094 196.107C226.818 197.294 206.788 198.185 204.859 196.923C203.969 196.33 203.524 195.069 203.672 193.659C207.826 194.104 223.183 195.069 242.026 185.87C259.904 177.19 261.833 156.567 261.907 148.852C265.839 156.567 266.358 167.546 263.985 175.187Z"
        fill="#B8D5FB"
      />
      <path
        d="M212.055 163.095C212.055 163.095 217.841 172.072 226.15 177.19C234.459 182.309 239.058 183.348 239.058 183.348C239.058 183.348 231.566 185.054 224.37 184.906C217.174 184.757 211.758 180.677 209.904 174.149C207.975 167.546 212.055 163.095 212.055 163.095Z"
        fill="#B8D5FB"
      />
      <path
        d="M265.988 193.958C264.875 193.958 263.836 193.958 262.798 193.958C260.201 193.958 257.605 193.883 255.157 193.735C251.076 193.512 247.293 193.067 243.732 192.474C221.996 188.616 210.275 177.043 211.165 152.191C211.907 132.013 218.064 107.829 222.589 92.5466C223.034 91.0629 223.405 89.7276 223.851 88.4664C225.334 83.5702 226.595 80.0094 227.115 78.3031C227.337 77.6354 227.486 77.2645 227.486 77.2645L289.949 66.3593L290.543 66.2109C290.543 66.2109 292.768 71.3297 296.033 79.4159C296.626 80.8254 297.219 82.3091 297.813 83.867C298.481 85.5732 299.223 87.3537 299.964 89.2825C305.231 102.487 311.76 119.55 317.027 135.203C318.585 139.802 319.994 144.254 321.255 148.408C322.442 152.34 323.481 156.123 324.297 159.536C329.787 181.717 301.893 193.587 265.988 193.958Z"
        fill="#E8F1FE"
      />
      <path
        d="M291.136 185.871H277.486C273.184 185.871 266.062 186.094 263.91 190.174C263.243 191.361 262.946 192.696 262.872 193.958C260.275 193.958 257.679 193.883 255.231 193.735L254.637 190.619C254.637 190.619 254.637 190.619 257.605 186.836C260.498 183.201 269.919 163.764 270.439 162.8C270.216 163.467 266.729 173.26 272.59 179.491C278.302 185.723 289.875 185.871 291.136 185.871Z"
        fill="#B8D5FB"
      />
      <path
        d="M247.441 190.397C247.367 190.471 247.293 190.471 247.219 190.545C246.18 191.213 244.993 191.88 243.732 192.474C221.922 188.616 210.275 177.043 211.165 152.191C211.758 136.464 215.616 118.363 219.399 103.897C220.512 99.7425 221.551 95.959 222.589 92.5465C225.334 89.8759 229.266 87.502 234.607 87.502C246.996 87.502 254.044 90.9145 259.088 129.862C263.985 168.438 257.605 183.497 247.441 190.397Z"
        fill="white"
      />
      <path
        opacity="0.5"
        d="M247.441 190.397C247.367 190.471 247.293 190.471 247.219 190.545C246.18 191.213 244.993 191.88 243.732 192.474C221.922 188.616 210.275 177.043 211.165 152.191C211.758 136.464 215.616 118.363 219.399 103.897C218.658 114.58 217.916 142.251 228.524 164.803C234.904 178.379 241.877 186.094 247.441 190.397Z"
        fill="#E8F1FE"
      />
      <path
        d="M296.107 79.4158C291.507 82.6058 282.234 88.0213 269.845 91.2112C265.097 92.3982 259.904 93.2884 254.341 93.5851C236.314 94.5495 227.634 90.9145 223.851 88.318C225.334 83.4218 226.595 79.8609 227.115 78.1547C230.75 79.3416 240.023 81.493 255.453 79.8609C258.198 79.5642 260.943 79.0449 263.614 78.3772C274.741 75.5582 284.534 69.7718 289.949 66.1367L290.543 66.0625C290.617 66.1367 292.768 71.3296 296.107 79.4158Z"
        fill="#E6E7E8"
      />
      <path
        d="M269.845 91.2109C265.097 92.3978 259.904 93.288 254.341 93.5848C236.314 94.5492 227.634 90.9141 223.851 88.3177C225.334 83.4214 226.595 79.8606 227.115 78.1543C230.75 79.3413 240.023 81.4926 255.453 79.8605C258.198 79.5638 260.943 79.0445 263.614 78.3768L269.845 91.2109Z"
        fill="#B3B3B6"
      />
      <path
        d="M241.581 96.9976C241.581 97.4427 241.581 97.8878 241.507 98.3329C240.913 102.932 237.278 106.493 232.827 106.493C228.005 106.493 224.073 102.191 224.073 96.9234C224.073 94.4753 224.889 92.2498 226.373 90.5435C228.005 88.6147 230.305 87.4277 232.827 87.4277C237.649 87.5019 241.581 91.7305 241.581 96.9976Z"
        fill="#E6E7E8"
      />
      <path
        d="M241.581 96.9971C241.581 97.4423 241.581 97.8874 241.507 98.3325C239.949 100.261 237.575 101.448 235.052 101.448C230.23 101.448 226.299 97.1455 226.299 91.9526C226.299 91.5075 226.299 91.0623 226.373 90.6172C228.005 88.6884 230.305 87.5015 232.827 87.5015C237.649 87.5015 241.581 91.73 241.581 96.9971Z"
        fill="#E6E7E8"
      />
      <path
        d="M232.233 99.0747C235.306 99.0747 237.797 97.879 237.797 96.4041C237.797 94.9291 235.306 93.7334 232.233 93.7334C229.161 93.7334 226.67 94.9291 226.67 96.4041C226.67 97.879 229.161 99.0747 232.233 99.0747Z"
        fill="#090A14"
      />
      <path
        d="M230.898 105.381V98.333C230.898 97.7395 231.417 97.2202 232.085 97.2202C232.753 97.2202 233.272 97.7395 233.272 98.333V105.381C233.272 105.974 232.753 106.493 232.085 106.493C231.417 106.493 230.898 105.974 230.898 105.381Z"
        fill="#090A14"
      />
      <path
        d="M317.101 135.202C315.172 137.057 312.576 138.615 309.238 138.17C300.41 136.983 301.374 133.199 299.668 124.371C297.961 115.543 285.573 116.582 286.611 99.2226C287.279 87.6497 293.733 84.6081 297.961 83.9404C298.629 85.6467 299.371 87.4271 300.113 89.356C305.306 102.487 311.834 119.549 317.101 135.202Z"
        fill="#B8D5FB"
      />
      <path
        d="M323.333 175.187C319.327 188.169 308.718 194.92 297.442 196.107C286.166 197.294 266.136 198.184 264.207 196.923C263.317 196.33 262.872 195.069 263.02 193.659C263.169 191.953 264.133 189.95 265.988 188.392C269.4 185.499 281.641 185.499 281.641 185.499C281.641 185.499 279.415 185.202 276.225 182.754C273.035 180.232 265.543 175.261 271.477 156.863C277.412 138.465 294.846 134.237 312.205 140.32C316.211 141.73 319.178 144.92 321.181 148.926C325.187 156.567 325.707 167.546 323.333 175.187Z"
        fill="#E8F1FE"
      />
      <path
        d="M292.768 185.276C292.768 185.944 292.175 186.389 291.581 186.389C291.433 186.389 274.296 186.092 269.029 187.576C264.652 188.837 264.43 191.582 264.356 193.288V193.659C264.207 195.143 265.023 195.291 265.172 195.291C265.839 195.366 266.284 195.959 266.21 196.627C266.136 197.22 265.617 197.665 265.023 197.665C264.949 197.665 264.949 197.665 264.875 197.665C263.54 197.517 261.685 196.256 261.982 193.437V193.066C262.13 191.211 262.427 186.983 268.362 185.276C270.513 184.683 274.445 184.312 278.377 184.164C276.448 183.57 274.741 182.902 273.555 182.086C267.323 177.709 266.21 170.662 269.771 157.828C272.442 148.258 277.857 142.991 283.347 140.023C283.94 139.727 284.682 139.949 284.905 140.617C285.127 141.136 284.905 141.73 284.386 142.026C279.415 144.697 274.445 149.593 271.997 158.421C268.213 172.146 270.439 176.968 274.89 180.158C279.044 183.051 291.507 184.015 291.656 184.015C292.249 184.089 292.768 184.609 292.768 185.276Z"
        fill="#B8D5FB"
      />
      <path
        d="M323.333 175.187C319.327 188.17 308.718 194.92 297.442 196.107C286.166 197.294 266.136 198.185 264.207 196.923C263.317 196.33 262.872 195.069 263.02 193.659C267.175 194.104 282.531 195.069 301.374 185.87C319.253 177.19 321.181 156.567 321.256 148.852C325.187 156.567 325.707 167.546 323.333 175.187Z"
        fill="#B8D5FB"
      />
      <path
        d="M271.403 163.095C271.403 163.095 277.19 172.072 285.498 177.19C293.807 182.309 298.406 183.348 298.406 183.348C298.406 183.348 290.914 185.054 283.718 184.906C276.522 184.757 271.106 180.677 269.252 174.149C267.323 167.546 271.403 163.095 271.403 163.095Z"
        fill="#B8D5FB"
      />
      <path
        d="M255.75 190.62C255.75 190.62 254.563 192.178 255.528 194.552C256.492 196.925 256.344 199.448 253.97 200.635C252.783 201.228 248.628 201.302 244.4 201.228C243.955 201.228 243.435 201.228 242.99 201.154C240.468 201.08 238.094 200.931 236.314 200.783C235.646 200.709 235.052 200.709 234.607 200.635C234.533 200.635 234.533 200.635 234.459 200.635C231.417 200.338 228.821 198.335 228.821 195.516C228.821 194.848 228.969 194.106 229.34 193.365C231.121 189.433 238.613 186.243 238.613 186.243C238.613 186.243 245.142 176.005 249.667 155.679C254.192 135.352 253.97 126.301 254.786 116.435C255.305 110.5 255.379 99.6689 267.026 98.4819C273.777 97.8143 277.931 99.8173 280.231 103.378C281.937 105.975 282.753 109.387 282.976 113.245C283.569 122.518 282.012 130.827 275.483 150.708C268.955 170.664 255.75 190.62 255.75 190.62Z"
        fill="#E8F1FE"
      />
      <path
        d="M255.75 190.62C255.75 190.62 254.563 192.178 255.528 194.552C256.492 196.926 256.344 199.448 253.97 200.635C252.783 201.229 248.628 201.303 244.4 201.229C243.955 201.229 243.435 201.229 242.99 201.154C240.468 201.08 238.094 200.932 236.314 200.783C235.646 200.709 235.052 200.709 234.607 200.635C234.533 200.635 234.533 200.635 234.459 200.635C231.417 200.338 228.821 198.335 228.821 195.516C230.23 195.368 231.788 195.368 233.272 195.516C237.055 195.887 249.073 197.519 250.26 194.923C251.447 192.326 249.667 189.211 249.667 189.211C249.667 189.211 258.347 173.854 266.433 154.121C274.074 135.426 279.712 106.494 280.231 103.453C281.937 106.049 282.753 109.462 282.976 113.319C283.569 122.592 282.012 130.901 275.483 150.783C268.955 170.664 255.75 190.62 255.75 190.62Z"
        fill="#B8D5FB"
      />
      <path
        d="M251.818 202.266C248.109 202.266 234.682 201.896 232.456 201.45C230.972 201.154 229.637 200.115 228.747 198.706C227.782 197.222 227.56 195.441 228.005 193.661C228.895 190.249 236.239 186.539 237.723 185.797C238.317 185.501 238.984 185.723 239.281 186.317C239.578 186.91 239.355 187.578 238.762 187.875C235.498 189.432 230.75 192.474 230.305 194.18C230.008 195.293 230.23 196.406 230.824 197.37C231.343 198.261 232.159 198.854 232.975 199.077C235.127 199.522 251.225 199.967 252.56 199.818C253.302 199.744 254.712 199.151 254.934 197.222C255.157 195.516 254.044 192.919 253.599 192.103C253.376 191.732 253.45 191.213 253.673 190.842C253.673 190.768 256.863 186.465 261.907 178.082C267.249 169.254 273.851 152.192 279.118 133.423C284.46 114.654 279.86 104.787 279.786 104.713C279.489 104.12 279.712 103.452 280.305 103.155C280.899 102.859 281.566 103.081 281.863 103.675C282.086 104.12 286.908 114.357 281.344 134.09C276.003 153.008 269.326 170.367 263.836 179.343C259.756 186.02 256.937 190.174 255.898 191.658C256.418 192.845 257.456 195.367 257.16 197.519C256.789 200.56 254.563 202.044 252.634 202.192C252.56 202.267 252.263 202.266 251.818 202.266Z"
        fill="#B8D5FB"
      />
      <path
        d="M239.133 190.396C239.133 190.396 236.462 192.029 235.794 194.848C235.275 197.37 236.091 200.189 236.314 200.857C235.646 200.782 235.052 200.782 234.607 200.708C234.236 199.447 233.717 196.925 234.236 194.477C234.978 191.064 238.168 189.135 238.317 189.061C238.688 188.839 239.207 188.987 239.429 189.358C239.578 189.655 239.504 190.174 239.133 190.396Z"
        fill="#B8D5FB"
      />
      <path
        d="M246.774 190.768C246.699 190.842 244.697 192.251 244.251 195.516C243.806 198.928 244.474 200.486 244.474 200.486C244.548 200.708 244.548 201.005 244.4 201.228C243.955 201.228 243.435 201.228 242.99 201.154C242.916 200.931 242.1 199.151 242.619 195.293C243.139 191.213 245.735 189.507 245.809 189.432C246.18 189.21 246.625 189.284 246.922 189.655C247.219 190.026 247.07 190.545 246.774 190.768Z"
        fill="#B8D5FB"
      />
      <path
        d="M290.617 66.1356C290.617 66.1356 288.911 67.6935 285.721 69.9933C282.531 72.293 268.139 80.5275 249.073 81.121C233.124 81.6403 209.978 81.492 202.559 65.3938C201.076 62.2038 200.26 58.3462 200.186 53.8209C199.815 26.2241 232.901 15.6898 246.329 15.3189C260.721 14.948 275.78 16.58 281.789 26.4466C284.756 31.3429 287.353 42.7674 288.688 50.8535C290.024 59.0881 290.617 66.1356 290.617 66.1356Z"
        fill="#E8F1FE"
      />
      <path
        d="M245.883 17.1741C243.955 19.3996 241.432 20.7349 238.91 21.551C232.159 23.7023 224.889 22.1445 224.889 22.1445C224.889 22.1445 224.147 13.539 224.221 8.93951C224.296 7.08489 224.444 5.74956 224.815 4.78516C225.408 3.30146 226.299 2.70798 227.708 2.55961C230.082 2.33705 245.883 17.1741 245.883 17.1741Z"
        fill="#E8F1FE"
      />
      <path
        d="M237.352 19.9192C231.343 19.1032 226.966 20.5869 226.966 20.5869C226.966 20.5869 225.631 13.5393 225.705 9.90424C225.705 8.42054 225.928 7.38195 226.224 6.56592C227.263 7.38195 229.266 9.1624 231.937 12.3524C234.533 15.6165 236.388 18.4355 237.352 19.9192Z"
        fill="white"
      />
      <path
        d="M284.386 33.198L276.448 30.0822L258.495 23.0346C258.495 23.0346 260.572 8.49437 263.91 3.74653C263.91 3.67235 263.985 3.67235 263.985 3.59816C267.397 -1.00131 270.587 -0.630381 271.997 1.59517C273.406 3.82072 279.193 16.7289 281.566 23.7765C284.015 30.9724 284.386 33.198 284.386 33.198Z"
        fill="#E8F1FE"
      />
      <path
        d="M274.741 20.3636L261.759 19.5476C261.759 19.5476 263.243 9.68099 265.691 5.89755C266.655 5.67499 267.62 5.82336 268.51 6.71358C270.661 8.93913 273.629 16.2834 274.519 19.4734C274.593 19.696 274.667 20.0669 274.741 20.3636Z"
        fill="white"
      />
      <path
        d="M264.43 49.4442C263.91 49.4442 263.391 49.0733 263.317 48.554C263.169 47.8863 263.54 47.2928 264.207 47.1445L275.928 44.3254C276.596 44.1771 277.19 44.548 277.338 45.2157C277.486 45.8833 277.115 46.4768 276.448 46.6252L264.727 49.4442C264.652 49.37 264.504 49.4442 264.43 49.4442Z"
        fill="#B8D5FB"
      />
      <path
        d="M275.854 59.6821C275.78 59.6821 275.706 59.6821 275.632 59.6821L264.801 57.5307C264.133 57.3824 263.762 56.7889 263.836 56.1212C263.985 55.4536 264.578 55.0826 265.246 55.1568L276.077 57.3082C276.744 57.4566 277.115 58.05 277.041 58.7177C276.893 59.3112 276.448 59.6821 275.854 59.6821Z"
        fill="#B8D5FB"
      />
      <path
        d="M203.153 56.4918C202.559 56.4918 202.04 56.0466 201.966 55.4532C201.892 54.7855 202.337 54.192 203.005 54.1178L213.761 52.8567C214.429 52.7825 215.022 53.2276 215.097 53.8953C215.171 54.563 214.726 55.1564 214.058 55.2306L203.301 56.4918C203.227 56.4918 203.227 56.4918 203.153 56.4918Z"
        fill="#B8D5FB"
      />
      <path
        d="M213.836 47.7384C213.687 47.7384 213.613 47.7384 213.465 47.6642L202.856 44.0291C202.263 43.8066 201.892 43.1389 202.114 42.5454C202.337 41.9519 203.005 41.581 203.598 41.8036L214.206 45.4386C214.8 45.6612 215.171 46.3288 214.948 46.9223C214.726 47.4416 214.281 47.7384 213.836 47.7384Z"
        fill="#B8D5FB"
      />
      <path
        d="M266.136 20.8827H258.643C257.976 20.8827 257.456 20.3634 257.456 19.6957C257.456 19.0281 257.976 18.5088 258.643 18.5088H266.136C266.804 18.5088 267.323 19.0281 267.323 19.6957C267.323 20.3634 266.804 20.8827 266.136 20.8827Z"
        fill="#B8D5FB"
      />
      <path
        d="M239.726 20.8827H232.233C231.566 20.8827 231.046 20.3634 231.046 19.6957C231.046 19.0281 231.566 18.5088 232.233 18.5088H239.726C240.394 18.5088 240.913 19.0281 240.913 19.6957C240.839 20.3634 240.32 20.8827 239.726 20.8827Z"
        fill="#B8D5FB"
      />
      <path
        d="M290.617 66.1356C290.617 66.1356 288.911 67.6935 285.721 69.9933C282.531 72.293 268.139 80.5275 249.073 81.121C233.124 81.6403 209.978 81.4919 202.559 65.3938C204.637 67.2484 215.022 74.8895 244.993 73.5541C273.332 72.2188 285.424 56.269 288.688 50.8535C290.024 59.0881 290.617 66.1356 290.617 66.1356Z"
        fill="#B8D5FB"
      />
      <path
        d="M233.865 61.6855C233.643 61.6855 233.42 61.6113 233.272 61.5371C232.679 61.1662 232.53 60.4985 232.901 59.9051L235.127 56.1958C235.794 55.083 236.981 54.4154 238.242 54.3412C239.504 54.267 240.765 54.8605 241.507 55.8991L244.326 59.7567C244.697 60.276 244.622 61.0178 244.029 61.3888C243.51 61.7597 242.768 61.6855 242.397 61.092L239.578 57.2344C239.281 56.7893 238.836 56.6409 238.317 56.6409C237.797 56.6409 237.352 56.9377 237.13 57.3828L234.904 61.092C234.682 61.463 234.311 61.6855 233.865 61.6855Z"
        fill="#090A14"
      />
      <path
        d="M218.658 33.2723C218.658 36.759 220.29 39.578 222.218 39.578C224.221 39.578 225.779 36.759 225.779 33.2723C225.779 31.9369 225.557 30.6758 225.112 29.6372L219.103 30.1565C218.806 31.0467 218.658 32.1595 218.658 33.2723Z"
        fill="#090A14"
      />
      <path
        d="M226.966 31.4179H219.474C218.806 31.4179 218.287 30.8986 218.287 30.2309C218.287 29.5632 218.806 29.0439 219.474 29.0439H226.966C227.634 29.0439 228.153 29.5632 228.153 30.2309C228.153 30.8986 227.56 31.4179 226.966 31.4179Z"
        fill="#090A14"
      />
      <path
        d="M259.014 34.9796C259.014 38.9114 257.308 42.1013 255.157 42.1013C253.005 42.1013 251.299 38.9114 251.299 34.9796C251.299 33.4217 251.596 32.0122 252.041 30.8252L258.569 31.4187C258.792 32.4573 259.014 33.7184 259.014 34.9796Z"
        fill="#090A14"
      />
      <path
        d="M259.534 32.6801H252.041C251.373 32.6801 250.854 32.1608 250.854 31.4931C250.854 30.8255 251.373 30.3062 252.041 30.3062H259.534C260.201 30.3062 260.721 30.8255 260.721 31.4931C260.721 32.1608 260.127 32.6801 259.534 32.6801Z"
        fill="#090A14"
      />
    </svg>
  );
};

export const FallBackMessageIcon = (fill) => {
  return (
    <svg
      width="381"
      height="150"
      viewBox="0 0 381 206"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M99.5164 204.863C53.8926 205.605 32.9724 204.788 49.5157 203.008C66.1331 201.228 49.4415 201.005 23.6993 201.228C-2.04293 201.45 -13.3932 199.225 24.6637 196.925C62.7206 194.625 202.263 192.251 186.239 195.219C170.215 198.186 158.419 198.854 168.138 199.966C177.856 201.079 162.277 203.824 99.5164 204.863Z"
        fill="#E8F1FE"
      />
      <path
        d="M289.504 190.248C242.174 190.693 220.512 192.103 237.723 193.512C255.008 194.922 247.219 195.441 220.438 195.886C193.657 196.331 172.589 199.15 212.055 200.634C251.596 202.044 396.257 200.782 379.565 198.038C362.873 195.293 350.633 194.922 360.648 193.438C370.811 192.029 354.639 189.655 289.504 190.248Z"
        fill="#E8F1FE"
      />
      <path
        d="M176.372 195.516H37.7945C36.6076 195.516 35.569 194.552 35.569 193.29V187.652C35.569 186.465 36.5334 185.427 37.7945 185.427H176.446C177.633 185.427 178.672 186.391 178.672 187.652V193.29C178.598 194.552 177.633 195.516 176.372 195.516Z"
        fill="white"
      />
      <path
        d="M179.191 195.516H92.7657C91.5788 195.516 90.5402 194.552 90.5402 193.29V187.652C90.5402 186.465 91.5046 185.427 92.7657 185.427H179.191C180.378 185.427 181.417 186.391 181.417 187.652V193.29C181.417 194.552 180.452 195.516 179.191 195.516Z"
        fill="#E6E7E8"
      />
      <path
        d="M140.912 185.575H40.0201C38.388 185.575 36.9043 184.537 36.3108 182.979L13.3135 119.402C12.3491 116.806 14.2779 114.135 17.0227 114.135H117.914C119.546 114.135 121.03 115.174 121.624 116.732L144.621 180.308C145.511 182.831 143.657 185.575 140.912 185.575Z"
        fill="#E6E7E8"
      />
      <path
        d="M134.754 181.941H42.5424C40.9103 181.941 39.4266 180.902 38.8332 179.344L18.5065 123.038C17.5421 120.441 19.4709 117.771 22.2157 117.771H114.502C116.134 117.771 117.618 118.809 118.211 120.367L138.538 176.673C139.428 179.196 137.499 181.941 134.754 181.941Z"
        fill="white"
      />
      <path
        d="M51.593 191.956H41.9489C41.578 191.956 41.2812 191.659 41.2812 191.288V189.656C41.2812 189.285 41.578 188.988 41.9489 188.988H51.593C51.9639 188.988 52.2606 189.285 52.2606 189.656V191.288C52.2606 191.659 51.9639 191.956 51.593 191.956Z"
        fill="#E6E7E8"
      />
      <path
        d="M65.0205 191.956H55.3764C55.0055 191.956 54.7087 191.659 54.7087 191.288V189.656C54.7087 189.285 55.0055 188.988 55.3764 188.988H65.0205C65.3914 188.988 65.6881 189.285 65.6881 189.656V191.288C65.7623 191.659 65.3914 191.956 65.0205 191.956Z"
        fill="#E6E7E8"
      />
      <path
        d="M242.916 109.386C241.803 110.796 240.32 112.428 238.762 114.208C230.601 123.11 217.545 135.351 210.794 138.986C202.708 143.289 195.586 144.327 192.248 139.579C188.909 134.832 188.687 131.122 193.806 125.41C198.924 119.698 218.138 94.2524 228.302 85.9437C235.498 80.083 244.474 82.7537 247.812 88.5401C251.225 94.1782 249.815 100.855 242.916 109.386Z"
        fill="#B8D5FB"
      />
      <path
        d="M238.762 114.134C230.601 123.036 217.545 135.276 210.794 138.911C202.708 143.214 195.586 144.253 192.248 139.505C204.785 138.466 228.524 111.611 228.524 111.611L238.762 114.134Z"
        fill="#95C0F9"
      />
      <path
        d="M208.568 136.094C201.669 149.299 189.503 141.064 180.007 131.791C170.511 122.518 159.903 107.755 158.345 103.378C157.826 101.969 157.677 100.485 157.826 99.0013C158.048 95.9597 159.606 93.2891 161.758 93.2891C164.948 93.2891 189.948 110.055 198.257 116.954C204.414 122.073 209.013 126.45 209.607 131.049C209.755 132.756 209.459 134.388 208.568 136.094Z"
        fill="#B8D5FB"
      />
      <path
        d="M208.568 136.094C201.669 149.299 189.503 141.064 180.007 131.791C170.511 122.518 159.903 107.755 158.345 103.378C157.826 101.969 157.677 100.485 157.826 99.0015C159.532 99.224 161.312 100.188 163.093 102.117C163.093 102.117 184.384 130.011 195.141 135.5C198.924 137.429 204.266 135.055 209.533 131.049C209.755 132.756 209.459 134.388 208.568 136.094Z"
        fill="#95C0F9"
      />
      <path
        d="M164.28 103.007C163.538 106.642 161.906 115.396 158.79 116.806C155.6 118.215 149.962 116.657 148.553 113.022C147.143 109.313 150.778 104.491 154.339 99.8914C157.9 95.292 160.126 93.289 162.129 93.4373C164.131 93.5857 165.022 99.0754 164.28 103.007Z"
        fill="#B8D5FB"
      />
      <path
        d="M148.924 110.945C148.924 111.316 148.553 109.09 148.924 111.316C149.294 113.541 152.855 113.319 153.375 112.354C155.081 109.313 161.461 96.0334 160.274 94.9949C159.087 93.9563 149.146 104.713 148.924 110.945Z"
        fill="#E8F1FE"
      />
      <path
        d="M316.508 167.918C316.508 167.918 334.757 166.36 343.437 151.894C352.116 137.428 338.17 103.526 337.354 90.0981C336.538 76.6706 347.591 66.1363 359.164 76.6706C370.737 87.2049 370.44 121.923 366.286 138.17C362.057 154.491 349.52 166.954 332.828 172.814C321.033 176.969 314.282 174.372 314.282 174.372L316.508 167.918Z"
        fill="#B8D5FB"
      />
      <path
        d="M263.985 175.187C259.979 188.169 249.37 194.92 238.094 196.107C226.818 197.294 206.788 198.184 204.859 196.923C203.969 196.33 203.524 195.069 203.672 193.659C203.82 191.953 204.785 189.95 206.639 188.392C210.052 185.499 222.293 185.499 222.293 185.499C222.293 185.499 220.067 185.202 216.877 182.754C213.687 180.232 206.194 175.261 212.129 156.863C218.064 138.465 235.497 134.237 252.857 140.32C256.863 141.73 259.83 144.92 261.833 148.926C265.839 156.567 266.358 167.546 263.985 175.187Z"
        fill="#B8D5FB"
      />
      <path
        d="M233.42 185.276C233.42 185.944 232.827 186.389 232.233 186.389C232.085 186.389 214.948 186.092 209.681 187.576C205.304 188.837 205.082 191.582 205.007 193.288V193.659C204.859 195.143 205.675 195.291 205.824 195.291C206.491 195.366 206.936 195.959 206.862 196.627C206.788 197.22 206.269 197.665 205.675 197.665C205.601 197.665 205.601 197.665 205.527 197.665C204.191 197.517 202.337 196.256 202.634 193.437V193.066C202.782 191.211 203.079 186.983 209.013 185.276C211.165 184.683 215.097 184.312 219.028 184.164C217.1 183.57 215.393 182.902 214.206 182.086C207.975 177.709 206.862 170.662 210.423 157.828C213.094 148.258 218.509 142.991 223.999 140.023C224.592 139.727 225.334 139.949 225.557 140.617C225.779 141.136 225.557 141.73 225.037 142.026C220.067 144.697 215.097 149.593 212.649 158.421C208.865 172.146 211.091 176.968 215.542 180.158C219.696 183.051 232.159 184.015 232.308 184.015C232.901 184.089 233.42 184.609 233.42 185.276Z"
        fill="#B8D5FB"
      />
      <path
        d="M263.985 175.187C259.979 188.17 249.37 194.92 238.094 196.107C226.818 197.294 206.788 198.185 204.859 196.923C203.969 196.33 203.524 195.069 203.672 193.659C207.826 194.104 223.183 195.069 242.026 185.87C259.904 177.19 261.833 156.567 261.907 148.852C265.839 156.567 266.358 167.546 263.985 175.187Z"
        fill="#B8D5FB"
      />
      <path
        d="M212.055 163.095C212.055 163.095 217.841 172.072 226.15 177.19C234.459 182.309 239.058 183.348 239.058 183.348C239.058 183.348 231.566 185.054 224.37 184.906C217.174 184.757 211.758 180.677 209.904 174.149C207.975 167.546 212.055 163.095 212.055 163.095Z"
        fill="#B8D5FB"
      />
      <path
        d="M265.988 193.958C264.875 193.958 263.836 193.958 262.798 193.958C260.201 193.958 257.605 193.883 255.157 193.735C251.076 193.512 247.293 193.067 243.732 192.474C221.996 188.616 210.275 177.043 211.165 152.191C211.907 132.013 218.064 107.829 222.589 92.5466C223.034 91.0629 223.405 89.7276 223.851 88.4664C225.334 83.5702 226.595 80.0094 227.115 78.3031C227.337 77.6354 227.486 77.2645 227.486 77.2645L289.949 66.3593L290.543 66.2109C290.543 66.2109 292.768 71.3297 296.033 79.4159C296.626 80.8254 297.219 82.3091 297.813 83.867C298.481 85.5732 299.223 87.3537 299.964 89.2825C305.231 102.487 311.76 119.55 317.027 135.203C318.585 139.802 319.994 144.254 321.255 148.408C322.442 152.34 323.481 156.123 324.297 159.536C329.787 181.717 301.893 193.587 265.988 193.958Z"
        fill="#E8F1FE"
      />
      <path
        d="M291.136 185.871H277.486C273.184 185.871 266.062 186.094 263.91 190.174C263.243 191.361 262.946 192.696 262.872 193.958C260.275 193.958 257.679 193.883 255.231 193.735L254.637 190.619C254.637 190.619 254.637 190.619 257.605 186.836C260.498 183.201 269.919 163.764 270.439 162.8C270.216 163.467 266.729 173.26 272.59 179.491C278.302 185.723 289.875 185.871 291.136 185.871Z"
        fill="#B8D5FB"
      />
      <path
        d="M247.441 190.397C247.367 190.471 247.293 190.471 247.219 190.545C246.18 191.213 244.993 191.88 243.732 192.474C221.922 188.616 210.275 177.043 211.165 152.191C211.758 136.464 215.616 118.363 219.399 103.897C220.512 99.7425 221.551 95.959 222.589 92.5465C225.334 89.8759 229.266 87.502 234.607 87.502C246.996 87.502 254.044 90.9145 259.088 129.862C263.985 168.438 257.605 183.497 247.441 190.397Z"
        fill="white"
      />
      <path
        opacity="0.5"
        d="M247.441 190.397C247.367 190.471 247.293 190.471 247.219 190.545C246.18 191.213 244.993 191.88 243.732 192.474C221.922 188.616 210.275 177.043 211.165 152.191C211.758 136.464 215.616 118.363 219.399 103.897C218.658 114.58 217.916 142.251 228.524 164.803C234.904 178.379 241.877 186.094 247.441 190.397Z"
        fill="#E8F1FE"
      />
      <path
        d="M296.107 79.4158C291.507 82.6058 282.234 88.0213 269.845 91.2112C265.097 92.3982 259.904 93.2884 254.341 93.5851C236.314 94.5495 227.634 90.9145 223.851 88.318C225.334 83.4218 226.595 79.8609 227.115 78.1547C230.75 79.3416 240.023 81.493 255.453 79.8609C258.198 79.5642 260.943 79.0449 263.614 78.3772C274.741 75.5582 284.534 69.7718 289.949 66.1367L290.543 66.0625C290.617 66.1367 292.768 71.3296 296.107 79.4158Z"
        fill="#E6E7E8"
      />
      <path
        d="M269.845 91.2109C265.097 92.3978 259.904 93.288 254.341 93.5848C236.314 94.5492 227.634 90.9141 223.851 88.3177C225.334 83.4214 226.595 79.8606 227.115 78.1543C230.75 79.3413 240.023 81.4926 255.453 79.8605C258.198 79.5638 260.943 79.0445 263.614 78.3768L269.845 91.2109Z"
        fill="#B3B3B6"
      />
      <path
        d="M241.581 96.9976C241.581 97.4427 241.581 97.8878 241.507 98.3329C240.913 102.932 237.278 106.493 232.827 106.493C228.005 106.493 224.073 102.191 224.073 96.9234C224.073 94.4753 224.889 92.2498 226.373 90.5435C228.005 88.6147 230.305 87.4277 232.827 87.4277C237.649 87.5019 241.581 91.7305 241.581 96.9976Z"
        fill="#E6E7E8"
      />
      <path
        d="M241.581 96.9971C241.581 97.4423 241.581 97.8874 241.507 98.3325C239.949 100.261 237.575 101.448 235.052 101.448C230.23 101.448 226.299 97.1455 226.299 91.9526C226.299 91.5075 226.299 91.0623 226.373 90.6172C228.005 88.6884 230.305 87.5015 232.827 87.5015C237.649 87.5015 241.581 91.73 241.581 96.9971Z"
        fill="#E6E7E8"
      />
      <path
        d="M232.233 99.0747C235.306 99.0747 237.797 97.879 237.797 96.4041C237.797 94.9291 235.306 93.7334 232.233 93.7334C229.161 93.7334 226.67 94.9291 226.67 96.4041C226.67 97.879 229.161 99.0747 232.233 99.0747Z"
        fill="#090A14"
      />
      <path
        d="M230.898 105.381V98.333C230.898 97.7395 231.417 97.2202 232.085 97.2202C232.753 97.2202 233.272 97.7395 233.272 98.333V105.381C233.272 105.974 232.753 106.493 232.085 106.493C231.417 106.493 230.898 105.974 230.898 105.381Z"
        fill="#090A14"
      />
      <path
        d="M317.101 135.202C315.172 137.057 312.576 138.615 309.238 138.17C300.41 136.983 301.374 133.199 299.668 124.371C297.961 115.543 285.573 116.582 286.611 99.2226C287.279 87.6497 293.733 84.6081 297.961 83.9404C298.629 85.6467 299.371 87.4271 300.113 89.356C305.306 102.487 311.834 119.549 317.101 135.202Z"
        fill="#B8D5FB"
      />
      <path
        d="M323.333 175.187C319.327 188.169 308.718 194.92 297.442 196.107C286.166 197.294 266.136 198.184 264.207 196.923C263.317 196.33 262.872 195.069 263.02 193.659C263.169 191.953 264.133 189.95 265.988 188.392C269.4 185.499 281.641 185.499 281.641 185.499C281.641 185.499 279.415 185.202 276.225 182.754C273.035 180.232 265.543 175.261 271.477 156.863C277.412 138.465 294.846 134.237 312.205 140.32C316.211 141.73 319.178 144.92 321.181 148.926C325.187 156.567 325.707 167.546 323.333 175.187Z"
        fill="#E8F1FE"
      />
      <path
        d="M292.768 185.276C292.768 185.944 292.175 186.389 291.581 186.389C291.433 186.389 274.296 186.092 269.029 187.576C264.652 188.837 264.43 191.582 264.356 193.288V193.659C264.207 195.143 265.023 195.291 265.172 195.291C265.839 195.366 266.284 195.959 266.21 196.627C266.136 197.22 265.617 197.665 265.023 197.665C264.949 197.665 264.949 197.665 264.875 197.665C263.54 197.517 261.685 196.256 261.982 193.437V193.066C262.13 191.211 262.427 186.983 268.362 185.276C270.513 184.683 274.445 184.312 278.377 184.164C276.448 183.57 274.741 182.902 273.555 182.086C267.323 177.709 266.21 170.662 269.771 157.828C272.442 148.258 277.857 142.991 283.347 140.023C283.94 139.727 284.682 139.949 284.905 140.617C285.127 141.136 284.905 141.73 284.386 142.026C279.415 144.697 274.445 149.593 271.997 158.421C268.213 172.146 270.439 176.968 274.89 180.158C279.044 183.051 291.507 184.015 291.656 184.015C292.249 184.089 292.768 184.609 292.768 185.276Z"
        fill="#B8D5FB"
      />
      <path
        d="M323.333 175.187C319.327 188.17 308.718 194.92 297.442 196.107C286.166 197.294 266.136 198.185 264.207 196.923C263.317 196.33 262.872 195.069 263.02 193.659C267.175 194.104 282.531 195.069 301.374 185.87C319.253 177.19 321.181 156.567 321.256 148.852C325.187 156.567 325.707 167.546 323.333 175.187Z"
        fill="#B8D5FB"
      />
      <path
        d="M271.403 163.095C271.403 163.095 277.19 172.072 285.498 177.19C293.807 182.309 298.406 183.348 298.406 183.348C298.406 183.348 290.914 185.054 283.718 184.906C276.522 184.757 271.106 180.677 269.252 174.149C267.323 167.546 271.403 163.095 271.403 163.095Z"
        fill="#B8D5FB"
      />
      <path
        d="M255.75 190.62C255.75 190.62 254.563 192.178 255.528 194.552C256.492 196.925 256.344 199.448 253.97 200.635C252.783 201.228 248.628 201.302 244.4 201.228C243.955 201.228 243.435 201.228 242.99 201.154C240.468 201.08 238.094 200.931 236.314 200.783C235.646 200.709 235.052 200.709 234.607 200.635C234.533 200.635 234.533 200.635 234.459 200.635C231.417 200.338 228.821 198.335 228.821 195.516C228.821 194.848 228.969 194.106 229.34 193.365C231.121 189.433 238.613 186.243 238.613 186.243C238.613 186.243 245.142 176.005 249.667 155.679C254.192 135.352 253.97 126.301 254.786 116.435C255.305 110.5 255.379 99.6689 267.026 98.4819C273.777 97.8143 277.931 99.8173 280.231 103.378C281.937 105.975 282.753 109.387 282.976 113.245C283.569 122.518 282.012 130.827 275.483 150.708C268.955 170.664 255.75 190.62 255.75 190.62Z"
        fill="#E8F1FE"
      />
      <path
        d="M255.75 190.62C255.75 190.62 254.563 192.178 255.528 194.552C256.492 196.926 256.344 199.448 253.97 200.635C252.783 201.229 248.628 201.303 244.4 201.229C243.955 201.229 243.435 201.229 242.99 201.154C240.468 201.08 238.094 200.932 236.314 200.783C235.646 200.709 235.052 200.709 234.607 200.635C234.533 200.635 234.533 200.635 234.459 200.635C231.417 200.338 228.821 198.335 228.821 195.516C230.23 195.368 231.788 195.368 233.272 195.516C237.055 195.887 249.073 197.519 250.26 194.923C251.447 192.326 249.667 189.211 249.667 189.211C249.667 189.211 258.347 173.854 266.433 154.121C274.074 135.426 279.712 106.494 280.231 103.453C281.937 106.049 282.753 109.462 282.976 113.319C283.569 122.592 282.012 130.901 275.483 150.783C268.955 170.664 255.75 190.62 255.75 190.62Z"
        fill="#B8D5FB"
      />
      <path
        d="M251.818 202.266C248.109 202.266 234.682 201.896 232.456 201.45C230.972 201.154 229.637 200.115 228.747 198.706C227.782 197.222 227.56 195.441 228.005 193.661C228.895 190.249 236.239 186.539 237.723 185.797C238.317 185.501 238.984 185.723 239.281 186.317C239.578 186.91 239.355 187.578 238.762 187.875C235.498 189.432 230.75 192.474 230.305 194.18C230.008 195.293 230.23 196.406 230.824 197.37C231.343 198.261 232.159 198.854 232.975 199.077C235.127 199.522 251.225 199.967 252.56 199.818C253.302 199.744 254.712 199.151 254.934 197.222C255.157 195.516 254.044 192.919 253.599 192.103C253.376 191.732 253.45 191.213 253.673 190.842C253.673 190.768 256.863 186.465 261.907 178.082C267.249 169.254 273.851 152.192 279.118 133.423C284.46 114.654 279.86 104.787 279.786 104.713C279.489 104.12 279.712 103.452 280.305 103.155C280.899 102.859 281.566 103.081 281.863 103.675C282.086 104.12 286.908 114.357 281.344 134.09C276.003 153.008 269.326 170.367 263.836 179.343C259.756 186.02 256.937 190.174 255.898 191.658C256.418 192.845 257.456 195.367 257.16 197.519C256.789 200.56 254.563 202.044 252.634 202.192C252.56 202.267 252.263 202.266 251.818 202.266Z"
        fill="#B8D5FB"
      />
      <path
        d="M239.133 190.396C239.133 190.396 236.462 192.029 235.794 194.848C235.275 197.37 236.091 200.189 236.314 200.857C235.646 200.782 235.052 200.782 234.607 200.708C234.236 199.447 233.717 196.925 234.236 194.477C234.978 191.064 238.168 189.135 238.317 189.061C238.688 188.839 239.207 188.987 239.429 189.358C239.578 189.655 239.504 190.174 239.133 190.396Z"
        fill="#B8D5FB"
      />
      <path
        d="M246.774 190.768C246.699 190.842 244.697 192.251 244.251 195.516C243.806 198.928 244.474 200.486 244.474 200.486C244.548 200.708 244.548 201.005 244.4 201.228C243.955 201.228 243.435 201.228 242.99 201.154C242.916 200.931 242.1 199.151 242.619 195.293C243.139 191.213 245.735 189.507 245.809 189.432C246.18 189.21 246.625 189.284 246.922 189.655C247.219 190.026 247.07 190.545 246.774 190.768Z"
        fill="#B8D5FB"
      />
      <path
        d="M290.617 66.1356C290.617 66.1356 288.911 67.6935 285.721 69.9933C282.531 72.293 268.139 80.5275 249.073 81.121C233.124 81.6403 209.978 81.492 202.559 65.3938C201.076 62.2038 200.26 58.3462 200.186 53.8209C199.815 26.2241 232.901 15.6898 246.329 15.3189C260.721 14.948 275.78 16.58 281.789 26.4466C284.756 31.3429 287.353 42.7674 288.688 50.8535C290.024 59.0881 290.617 66.1356 290.617 66.1356Z"
        fill="#E8F1FE"
      />
      <path
        d="M245.883 17.1741C243.955 19.3996 241.432 20.7349 238.91 21.551C232.159 23.7023 224.889 22.1445 224.889 22.1445C224.889 22.1445 224.147 13.539 224.221 8.93951C224.296 7.08489 224.444 5.74956 224.815 4.78516C225.408 3.30146 226.299 2.70798 227.708 2.55961C230.082 2.33705 245.883 17.1741 245.883 17.1741Z"
        fill="#E8F1FE"
      />
      <path
        d="M237.352 19.9192C231.343 19.1032 226.966 20.5869 226.966 20.5869C226.966 20.5869 225.631 13.5393 225.705 9.90424C225.705 8.42054 225.928 7.38195 226.224 6.56592C227.263 7.38195 229.266 9.1624 231.937 12.3524C234.533 15.6165 236.388 18.4355 237.352 19.9192Z"
        fill="white"
      />
      <path
        d="M284.386 33.198L276.448 30.0822L258.495 23.0346C258.495 23.0346 260.572 8.49437 263.91 3.74653C263.91 3.67235 263.985 3.67235 263.985 3.59816C267.397 -1.00131 270.587 -0.630381 271.997 1.59517C273.406 3.82072 279.193 16.7289 281.566 23.7765C284.015 30.9724 284.386 33.198 284.386 33.198Z"
        fill="#E8F1FE"
      />
      <path
        d="M274.741 20.3636L261.759 19.5476C261.759 19.5476 263.243 9.68099 265.691 5.89755C266.655 5.67499 267.62 5.82336 268.51 6.71358C270.661 8.93913 273.629 16.2834 274.519 19.4734C274.593 19.696 274.667 20.0669 274.741 20.3636Z"
        fill="white"
      />
      <path
        d="M264.43 49.4442C263.91 49.4442 263.391 49.0733 263.317 48.554C263.169 47.8863 263.54 47.2928 264.207 47.1445L275.928 44.3254C276.596 44.1771 277.19 44.548 277.338 45.2157C277.486 45.8833 277.115 46.4768 276.448 46.6252L264.727 49.4442C264.652 49.37 264.504 49.4442 264.43 49.4442Z"
        fill="#B8D5FB"
      />
      <path
        d="M275.854 59.6821C275.78 59.6821 275.706 59.6821 275.632 59.6821L264.801 57.5307C264.133 57.3824 263.762 56.7889 263.836 56.1212C263.985 55.4536 264.578 55.0826 265.246 55.1568L276.077 57.3082C276.744 57.4566 277.115 58.05 277.041 58.7177C276.893 59.3112 276.448 59.6821 275.854 59.6821Z"
        fill="#B8D5FB"
      />
      <path
        d="M203.153 56.4918C202.559 56.4918 202.04 56.0466 201.966 55.4532C201.892 54.7855 202.337 54.192 203.005 54.1178L213.761 52.8567C214.429 52.7825 215.022 53.2276 215.097 53.8953C215.171 54.563 214.726 55.1564 214.058 55.2306L203.301 56.4918C203.227 56.4918 203.227 56.4918 203.153 56.4918Z"
        fill="#B8D5FB"
      />
      <path
        d="M213.836 47.7384C213.687 47.7384 213.613 47.7384 213.465 47.6642L202.856 44.0291C202.263 43.8066 201.892 43.1389 202.114 42.5454C202.337 41.9519 203.005 41.581 203.598 41.8036L214.206 45.4386C214.8 45.6612 215.171 46.3288 214.948 46.9223C214.726 47.4416 214.281 47.7384 213.836 47.7384Z"
        fill="#B8D5FB"
      />
      <path
        d="M266.136 20.8827H258.643C257.976 20.8827 257.456 20.3634 257.456 19.6957C257.456 19.0281 257.976 18.5088 258.643 18.5088H266.136C266.804 18.5088 267.323 19.0281 267.323 19.6957C267.323 20.3634 266.804 20.8827 266.136 20.8827Z"
        fill="#B8D5FB"
      />
      <path
        d="M239.726 20.8827H232.233C231.566 20.8827 231.046 20.3634 231.046 19.6957C231.046 19.0281 231.566 18.5088 232.233 18.5088H239.726C240.394 18.5088 240.913 19.0281 240.913 19.6957C240.839 20.3634 240.32 20.8827 239.726 20.8827Z"
        fill="#B8D5FB"
      />
      <path
        d="M290.617 66.1356C290.617 66.1356 288.911 67.6935 285.721 69.9933C282.531 72.293 268.139 80.5275 249.073 81.121C233.124 81.6403 209.978 81.4919 202.559 65.3938C204.637 67.2484 215.022 74.8895 244.993 73.5541C273.332 72.2188 285.424 56.269 288.688 50.8535C290.024 59.0881 290.617 66.1356 290.617 66.1356Z"
        fill="#B8D5FB"
      />
      <path
        d="M233.865 61.6855C233.643 61.6855 233.42 61.6113 233.272 61.5371C232.679 61.1662 232.53 60.4985 232.901 59.9051L235.127 56.1958C235.794 55.083 236.981 54.4154 238.242 54.3412C239.504 54.267 240.765 54.8605 241.507 55.8991L244.326 59.7567C244.697 60.276 244.622 61.0178 244.029 61.3888C243.51 61.7597 242.768 61.6855 242.397 61.092L239.578 57.2344C239.281 56.7893 238.836 56.6409 238.317 56.6409C237.797 56.6409 237.352 56.9377 237.13 57.3828L234.904 61.092C234.682 61.463 234.311 61.6855 233.865 61.6855Z"
        fill="#090A14"
      />
      <path
        d="M218.658 33.2723C218.658 36.759 220.29 39.578 222.218 39.578C224.221 39.578 225.779 36.759 225.779 33.2723C225.779 31.9369 225.557 30.6758 225.112 29.6372L219.103 30.1565C218.806 31.0467 218.658 32.1595 218.658 33.2723Z"
        fill="#090A14"
      />
      <path
        d="M226.966 31.4179H219.474C218.806 31.4179 218.287 30.8986 218.287 30.2309C218.287 29.5632 218.806 29.0439 219.474 29.0439H226.966C227.634 29.0439 228.153 29.5632 228.153 30.2309C228.153 30.8986 227.56 31.4179 226.966 31.4179Z"
        fill="#090A14"
      />
      <path
        d="M259.014 34.9796C259.014 38.9114 257.308 42.1013 255.157 42.1013C253.005 42.1013 251.299 38.9114 251.299 34.9796C251.299 33.4217 251.596 32.0122 252.041 30.8252L258.569 31.4187C258.792 32.4573 259.014 33.7184 259.014 34.9796Z"
        fill="#090A14"
      />
      <path
        d="M259.534 32.6801H252.041C251.373 32.6801 250.854 32.1608 250.854 31.4931C250.854 30.8255 251.373 30.3062 252.041 30.3062H259.534C260.201 30.3062 260.721 30.8255 260.721 31.4931C260.721 32.1608 260.127 32.6801 259.534 32.6801Z"
        fill="#090A14"
      />
    </svg>
  );
};
export const FourSquareIcon = (fill) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <rect width="24" height="24" fill="#1E1E1E" />
      <g id="Campaign List - Grid View - All" clip-path="url(#clip0_0_1)">
        <rect
          width="1512"
          height="982"
          transform="translate(-1270 -160)"
          fill="#161023"
        />
        <g id="Group 1908">
          <g id="Frame 237982">
            <g id="Frame 237983">
              <g id="Frame 237982_2" filter="url(#filter0_b_0_1)">
                <rect
                  x="-8"
                  y="-8"
                  width="40"
                  height="40"
                  rx="6"
                  fill="white"
                />
                <g id="Iconsax/Linear/element3">
                  <path
                    id="Vector"
                    d="M21 8.868V4.782C21 3.513 20.424 3 18.993 3H15.357C13.926 3 13.35 3.513 13.35 4.782V8.859C13.35 10.137 13.926 10.641 15.357 10.641H18.993C20.424 10.65 21 10.137 21 8.868ZM21 18.993V15.357C21 13.926 20.424 13.35 18.993 13.35H15.357C13.926 13.35 13.35 13.926 13.35 15.357V18.993C13.35 20.424 13.926 21 15.357 21H18.993C20.424 21 21 20.424 21 18.993ZM10.65 8.868V4.782C10.65 3.513 10.074 3 8.643 3H5.007C3.576 3 3 3.513 3 4.782V8.859C3 10.137 3.576 10.641 5.007 10.641H8.643C10.074 10.65 10.65 10.137 10.65 8.868ZM10.65 18.993V15.357C10.65 13.926 10.074 13.35 8.643 13.35H5.007C3.576 13.35 3 13.926 3 15.357V18.993C3 20.424 3.576 21 5.007 21H8.643C10.074 21 10.65 20.424 10.65 18.993Z"
                    stroke="#090A14"
                    strokeWidth="1.35"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
      <defs>
        <filter
          id="filter0_b_0_1"
          x="-12"
          y="-12"
          width="48"
          height="48"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB">
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feGaussianBlur in="BackgroundImageFix" stdDeviation="2" />
          <feComposite
            in2="SourceAlpha"
            operator="in"
            result="effect1_backgroundBlur_0_1"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_backgroundBlur_0_1"
            result="shape"
          />
        </filter>
        <clipPath id="clip0_0_1">
          <rect
            width="1512"
            height="982"
            fill="white"
            transform="translate(-1270 -160)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const TwoLineIcon = (fill) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none">
      <path
        d="M19.11 4H4.89C3.54 4 3 4.576 3 6.007V6.943C3 8.374 3.54 8.95 4.89 8.95H19.11C20.46 8.95 21 8.374 21 6.943V6.007C21 4.576 20.46 4 19.11 4Z"
        stroke="white"
        strokeWidth="1.35"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.11 13.9004H4.89C3.54 13.9004 3 14.4764 3 15.9074V16.8434C3 18.2744 3.54 18.8504 4.89 18.8504H19.11C20.46 18.8504 21 18.2744 21 16.8434V15.9074C21 14.4764 20.46 13.9004 19.11 13.9004Z"
        stroke="white"
        strokeWidth="1.35"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const FilterIcon = (fill) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3 7H21M6 12H18M10 17H14"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
};

export const instagramIcon = (fill) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <rect
        x="2"
        y="2"
        width="28"
        height="28"
        rx="6"
        fill="url(#paint0_radial_912_821)"
      />
      <rect
        x="2"
        y="2"
        width="28"
        height="28"
        rx="6"
        fill="url(#paint1_radial_912_821)"
      />
      <rect
        x="2"
        y="2"
        width="28"
        height="28"
        rx="6"
        fill="url(#paint2_radial_912_821)"
      />
      <path
        d="M23 10.5C23 11.3284 22.3284 12 21.5 12C20.6716 12 20 11.3284 20 10.5C20 9.67157 20.6716 9 21.5 9C22.3284 9 23 9.67157 23 10.5Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 21C18.7614 21 21 18.7614 21 16C21 13.2386 18.7614 11 16 11C13.2386 11 11 13.2386 11 16C11 18.7614 13.2386 21 16 21ZM16 19C17.6569 19 19 17.6569 19 16C19 14.3431 17.6569 13 16 13C14.3431 13 13 14.3431 13 16C13 17.6569 14.3431 19 16 19Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 15.6C6 12.2397 6 10.5595 6.65396 9.27606C7.2292 8.14708 8.14708 7.2292 9.27606 6.65396C10.5595 6 12.2397 6 15.6 6H16.4C19.7603 6 21.4405 6 22.7239 6.65396C23.8529 7.2292 24.7708 8.14708 25.346 9.27606C26 10.5595 26 12.2397 26 15.6V16.4C26 19.7603 26 21.4405 25.346 22.7239C24.7708 23.8529 23.8529 24.7708 22.7239 25.346C21.4405 26 19.7603 26 16.4 26H15.6C12.2397 26 10.5595 26 9.27606 25.346C8.14708 24.7708 7.2292 23.8529 6.65396 22.7239C6 21.4405 6 19.7603 6 16.4V15.6ZM15.6 8H16.4C18.1132 8 19.2777 8.00156 20.1779 8.0751C21.0548 8.14674 21.5032 8.27659 21.816 8.43597C22.5686 8.81947 23.1805 9.43139 23.564 10.184C23.7234 10.4968 23.8533 10.9452 23.9249 11.8221C23.9984 12.7223 24 13.8868 24 15.6V16.4C24 18.1132 23.9984 19.2777 23.9249 20.1779C23.8533 21.0548 23.7234 21.5032 23.564 21.816C23.1805 22.5686 22.5686 23.1805 21.816 23.564C21.5032 23.7234 21.0548 23.8533 20.1779 23.9249C19.2777 23.9984 18.1132 24 16.4 24H15.6C13.8868 24 12.7223 23.9984 11.8221 23.9249C10.9452 23.8533 10.4968 23.7234 10.184 23.564C9.43139 23.1805 8.81947 22.5686 8.43597 21.816C8.27659 21.5032 8.14674 21.0548 8.0751 20.1779C8.00156 19.2777 8 18.1132 8 16.4V15.6C8 13.8868 8.00156 12.7223 8.0751 11.8221C8.14674 10.9452 8.27659 10.4968 8.43597 10.184C8.81947 9.43139 9.43139 8.81947 10.184 8.43597C10.4968 8.27659 10.9452 8.14674 11.8221 8.0751C12.7223 8.00156 13.8868 8 15.6 8Z"
        fill="white"
      />
      <defs>
        <radialGradient
          id="paint0_radial_912_821"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(12 23) rotate(-55.3758) scale(25.5196)">
          <stop stop-color="#B13589" />
          <stop offset="0.79309" stop-color="#C62F94" />
          <stop offset="1" stop-color="#8A3AC8" />
        </radialGradient>
        <radialGradient
          id="paint1_radial_912_821"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(11 31) rotate(-65.1363) scale(22.5942)">
          <stop stop-color="#E0E8B7" />
          <stop offset="0.444662" stop-color="#FB8A2E" />
          <stop offset="0.71474" stop-color="#E2425C" />
          <stop offset="1" stop-color="#E2425C" stop-opacity="0" />
        </radialGradient>
        <radialGradient
          id="paint2_radial_912_821"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(0.500002 3) rotate(-8.1301) scale(38.8909 8.31836)">
          <stop offset="0.156701" stop-color="#406ADC" />
          <stop offset="0.467799" stop-color="#6A45BE" />
          <stop offset="1" stop-color="#6A45BE" stop-opacity="0" />
        </radialGradient>
      </defs>
    </svg>
  );
};

export const FacebookIcon = (fill) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <circle cx="16" cy="16" r="14" fill="url(#paint0_linear_949_1581)" />
      <path
        d="M21.2137 20.2816L21.8356 16.3301H17.9452V13.767C17.9452 12.6857 18.4877 11.6311 20.2302 11.6311H22V8.26699C22 8.26699 20.3945 8 18.8603 8C15.6548 8 13.5617 9.89294 13.5617 13.3184V16.3301H10V20.2816H13.5617V29.8345C14.2767 29.944 15.0082 30 15.7534 30C16.4986 30 17.2302 29.944 17.9452 29.8345V20.2816H21.2137Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id="paint0_linear_949_1581"
          x1="16"
          y1="2"
          x2="16"
          y2="29.917"
          gradientUnits="userSpaceOnUse">
          <stop stop-color="#18ACFE" />
          <stop offset="1" stop-color="#0163E0" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const youtubeIcon = (fill) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2.24451 9.94111C2.37304 7.96233 3.96395 6.41157 5.94447 6.31345C8.81239 6.17136 12.9115 6 16 6C19.0885 6 23.1876 6.17136 26.0555 6.31345C28.0361 6.41157 29.627 7.96233 29.7555 9.94111C29.8786 11.8369 30 14.1697 30 16C30 17.8303 29.8786 20.1631 29.7555 22.0589C29.627 24.0377 28.0361 25.5884 26.0555 25.6866C23.1876 25.8286 19.0885 26 16 26C12.9115 26 8.81239 25.8286 5.94447 25.6866C3.96395 25.5884 2.37304 24.0377 2.24451 22.0589C2.12136 20.1631 2 17.8303 2 16C2 14.1697 2.12136 11.8369 2.24451 9.94111Z"
        fill="#FC0D1B"
      />
      <path d="M13 12V20L21 16L13 12Z" fill="white" />
    </svg>
  );
};

export const YoutubeBlack = (fill) => {
  return (
    <svg
      width="19"
      height="14"
      viewBox="0 0 19 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.59222 1.06244C1.29066 1.12692 0.245151 2.14605 0.160684 3.44645C0.0797577 4.69234 0 6.22536 0 7.42822C0 8.63108 0.0797577 10.1641 0.160684 11.41C0.245151 12.7104 1.29066 13.7295 2.59222 13.794C4.47695 13.8874 7.17078 14 9.20049 14C11.2302 14 13.924 13.8874 15.8088 13.794C17.1103 13.7295 18.1558 12.7104 18.2403 11.41C18.3212 10.1641 18.401 8.63108 18.401 7.42822C18.401 6.22536 18.3212 4.69234 18.2403 3.44645C18.1558 2.14605 17.1103 1.12692 15.8088 1.06244C13.924 0.96906 11.2302 0.856445 9.20049 0.856445C7.17078 0.856445 4.47695 0.96906 2.59222 1.06244ZM12.4863 7.42898L7.22884 10.0577V4.80027L12.4863 7.42898Z"
        fill="#090A14"
      />
    </svg>
  );
};
export const YoutubeHover = (fill) => {
  return (
    <svg
      width="19"
      height="14"
      viewBox="0 0 19 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.59222 1.06244C1.29066 1.12692 0.245151 2.14605 0.160684 3.44645C0.0797577 4.69234 0 6.22536 0 7.42822C0 8.63108 0.0797577 10.1641 0.160684 11.41C0.245151 12.7104 1.29066 13.7295 2.59222 13.794C4.47695 13.8874 7.17078 14 9.20049 14C11.2302 14 13.924 13.8874 15.8088 13.794C17.1103 13.7295 18.1558 12.7104 18.2403 11.41C18.3212 10.1641 18.401 8.63108 18.401 7.42822C18.401 6.22536 18.3212 4.69234 18.2403 3.44645C18.1558 2.14605 17.1103 1.12692 15.8088 1.06244C13.924 0.96906 11.2302 0.856445 9.20049 0.856445C7.17078 0.856445 4.47695 0.96906 2.59222 1.06244ZM12.4863 7.42898L7.22884 10.0577V4.80027L12.4863 7.42898Z"
        fill="#1977F2"
      />
    </svg>
  );
};

export const twitterIcon = (fill) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.7887 28C8.55374 28 5.53817 27.0591 3 25.4356C5.15499 25.5751 8.95807 25.2411 11.3236 22.9848C7.76508 22.8215 6.16026 20.0923 5.95094 18.926C6.25329 19.0426 7.6953 19.1826 8.50934 18.856C4.4159 17.8296 3.78793 14.2373 3.92748 13.141C4.695 13.6775 5.99745 13.8641 6.50913 13.8174C2.69479 11.0882 4.06703 6.98276 4.74151 6.09635C7.47882 9.88867 11.5812 12.0186 16.6564 12.137C16.5607 11.7174 16.5102 11.2804 16.5102 10.8316C16.5102 7.61092 19.1134 5 22.3247 5C24.0025 5 25.5144 5.71275 26.5757 6.85284C27.6969 6.59011 29.3843 5.97507 30.2092 5.4432C29.7934 6.93611 28.4989 8.18149 27.7159 8.64308C27.7095 8.62731 27.7224 8.65878 27.7159 8.64308C28.4037 8.53904 30.2648 8.18137 31 7.68256C30.6364 8.52125 29.264 9.91573 28.1377 10.6964C28.3473 19.9381 21.2765 28 11.7887 28Z"
        fill="#47ACDF"
      />
    </svg>
  );
};

export const SocialMediaDropDrown = (fill) => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M19.5433 8.75244L18.764 8L12.019 14.9063L5.08581 8.16124L4.33337 8.91367L12.019 16.438L19.5433 8.75244Z"
        fill="#090A14"
        stroke="#090A14"
        strokeWidth="0.2"
      />
    </svg>
  );
};

export const UploadContentIcon = (fill) => {
  return (
    <svg
      width="69"
      height="60"
      viewBox="0 0 69 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <g id="Upload icon">
        <path
          id="Vector"
          d="M36.028 14.7458L36.1203 14.7733L36.1243 14.7688C36.5619 14.8481 36.9961 14.586 37.1247 14.1519C38.2963 10.2152 41.9874 7.46504 46.0998 7.46504C46.5867 7.46504 46.9816 7.07016 46.9816 6.5833C46.9816 6.09643 46.5867 5.70156 46.0998 5.70156C41.0457 5.70156 36.7985 9.06665 35.4348 13.6493C35.2956 14.1162 35.5615 14.6067 36.028 14.7458Z"
          fill="#667085"
          stroke="#F9FFF9"
          strokeWidth="0.3"
        />
        <path
          id="Vector_2"
          d="M56.3438 42.4384H51.9534C51.5494 42.4384 51.2217 42.1107 51.2217 41.7067C51.2217 41.3027 51.5494 40.9749 51.9534 40.9749H56.3438C62.3956 40.9749 67.3197 36.0509 67.3197 29.999C67.3197 23.9471 62.3956 19.023 56.3438 19.023H56.2382C56.026 19.023 55.8242 18.9311 55.6852 18.7706C55.5462 18.6101 55.4834 18.3974 55.5138 18.1873C55.5791 17.7315 55.612 17.2737 55.612 16.8279C55.612 11.5829 51.3444 7.31531 46.0995 7.31531C44.059 7.31531 42.1131 7.95296 40.4719 9.15978C40.1112 9.42478 39.599 9.30718 39.3905 8.91047C34.7425 0.0596993 22.6023 -1.12887 16.3082 6.57053C13.6568 9.81417 12.615 14.0336 13.4498 18.146C13.5418 18.6002 13.1942 19.0236 12.7327 19.0236H12.4395C6.3876 19.0236 1.46353 23.9477 1.46353 29.9996C1.46353 36.0514 6.3876 40.9755 12.4395 40.9755H16.8298C17.2338 40.9755 17.5615 41.3032 17.5615 41.7072C17.5615 42.1113 17.2338 42.439 16.8298 42.439H12.4395C5.5805 42.439 0 36.8585 0 29.9995C0 23.3329 5.27155 17.8742 11.8651 17.5731C11.2457 13.3066 12.4301 9.00295 15.1751 5.64437C21.9138 -2.5996 34.828 -1.67556 40.2871 7.51707C42.0287 6.42522 44.0215 5.85244 46.0992 5.85244C52.4538 5.85244 57.4892 11.261 57.0486 17.58C63.5813 17.9463 68.7829 23.3763 68.7829 29.999C68.7829 36.8585 63.2024 42.4384 56.3434 42.4384L56.3438 42.4384Z"
          fill="#667085"
        />
        <path
          id="Vector_3"
          d="M15.85 41.2935C15.85 51.4634 24.1237 59.737 34.2935 59.737C44.4634 59.737 52.737 51.4633 52.737 41.2935C52.737 31.1235 44.4634 22.85 34.2935 22.85C24.1235 22.85 15.85 31.1237 15.85 41.2935ZM17.6138 41.2935C17.6138 32.0966 25.0964 24.6138 34.2935 24.6138C43.4904 24.6138 50.9732 32.0964 50.9732 41.2935C50.9732 50.4904 43.4904 57.9732 34.2935 57.9732C25.0966 57.9732 17.6138 50.4905 17.6138 41.2935Z"
          fill="#667085"
          stroke="#F9FFF9"
          strokeWidth="0.3"
        />
        <g id="arrow">
          <path
            id="Vector_4"
            d="M33.9428 48.6577C33.9428 49.0363 34.2499 49.3434 34.6285 49.3434C35.0071 49.3434 35.3142 49.0367 35.3142 48.6577V34.7291C35.3142 34.3504 35.0071 34.0434 34.6285 34.0434C34.2498 34.0434 33.9428 34.3504 33.9428 34.7291V48.6577Z"
            fill="#667085"
            stroke="#483EA8"
            strokeWidth="0.3"
          />
          <path
            id="Vector_5"
            d="M34.6281 35.6999L30.8274 39.5006L34.6281 35.6999ZM34.6281 35.6999L38.4289 39.5007C38.5626 39.6344 38.7386 39.7015 38.9137 39.7015L34.6281 35.6999ZM29.8576 39.5007C30.1254 39.7685 30.5597 39.7686 30.8273 39.5007L38.9138 39.7015C39.0886 39.7015 39.2647 39.635 39.3987 39.5006C39.6665 39.2327 39.6665 38.7988 39.3986 38.5309L35.113 34.2452C34.8452 33.9775 34.4108 33.9773 34.1432 34.2452C34.1432 34.2453 34.1431 34.2453 34.1431 34.2453L29.8576 38.5309C29.5897 38.7988 29.5897 39.2328 29.8576 39.5007Z"
            fill="#667085"
            stroke="#483EA8"
            strokeWidth="0.3"
          />
        </g>
      </g>
    </svg>
  );
};

export const InstagramIcons2 = (fill) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none">
      <path
        d="M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 15.5C12.4596 15.5 12.9148 15.4095 13.3394 15.2336C13.764 15.0577 14.1499 14.7999 14.4749 14.4749C14.7999 14.1499 15.0577 13.764 15.2336 13.3394C15.4095 12.9148 15.5 12.4596 15.5 12C15.5 11.5404 15.4095 11.0852 15.2336 10.6606C15.0577 10.236 14.7999 9.85013 14.4749 9.52513C14.1499 9.20012 13.764 8.94231 13.3394 8.76642C12.9148 8.59053 12.4596 8.5 12 8.5C11.0717 8.5 10.1815 8.86875 9.52513 9.52513C8.86875 10.1815 8.5 11.0717 8.5 12C8.5 12.9283 8.86875 13.8185 9.52513 14.4749C10.1815 15.1313 11.0717 15.5 12 15.5Z"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.636 7H17.648"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const EditIcon = (fill) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="15"
      viewBox="0 0 14 15"
      fill="none">
      <path
        d="M9.92281 2.02799C10.2609 1.68992 10.7194 1.5 11.1975 1.5C11.6756 1.5 12.1341 1.68992 12.4721 2.02799C12.8102 2.36605 13.0001 2.82456 13.0001 3.30265C13.0001 3.78075 12.8102 4.23926 12.4721 4.57732L4.39924 12.6502L1.00012 13.5L1.8499 10.1009L9.92281 2.02799Z"
        stroke="white"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const EditIconCounter = (fill) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="15"
      viewBox="0 0 14 15"
      fill="none">
      <path
        d="M9.92281 2.02799C10.2609 1.68992 10.7194 1.5 11.1975 1.5C11.6756 1.5 12.1341 1.68992 12.4721 2.02799C12.8102 2.36605 13.0001 2.82456 13.0001 3.30265C13.0001 3.78075 12.8102 4.23926 12.4721 4.57732L4.39924 12.6502L1.00012 13.5L1.8499 10.1009L9.92281 2.02799Z"
        stroke="#1977F2"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const EditIconBlack = (fill) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15.8969 4.70398C16.3477 4.25323 16.959 4 17.5965 4C18.2339 4 18.8453 4.25323 19.296 4.70398C19.7468 5.15473 20 5.76608 20 6.40354C20 7.041 19.7468 7.65234 19.296 8.1031L8.53215 18.867L4 20L5.13304 15.4678L15.8969 4.70398Z"
        stroke="#5A5B62"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const InstagramIconNonColoredIcon = (fill) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="48"
      height="47"
      viewBox="0 0 48 47"
      fill="none">
      <path
        d="M18.1248 43.0827H29.8748C39.6665 43.0827 43.5832 39.166 43.5832 29.3743V17.6243C43.5832 7.83268 39.6665 3.91602 29.8748 3.91602H18.1248C8.33317 3.91602 4.4165 7.83268 4.4165 17.6243V29.3743C4.4165 39.166 8.33317 43.0827 18.1248 43.0827Z"
        stroke="#090a14"
        strokeWidth="2.9375"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24.0002 30.3548C24.9003 30.3548 25.7916 30.1775 26.6231 29.8331C27.4547 29.4886 28.2103 28.9837 28.8468 28.3473C29.4833 27.7108 29.9881 26.9552 30.3326 26.1236C30.677 25.292 30.8543 24.4008 30.8543 23.5007C30.8543 22.6005 30.677 21.7093 30.3326 20.8777C29.9881 20.0461 29.4833 19.2905 28.8468 18.654C28.2103 18.0176 27.4547 17.5127 26.6231 17.1682C25.7916 16.8238 24.9003 16.6465 24.0002 16.6465C22.1823 16.6465 20.4389 17.3686 19.1535 18.654C17.8681 19.9394 17.146 21.6828 17.146 23.5007C17.146 25.3185 17.8681 27.0619 19.1535 28.3473C20.4389 29.6327 22.1823 30.3548 24.0002 30.3548Z"
        stroke="#090a14"
        strokeWidth="2.9375"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M35.0366 13.709H35.0596"
        stroke="#090a14"
        strokeWidth="3.91667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const InstagramBlack = (fill) => {
  return (
    <svg
      width="15"
      height="14"
      viewBox="0 0 15 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.38265 0.965004C5.12304 0.932913 5.3591 0.925781 7.2451 0.925781C9.13109 0.925781 9.36716 0.933507 10.1069 0.965004C10.8467 0.996501 11.3516 1.10763 11.7935 1.26868C12.2561 1.4333 12.6759 1.69063 13.023 2.02342C13.3765 2.34969 13.6492 2.74429 13.8234 3.1805C13.995 3.59649 14.1125 4.07192 14.1465 4.76723C14.1806 5.46552 14.1882 5.68778 14.1882 7.46291C14.1882 9.23863 14.18 9.46089 14.1465 10.158C14.1131 10.8533 13.995 11.3287 13.8234 11.7447C13.6492 12.181 13.376 12.5762 13.023 12.903C12.6759 13.2358 12.2561 13.4925 11.7935 13.6565C11.3516 13.8182 10.8467 13.9287 10.1082 13.9608C9.36716 13.9929 9.13109 14 7.2451 14C5.3591 14 5.12304 13.9923 4.38265 13.9608C3.64416 13.9293 3.1392 13.8182 2.69737 13.6565C2.23403 13.4925 1.81422 13.2353 1.46718 12.903C1.11395 12.5765 0.840606 12.1815 0.666199 11.7453C0.495146 11.3293 0.377745 10.8539 0.343661 10.1586C0.309576 9.4603 0.302002 9.23804 0.302002 7.46291C0.302002 5.68719 0.310207 5.46492 0.343661 4.76842C0.377114 4.07192 0.495146 3.59649 0.666199 3.1805C0.840864 2.74434 1.11442 2.34928 1.46781 2.02283C1.81436 1.69033 2.23374 1.43297 2.69674 1.26868C3.13857 1.10763 3.64416 0.997095 4.38265 0.965004ZM6.35827 9.47813C6.85354 9.67224 7.40503 9.69844 7.91853 9.55225C8.43204 9.40606 8.87571 9.09655 9.17377 8.67658C9.47183 8.25662 9.60579 7.75225 9.55276 7.24962C9.49973 6.747 9.26302 6.27729 8.88304 5.92074C8.64081 5.69282 8.34792 5.5183 8.02546 5.40974C7.703 5.30119 7.35898 5.2613 7.01818 5.29295C6.67738 5.3246 6.34827 5.427 6.05455 5.59277C5.76082 5.75855 5.50979 5.98358 5.31953 6.25167C5.12926 6.51975 5.00449 6.82422 4.9542 7.14316C4.90391 7.4621 4.92936 7.78756 5.0287 8.09613C5.12804 8.40469 5.29881 8.68868 5.52871 8.92765C5.75862 9.16662 6.04194 9.35462 6.35827 9.47813ZM4.7216 5.08696C5.05299 4.77495 5.44641 4.52744 5.87939 4.35858C6.31237 4.18972 6.77644 4.10281 7.2451 4.10281C7.71375 4.10281 8.17782 4.18972 8.61081 4.35858C9.04379 4.52744 9.43721 4.77495 9.7686 5.08696C10.1 5.39897 10.3629 5.76939 10.5422 6.17705C10.7216 6.58472 10.8139 7.02165 10.8139 7.46291C10.8139 7.90416 10.7216 8.3411 10.5422 8.74876C10.3629 9.15643 10.1 9.52684 9.7686 9.83886C9.09932 10.469 8.19159 10.823 7.2451 10.823C6.2986 10.823 5.39087 10.469 4.7216 9.83886C4.05232 9.20872 3.67633 8.35406 3.67633 7.46291C3.67633 6.57175 4.05232 5.7171 4.7216 5.08696ZM11.6054 4.60321C11.6875 4.53028 11.7532 4.44257 11.7987 4.34528C11.8442 4.24799 11.8684 4.1431 11.8701 4.03682C11.8717 3.93054 11.8507 3.82503 11.8083 3.72653C11.7658 3.62803 11.7028 3.53856 11.623 3.4634C11.5432 3.38824 11.4481 3.32892 11.3435 3.28896C11.2389 3.249 11.1269 3.22921 11.014 3.23076C10.9011 3.23231 10.7897 3.25517 10.6864 3.29798C10.583 3.3408 10.4899 3.4027 10.4124 3.48002C10.2618 3.63039 10.1793 3.83012 10.1825 4.03682C10.1857 4.24352 10.2743 4.4409 10.4296 4.58707C10.5848 4.73325 10.7944 4.8167 11.014 4.81971C11.2335 4.82272 11.4457 4.74506 11.6054 4.60321Z"
        fill="#090A14"
      />
    </svg>
  );
};
export const InstagramHover = (fill) => {
  return (
    <svg
      width="15"
      height="14"
      viewBox="0 0 15 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.48165 0.895668C5.22203 0.863577 5.4581 0.856445 7.3441 0.856445C9.23009 0.856445 9.46616 0.864171 10.2059 0.895668C10.9457 0.927165 11.4506 1.0383 11.8925 1.19935C12.3551 1.36396 12.7749 1.62129 13.122 1.95409C13.4755 2.28035 13.7482 2.67496 13.9224 3.11116C14.094 3.52716 14.2114 4.00259 14.2455 4.6979C14.2796 5.39618 14.2872 5.61844 14.2872 7.39357C14.2872 9.16929 14.279 9.39156 14.2455 10.0887C14.2121 10.784 14.094 11.2594 13.9224 11.6754C13.7482 12.1117 13.475 12.5069 13.122 12.8336C12.7749 13.1664 12.3551 13.4232 11.8925 13.5872C11.4506 13.7488 10.9457 13.8594 10.2072 13.8915C9.46616 13.9236 9.23009 13.9307 7.3441 13.9307C5.4581 13.9307 5.22203 13.923 4.48165 13.8915C3.74316 13.86 3.2382 13.7488 2.79637 13.5872C2.33303 13.4232 1.91322 13.166 1.56618 12.8336C1.21295 12.5072 0.939605 12.1121 0.765198 11.676C0.594145 11.26 0.476744 10.7846 0.44266 10.0892C0.408575 9.39096 0.401001 9.1687 0.401001 7.39357C0.401001 5.61785 0.409206 5.39559 0.44266 4.69909C0.476113 4.00259 0.594145 3.52716 0.765198 3.11116C0.939863 2.675 1.21342 2.27994 1.56681 1.95349C1.91336 1.62099 2.33274 1.36363 2.79574 1.19935C3.23757 1.0383 3.74316 0.927759 4.48165 0.895668ZM6.45727 9.40879C6.95254 9.6029 7.50403 9.6291 8.01753 9.48291C8.53104 9.33672 8.97471 9.02721 9.27277 8.60724C9.57083 8.18728 9.70478 7.68291 9.65176 7.18029C9.59873 6.67766 9.36202 6.20796 8.98204 5.8514C8.73981 5.62348 8.44692 5.44896 8.12446 5.34041C7.802 5.23185 7.45798 5.19196 7.11718 5.22361C6.77638 5.25526 6.44727 5.35766 6.15355 5.52344C5.85982 5.68921 5.60879 5.91425 5.41853 6.18233C5.22826 6.45042 5.10349 6.75489 5.0532 7.07382C5.00291 7.39276 5.02835 7.71823 5.1277 8.02679C5.22704 8.33536 5.39781 8.61935 5.62771 8.85832C5.85762 9.09729 6.14094 9.28529 6.45727 9.40879ZM4.8206 5.01762C5.15199 4.70561 5.54541 4.45811 5.97839 4.28925C6.41137 4.12039 6.87544 4.03347 7.3441 4.03347C7.81275 4.03347 8.27682 4.12038 8.7098 4.28925C9.14279 4.45811 9.53621 4.70561 9.8676 5.01762C10.199 5.32964 10.4619 5.70005 10.6412 6.10772C10.8206 6.51538 10.9129 6.95232 10.9129 7.39357C10.9129 7.83483 10.8206 8.27176 10.6412 8.67943C10.4619 9.08709 10.199 9.45751 9.8676 9.76952C9.19832 10.3997 8.29059 10.7537 7.3441 10.7537C6.3976 10.7537 5.48987 10.3997 4.8206 9.76952C4.15132 9.13938 3.77533 8.28473 3.77533 7.39357C3.77533 6.50242 4.15132 5.64776 4.8206 5.01762ZM11.7044 4.53388C11.7865 4.46094 11.8522 4.37323 11.8977 4.27594C11.9432 4.17865 11.9674 4.07376 11.9691 3.96748C11.9707 3.8612 11.9497 3.75569 11.9073 3.65719C11.8648 3.5587 11.8018 3.46922 11.722 3.39406C11.6422 3.3189 11.5471 3.25959 11.4425 3.21963C11.3379 3.17967 11.2259 3.15988 11.113 3.16143C11.0001 3.16298 10.8887 3.18583 10.7854 3.22865C10.682 3.27146 10.5889 3.33336 10.5114 3.41068C10.3608 3.56105 10.2783 3.76078 10.2815 3.96748C10.2847 4.17418 10.3733 4.37156 10.5286 4.51774C10.6838 4.66391 10.8934 4.74736 11.113 4.75037C11.3325 4.75339 11.5447 4.67573 11.7044 4.53388Z"
        fill="#1977F2"
      />
    </svg>
  );
};

export const EditIconBlue = (fill) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="15"
      viewBox="0 0 14 15"
      fill="none">
      <path
        d="M9.92281 2.02799C10.2609 1.68992 10.7194 1.5 11.1975 1.5C11.6756 1.5 12.1341 1.68992 12.4721 2.02799C12.8102 2.36605 13.0001 2.82456 13.0001 3.30265C13.0001 3.78075 12.8102 4.23926 12.4721 4.57732L4.39924 12.6502L1.00012 13.5L1.8499 10.1009L9.92281 2.02799Z"
        stroke="#1977F2"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const CloseRoundButtonIcon = (fill) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none">
      <circle cx="16" cy="16" r="16" fill="white" fillOpacity="0.8" />
      <path
        d="M21.9303 10.0693C21.7435 9.88254 21.4903 9.77734 21.226 9.77734C20.9618 9.77734 20.7084 9.88254 20.5217 10.0693L15.9999 14.5912L11.4781 10.0693C11.2265 9.81779 10.8597 9.71954 10.516 9.81154C10.1723 9.90372 9.90396 10.1721 9.81174 10.5158C9.71974 10.8596 9.81799 11.2263 10.0695 11.4779L14.5914 15.9997L10.0695 20.5215C9.81799 20.7731 9.71974 21.1399 9.81174 21.4836C9.90392 21.8273 10.1723 22.0957 10.516 22.1879C10.8598 22.2799 11.2266 22.1816 11.4781 21.9301L15.9999 17.4083L20.5217 21.9301C20.7733 22.1816 21.1401 22.2799 21.4838 22.1879C21.8275 22.0957 22.0959 21.8273 22.1881 21.4836C22.2801 21.1399 22.1818 20.7731 21.9303 20.5215L17.4085 15.9997L21.9303 11.4779C22.1171 11.2913 22.2223 11.0378 22.2223 10.7736C22.2223 10.5094 22.1171 10.2561 21.9303 10.0693L21.9303 10.0693Z"
        fill="black"
      />
    </svg>
  );
};

export const DeleteIcons = (fill) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.40627 2.8906C9.7772 2.3342 10.4017 2 11.0704 2H12.9296C13.5983 2 14.2228 2.3342 14.5937 2.8906L15.5 4.25H19.25C19.6642 4.25 20 4.58579 20 5C20 5.41421 19.6642 5.75 19.25 5.75H4.75C4.33579 5.75 4 5.41421 4 5C4 4.58579 4.33579 4.25 4.75 4.25H8.5L9.40627 2.8906ZM15 22H9C6.79086 22 5 20.2091 5 18V7H19V18C19 20.2091 17.2091 22 15 22ZM10 10.25C10.4142 10.25 10.75 10.5858 10.75 11V18C10.75 18.4142 10.4142 18.75 10 18.75C9.58579 18.75 9.25 18.4142 9.25 18L9.25 11C9.25 10.5858 9.58579 10.25 10 10.25ZM14 10.25C14.4142 10.25 14.75 10.5858 14.75 11V18C14.75 18.4142 14.4142 18.75 14 18.75C13.5858 18.75 13.25 18.4142 13.25 18V11C13.25 10.5858 13.5858 10.25 14 10.25Z"
        fill="white"
      />
    </svg>
  );
};

export const bellIcon = (fill) => {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 52 52"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M26.3547 51.1431C40.3901 51.1431 51.7681 39.7651 51.7681 25.7297C51.7681 11.6943 40.3901 0.316406 26.3547 0.316406C12.3193 0.316406 0.941406 11.6943 0.941406 25.7297C0.941406 39.7651 12.3193 51.1431 26.3547 51.1431Z"
        fill="#FBC12F"
      />
      <path
        d="M35.9692 33.7383H16.7669C16.6172 33.7551 16.4789 33.8264 16.3785 33.9387C16.2781 34.051 16.2227 34.1963 16.2227 34.3469C16.2227 34.4976 16.2781 34.6429 16.3785 34.7552C16.4789 34.8675 16.6172 34.9388 16.7669 34.9556H35.9692C36.1189 34.9388 36.2571 34.8675 36.3575 34.7552C36.4579 34.6429 36.5134 34.4976 36.5134 34.3469C36.5134 34.1963 36.4579 34.051 36.3575 33.9387C36.2571 33.8264 36.1189 33.7551 35.9692 33.7383Z"
        fill="white"
      />
      <path
        d="M38.1469 23.4034L32.8304 25.4365C32.6998 25.4811 32.5579 25.4802 32.4279 25.4341C32.2978 25.388 32.1871 25.2993 32.1138 25.1823L26.8862 16.8087C26.8322 16.7203 26.7564 16.6474 26.666 16.5967C26.5757 16.5461 26.4739 16.5195 26.3703 16.5195C26.2668 16.5195 26.165 16.5461 26.0746 16.5967C25.9843 16.6474 25.9085 16.7203 25.8544 16.8087L20.6269 25.1823C20.5528 25.3031 20.4391 25.3945 20.3052 25.4408C20.1713 25.4872 20.0254 25.4856 19.8925 25.4365L14.5938 23.4187C14.4883 23.3798 14.3743 23.3707 14.264 23.3923C14.1538 23.414 14.0516 23.4656 13.9686 23.5414C13.8857 23.6172 13.8253 23.7144 13.7939 23.8223C13.7625 23.9302 13.7614 24.0446 13.7907 24.1531L16.0347 32.0948C16.0692 32.2186 16.1422 32.3282 16.2432 32.4077C16.3442 32.4872 16.4679 32.5325 16.5964 32.537H36.124C36.2523 32.5321 36.3758 32.4867 36.4767 32.4072C36.5776 32.3278 36.6508 32.2184 36.6856 32.0948L38.9296 24.1531C38.9575 24.047 38.9562 23.9354 38.926 23.83C38.8957 23.7245 38.8376 23.6292 38.7578 23.554C38.6779 23.4789 38.5792 23.4266 38.4722 23.4028C38.3651 23.3789 38.2536 23.3844 38.1494 23.4187L38.1469 23.4034Z"
        fill="white"
      />
    </svg>
  );
};

export const creditIcon = (fill) => {
  return (
    <svg
      id="Group_1801"
      data-name="Group 1801"
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      viewBox="0 0 20 20">
      <circle
        id="Ellipse_118"
        data-name="Ellipse 118"
        cx="10"
        cy="10"
        r="10"
        transform="translate(0 0)"
        fill="#fbc12f"
      />
    </svg>
  );
};

export const UploadIconFile = (file) => {
  return (
    <svg
      width="69"
      height="60"
      viewBox="0 0 69 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <rect width="69" height="60" fill="#1E1E1E" />
      <path
        d="M-18339 -1166C-18339 -1167.1 -18338.1 -1168 -18337 -1168H6368C6369.1 -1168 6370 -1167.1 6370 -1166V601C6370 602.105 6369.1 603 6368 603H-18337C-18338.1 603 -18339 602.105 -18339 601V-1166Z"
        fill="#404040"
      />
      <g clip-path="url(#clip0_0_1)">
        <rect
          width="1512"
          height="1190"
          transform="translate(-845 -689)"
          fill="#161023"
        />
        <rect
          x="-566"
          y="-537"
          width="1201"
          height="1013"
          rx="8"
          fill="#1C1835"
        />
        <rect x="-317" y="-30" width="702" height="202" rx="4" fill="white" />
        <rect
          x="-316.5"
          y="-29.5"
          width="701"
          height="201"
          rx="3.5"
          stroke="#1C1835"
          stroke-opacity="0.4"
          stroke-dasharray="5 5"
        />
        <path
          d="M36.028 14.7458L36.1203 14.7733L36.1243 14.7688C36.5619 14.8481 36.9961 14.586 37.1247 14.1519C38.2963 10.2152 41.9874 7.46504 46.0998 7.46504C46.5867 7.46504 46.9816 7.07016 46.9816 6.5833C46.9816 6.09643 46.5867 5.70156 46.0998 5.70156C41.0457 5.70156 36.7985 9.06665 35.4348 13.6493C35.2956 14.1162 35.5615 14.6067 36.028 14.7458Z"
          fill="#667085"
          stroke="#F9FFF9"
          strokeWidth="0.3"
        />
        <path
          d="M56.3438 42.4384H51.9534C51.5494 42.4384 51.2217 42.1107 51.2217 41.7067C51.2217 41.3027 51.5494 40.9749 51.9534 40.9749H56.3438C62.3956 40.9749 67.3197 36.0509 67.3197 29.999C67.3197 23.9471 62.3956 19.023 56.3438 19.023H56.2382C56.026 19.023 55.8242 18.9311 55.6852 18.7706C55.5462 18.6101 55.4834 18.3974 55.5138 18.1873C55.5791 17.7315 55.612 17.2737 55.612 16.8279C55.612 11.5829 51.3444 7.31531 46.0995 7.31531C44.059 7.31531 42.1131 7.95296 40.4719 9.15978C40.1112 9.42478 39.599 9.30718 39.3905 8.91047C34.7425 0.0596993 22.6023 -1.12887 16.3082 6.57053C13.6568 9.81417 12.615 14.0336 13.4498 18.146C13.5418 18.6002 13.1942 19.0236 12.7327 19.0236H12.4395C6.3876 19.0236 1.46353 23.9477 1.46353 29.9996C1.46353 36.0514 6.3876 40.9755 12.4395 40.9755H16.8298C17.2338 40.9755 17.5615 41.3032 17.5615 41.7072C17.5615 42.1113 17.2338 42.439 16.8298 42.439H12.4395C5.5805 42.439 0 36.8585 0 29.9995C0 23.3329 5.27155 17.8742 11.8651 17.5731C11.2457 13.3066 12.4301 9.00295 15.1751 5.64437C21.9138 -2.5996 34.828 -1.67556 40.2871 7.51707C42.0287 6.42522 44.0215 5.85244 46.0992 5.85244C52.4538 5.85244 57.4892 11.261 57.0486 17.58C63.5813 17.9463 68.7829 23.3763 68.7829 29.999C68.7829 36.8585 63.2024 42.4384 56.3434 42.4384L56.3438 42.4384Z"
          fill="#667085"
        />
        <path
          d="M15.85 41.2935C15.85 51.4634 24.1237 59.737 34.2935 59.737C44.4634 59.737 52.737 51.4633 52.737 41.2935C52.737 31.1235 44.4634 22.85 34.2935 22.85C24.1235 22.85 15.85 31.1237 15.85 41.2935ZM17.6138 41.2935C17.6138 32.0966 25.0964 24.6138 34.2935 24.6138C43.4904 24.6138 50.9732 32.0964 50.9732 41.2935C50.9732 50.4904 43.4904 57.9732 34.2935 57.9732C25.0966 57.9732 17.6138 50.4905 17.6138 41.2935Z"
          fill="#667085"
          stroke="#F9FFF9"
          strokeWidth="0.3"
        />
        <path
          d="M33.9428 48.6577C33.9428 49.0363 34.2499 49.3434 34.6285 49.3434C35.0071 49.3434 35.3142 49.0367 35.3142 48.6577V34.7291C35.3142 34.3504 35.0071 34.0434 34.6285 34.0434C34.2498 34.0434 33.9428 34.3504 33.9428 34.7291V48.6577Z"
          fill="#667085"
          stroke="#483EA8"
          strokeWidth="0.3"
        />
        <path
          d="M34.6281 35.6999L30.8274 39.5006L34.6281 35.6999ZM34.6281 35.6999L38.4289 39.5007C38.5626 39.6344 38.7386 39.7015 38.9137 39.7015L34.6281 35.6999ZM29.8576 39.5007C30.1254 39.7685 30.5597 39.7686 30.8273 39.5007L38.9138 39.7015C39.0886 39.7015 39.2647 39.635 39.3987 39.5006C39.6665 39.2327 39.6665 38.7988 39.3986 38.5309L35.113 34.2452C34.8452 33.9775 34.4108 33.9773 34.1432 34.2452C34.1432 34.2453 34.1431 34.2453 34.1431 34.2453L29.8576 38.5309C29.5897 38.7988 29.5897 39.2328 29.8576 39.5007Z"
          fill="#667085"
          stroke="#483EA8"
          strokeWidth="0.3"
        />
      </g>
      <path
        d="M-18337 -1167H6368V-1169H-18337V-1167ZM6369 -1166V601H6371V-1166H6369ZM6368 602H-18337V604H6368V602ZM-18338 601V-1166H-18340V601H-18338ZM-18337 602C-18337.6 602 -18338 601.552 -18338 601H-18340C-18340 602.657 -18338.7 604 -18337 604V602ZM6369 601C6369 601.552 6368.55 602 6368 602V604C6369.66 604 6371 602.657 6371 601H6369ZM6368 -1167C6368.55 -1167 6369 -1166.55 6369 -1166H6371C6371 -1167.66 6369.66 -1169 6368 -1169V-1167ZM-18337 -1169C-18338.7 -1169 -18340 -1167.66 -18340 -1166H-18338C-18338 -1166.55 -18337.6 -1167 -18337 -1167V-1169Z"
        fill="white"
        fill-opacity="0.1"
      />
      <defs>
        <clipPath id="clip0_0_1">
          <rect
            width="1512"
            height="1190"
            fill="white"
            transform="translate(-845 -689)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const LogoUploadBrandIcon = (fill) => {
  return (
    <>
      <svg
      // xmlns:dc="http://purl.org/dc/elements/1.1/"
      // xmlns:cc="http://creativecommons.org/ns#"
      // xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
      // xmlns:svg="http://www.w3.org/2000/svg"
      // xmlns="http://www.w3.org/2000/svg"
      // xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"
      // xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape"
      // viewBox="0 0 6.6145832 8.268229375"
      // version="1.1"
      // x="0px"
      // y="0px"
      >
        <g transform="translate(0,-290.38541)">
          <rect
            style="display:inline;opacity:1;vector-effect:none;fill:none;fill-opacity:1;stroke:none;strokeWidth:0.02645833;strokeLinecap:round;strokeLinejoin:round;stroke-miterlimit:4;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1;paint-order:normal"
            width="6.614584"
            height="6.6145902"
            x="-2.1020507e-07"
            y="290.38541"
          />
          <path
            style="color:#000000;font-style:normal;font-variant:normal;font-weight:normal;font-stretch:normal;font-size:medium;line-height:normal;font-family:sans-serif;font-variant-ligatures:normal;font-variant-position:normal;font-variant-caps:normal;font-variant-numeric:normal;font-variant-alternates:normal;font-feature-settings:normal;text-indent:0;text-align:start;text-decoration:none;text-decoration-line:none;text-decoration-style:solid;text-decoration-color:#000000;letter-spacing:normal;word-spacing:normal;text-transform:none;writing-mode:lr-tb;direction:ltr;text-orientation:mixed;dominant-baseline:auto;baseline-shift:baseline;text-anchor:start;white-space:normal;shape-padding:0;clipRule:nonzero;display:inline;overflow:visible;visibility:visible;opacity:1;isolation:auto;mix-blend-mode:normal;color-interpolation:sRGB;color-interpolation-filters:linearRGB;solid-color:#000000;solid-opacity:1;vector-effect:none;fill:#000000;fill-opacity:1;fillRule:nonzero;stroke:none;strokeWidth:0.26458335px;strokeLinecap:round;strokeLinejoin:round;stroke-miterlimit:4;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1;color-rendering:auto;image-rendering:auto;shape-rendering:auto;text-rendering:auto;enable-background:accumulate"
            d="m 4.8973007,291.97033 a 0.1323049,0.1323049 0 0 0 -0.013943,0.001 0.1323049,0.1323049 0 0 0 -0.1167897,0.13281 v 0.39842 H 4.3696924 a 0.1323049,0.1323049 0 0 0 -0.011377,0 0.1323049,0.1323049 0 0 0 0.011377,0.26407 h 0.3968751 v 0.39636 a 0.1328125,0.1328125 0 1 0 0.2656178,0 v -0.39636 h 0.3963591 a 0.1323049,0.1323049 0 1 0 0,-0.26407 H 5.0321853 v -0.39842 A 0.1323049,0.1323049 0 0 0 4.8973087,291.9703 Z m -0.7746286,0.003 a 0.13230489,0.13230489 0 0 0 -0.014473,5.3e-4 H 3.4751626 c -0.056568,-10e-6 -0.1139031,-6e-5 -0.1700133,0 -0.067892,-7e-5 -0.1288653,0 -0.1968897,0 -0.1302967,0 -0.2398077,-0.002 -0.3477816,0.0217 -0.1079738,0.0235 -0.2103543,0.0773 -0.3007571,0.16795 a 0.13230489,0.13230489 0 0 0 -0.00212,0.002 c -0.08141,0.083 -0.1568132,0.17648 -0.2247926,0.24391 -0.067979,0.0674 -0.1244283,0.0935 -0.1343581,0.0935 h -0.504362 c -0.292436,0 -0.536919,0.23588 -0.536919,0.52969 v 2.11098 c 0,0.29381 0.2431362,0.53253 0.536919,0.5333 h 1.7151403 1.7146244 c 0.2942035,0 0.5374349,-0.23949 0.5374349,-0.5333 v -1.88878 a 0.1328125,0.1328125 0 1 0 -0.2656178,0 v 1.88877 c 0,0.15083 -0.1188535,0.26975 -0.2718171,0.26975 H 3.3092848 1.5941444 c -0.1533842,-4e-4 -0.2713011,-0.11892 -0.2713011,-0.26975 v -2.11098 c 0,-0.15083 0.1165701,-0.26562 0.2713011,-0.26562 h 0.504362 c 0.1414145,0 0.2379477,-0.0867 0.3219424,-0.17001 0.084002,-0.0833 0.1594326,-0.17722 0.2268617,-0.24598 0.060939,-0.0611 0.1028911,-0.0837 0.1694973,-0.0982 0.066612,-0.0145 0.1611578,-0.0155 0.2914545,-0.0155 0.068231,0 0.1293759,-7e-5 0.1968897,0 0.055758,-6e-5 0.113321,-10e-6 0.1700133,0 0.01569,1e-5 0.6211967,0 0.6330368,0 a 0.13230489,0.13230489 0 1 0 0.01447,-0.26407 z m -0.8092546,1.32292 c -0.3637386,0 -0.6604238,0.29823 -0.6604238,0.66197 0,0.36374 0.2966852,0.66043 0.6604238,0.66043 0.3637413,0 0.661977,-0.29669 0.661977,-0.66043 0,-0.36374 -0.2982357,-0.66197 -0.661977,-0.66197 z m 0,0.26561 c 0.2207499,0 0.3984255,0.17561 0.3984255,0.39636 0,0.22075 -0.1776756,0.39636 -0.3984255,0.39636 -0.2207471,0 -0.3968723,-0.17561 -0.396875,-0.39636 0,-0.22075 0.1761279,-0.39636 0.396875,-0.39636 z"
          />
        </g>
        <text
          x="0"
          y="21.614583500000002"
          fill="#000000"
          font-size="5px"
          font-weight="bold"
          font-family="'Helvetica Neue', Helvetica, Arial-Unicode, Arial, Sans-serif"></text>
        <text
          x="0"
          y="26.614583500000002"
          fill="#000000"
          font-size="5px"
          font-weight="bold"
          font-family="'Helvetica Neue', Helvetica, Arial-Unicode, Arial, Sans-serif"></text>
      </svg>
    </>
  );
};

export const PayoutIcon = ({ className, fill }) => {
  const element = document.querySelector(".menu-icon a.active");
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="12" r="8.5" stroke="#5A5B62" />
      <path
        d="M13.592 9.52V9.724H15.14V10.516H13.532C13.46 11.068 13.3 11.5 13.052 11.812C12.812 12.124 12.46 12.348 11.996 12.484C11.54 12.62 10.932 12.688 10.172 12.688V13.636C10.172 14.716 10.644 15.256 11.588 15.256C12.516 15.256 12.98 14.736 12.98 13.696H13.988C13.98 14.496 13.768 15.1 13.352 15.508C12.936 15.916 12.344 16.12 11.576 16.12C10.784 16.12 10.18 15.9 9.764 15.46C9.356 15.02 9.152 14.404 9.152 13.612V11.92C10.064 11.92 10.736 11.892 11.168 11.836C11.608 11.772 11.928 11.644 12.128 11.452C12.328 11.252 12.456 10.94 12.512 10.516H8.612V9.724H12.56V9.508V8.428H8.612V7.624H15.14V8.428H13.592V9.52Z"
        fill="#5A5B62"
      />
    </svg>
  );
};
export const PayoutIconActive = ({ className, fill }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <mask id="path-1-inside-1_3309_6623" fill="white">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21ZM13.592 9.724V9.52V8.428H15.14V7.624H8.612V8.428H12.56V9.508V9.724H8.612V10.516H12.512C12.456 10.94 12.328 11.252 12.128 11.452C11.928 11.644 11.608 11.772 11.168 11.836C10.736 11.892 10.064 11.92 9.152 11.92V13.612C9.152 14.404 9.356 15.02 9.764 15.46C10.18 15.9 10.784 16.12 11.576 16.12C12.344 16.12 12.936 15.916 13.352 15.508C13.768 15.1 13.98 14.496 13.988 13.696H12.98C12.98 14.736 12.516 15.256 11.588 15.256C10.644 15.256 10.172 14.716 10.172 13.636V12.688C10.932 12.688 11.54 12.62 11.996 12.484C12.46 12.348 12.812 12.124 13.052 11.812C13.3 11.5 13.46 11.068 13.532 10.516H15.14V9.724H13.592Z"
        />
      </mask>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21ZM13.592 9.724V9.52V8.428H15.14V7.624H8.612V8.428H12.56V9.508V9.724H8.612V10.516H12.512C12.456 10.94 12.328 11.252 12.128 11.452C11.928 11.644 11.608 11.772 11.168 11.836C10.736 11.892 10.064 11.92 9.152 11.92V13.612C9.152 14.404 9.356 15.02 9.764 15.46C10.18 15.9 10.784 16.12 11.576 16.12C12.344 16.12 12.936 15.916 13.352 15.508C13.768 15.1 13.98 14.496 13.988 13.696H12.98C12.98 14.736 12.516 15.256 11.588 15.256C10.644 15.256 10.172 14.716 10.172 13.636V12.688C10.932 12.688 11.54 12.62 11.996 12.484C12.46 12.348 12.812 12.124 13.052 11.812C13.3 11.5 13.46 11.068 13.532 10.516H15.14V9.724H13.592Z"
        fill="#090A14"
      />
      <path
        d="M13.592 9.724H12.592V10.724H13.592V9.724ZM13.592 8.428V7.428H12.592V8.428H13.592ZM15.14 8.428V9.428H16.14V8.428H15.14ZM15.14 7.624H16.14V6.624H15.14V7.624ZM8.612 7.624V6.624H7.612V7.624H8.612ZM8.612 8.428H7.612V9.428H8.612V8.428ZM12.56 8.428H13.56V7.428H12.56V8.428ZM12.56 9.724V10.724H13.56V9.724H12.56ZM8.612 9.724V8.724H7.612V9.724H8.612ZM8.612 10.516H7.612V11.516H8.612V10.516ZM12.512 10.516L13.5034 10.6469L13.6528 9.516H12.512V10.516ZM12.128 11.452L12.8205 12.1734L12.8279 12.1663L12.8351 12.1591L12.128 11.452ZM11.168 11.836L11.2966 12.8277L11.3043 12.8267L11.3119 12.8256L11.168 11.836ZM9.152 11.92V10.92H8.152V11.92H9.152ZM9.764 15.46L9.0307 16.14L9.03735 16.147L9.764 15.46ZM13.988 13.696L14.988 13.706L14.998 12.696H13.988V13.696ZM12.98 13.696V12.696H11.98V13.696H12.98ZM10.172 12.688V11.688H9.172V12.688H10.172ZM11.996 12.484L11.7147 11.5244L11.7102 11.5257L11.996 12.484ZM13.052 11.812L12.2692 11.1898L12.2642 11.196L12.2594 11.2023L13.052 11.812ZM13.532 10.516V9.516H12.654L12.5404 10.3867L13.532 10.516ZM15.14 10.516V11.516H16.14V10.516H15.14ZM15.14 9.724H16.14V8.724H15.14V9.724ZM20 12C20 16.4183 16.4183 20 12 20V22C17.5228 22 22 17.5228 22 12H20ZM12 4C16.4183 4 20 7.58172 20 12H22C22 6.47715 17.5228 2 12 2V4ZM4 12C4 7.58172 7.58172 4 12 4V2C6.47715 2 2 6.47715 2 12H4ZM12 20C7.58172 20 4 16.4183 4 12H2C2 17.5228 6.47715 22 12 22V20ZM12.592 9.52V9.724H14.592V9.52H12.592ZM12.592 8.428V9.52H14.592V8.428H12.592ZM15.14 7.428H13.592V9.428H15.14V7.428ZM14.14 7.624V8.428H16.14V7.624H14.14ZM8.612 8.624H15.14V6.624H8.612V8.624ZM9.612 8.428V7.624H7.612V8.428H9.612ZM12.56 7.428H8.612V9.428H12.56V7.428ZM13.56 9.508V8.428H11.56V9.508H13.56ZM13.56 9.724V9.508H11.56V9.724H13.56ZM8.612 10.724H12.56V8.724H8.612V10.724ZM9.612 10.516V9.724H7.612V10.516H9.612ZM12.512 9.516H8.612V11.516H12.512V9.516ZM12.8351 12.1591C13.2524 11.7419 13.4326 11.1829 13.5034 10.6469L11.5206 10.3851C11.4794 10.6971 11.4036 10.7621 11.4209 10.7449L12.8351 12.1591ZM11.3119 12.8256C11.8437 12.7482 12.4039 12.5734 12.8205 12.1734L11.4355 10.7306C11.4478 10.7188 11.4353 10.7361 11.3666 10.7635C11.2973 10.7912 11.1873 10.8227 11.0241 10.8464L11.3119 12.8256ZM9.152 12.92C10.0711 12.92 10.797 12.8925 11.2966 12.8277L11.0394 10.8443C10.675 10.8915 10.0569 10.92 9.152 10.92V12.92ZM10.152 13.612V11.92H8.152V13.612H10.152ZM10.4973 14.7801C10.3097 14.5778 10.152 14.2345 10.152 13.612H8.152C8.152 14.5735 8.40229 15.4622 9.03073 16.1399L10.4973 14.7801ZM11.576 15.12C10.9701 15.12 10.6643 14.9567 10.4906 14.773L9.03735 16.147C9.69566 16.8433 10.5979 17.12 11.576 17.12V15.12ZM12.6518 14.7941C12.4763 14.9661 12.1683 15.12 11.576 15.12V17.12C12.5197 17.12 13.3957 16.8659 14.0522 16.2219L12.6518 14.7941ZM12.988 13.686C12.9817 14.322 12.8169 14.6322 12.6518 14.7941L14.0522 16.2219C14.7191 15.5678 14.9783 14.67 14.988 13.706L12.988 13.686ZM12.98 14.696H13.988V12.696H12.98V14.696ZM11.588 16.256C12.2375 16.256 12.899 16.0688 13.3781 15.5318C13.838 15.0165 13.98 14.3438 13.98 13.696H11.98C11.98 14.0882 11.89 14.1955 11.8859 14.2002C11.8851 14.2011 11.8793 14.2097 11.8471 14.2217C11.809 14.236 11.7291 14.256 11.588 14.256V16.256ZM9.172 13.636C9.172 14.2996 9.3141 14.984 9.77308 15.5091C10.2545 16.0599 10.9242 16.256 11.588 16.256V14.256C11.445 14.256 11.3639 14.2353 11.3248 14.2204C11.2917 14.2078 11.2832 14.1978 11.2789 14.1929C11.2659 14.178 11.172 14.0524 11.172 13.636H9.172ZM9.172 12.688V13.636H11.172V12.688H9.172ZM11.7102 11.5257C11.3853 11.6226 10.8856 11.688 10.172 11.688V13.688C10.9784 13.688 11.6947 13.6174 12.2818 13.4423L11.7102 11.5257ZM12.2594 11.2023C12.1756 11.3113 12.0227 11.4341 11.7147 11.5244L12.2773 13.4436C12.8973 13.2619 13.4484 12.9367 13.8446 12.4217L12.2594 11.2023ZM12.5404 10.3867C12.483 10.8267 12.3678 11.0657 12.2692 11.1898L13.8348 12.4342C14.2322 11.9343 14.437 11.3093 14.5236 10.6453L12.5404 10.3867ZM15.14 9.516H13.532V11.516H15.14V9.516ZM14.14 9.724V10.516H16.14V9.724H14.14ZM13.592 10.724H15.14V8.724H13.592V10.724Z"
        fill="#090A14"
        mask="url(#path-1-inside-1_3309_6623)"
      />
    </svg>
  );
};

export const BrandSetting = ({ className, fill }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M19.7724 15.3072L19.2038 14.959V14.959L19.7724 15.3072ZM18.9239 16.6928L19.4924 17.041V17.041L18.9239 16.6928ZM4.22764 8.69281L3.65909 8.34467H3.65909L4.22764 8.69281ZM5.07612 7.30717L5.64467 7.65532V7.65532L5.07612 7.30717ZM7.39424 6.72153L7.71298 6.136L7.71298 6.136L7.39424 6.72153ZM4.84877 10.8785L4.53003 11.464H4.53003L4.84877 10.8785ZM16.6058 17.2785L16.287 17.864H16.287L16.6058 17.2785ZM19.1512 13.1215L18.8325 13.7071L19.1512 13.1215ZM5.07612 16.6928L4.50758 17.041H4.50758L5.07612 16.6928ZM4.22763 15.3072L4.79618 14.959H4.79618L4.22763 15.3072ZM18.9239 7.30719L19.4924 6.95904V6.95904L18.9239 7.30719ZM19.7724 8.69283L19.2038 9.04097V9.04097L19.7724 8.69283ZM19.1512 10.8785L19.47 11.464L19.1512 10.8785ZM16.6058 6.72154L16.9245 7.30708V7.30708L16.6058 6.72154ZM4.84877 13.1215L5.16751 13.7071H5.16751L4.84877 13.1215ZM7.39424 17.2785L7.0755 16.6929L7.0755 16.6929L7.39424 17.2785ZM16.5156 6.77065L16.1968 6.18511L16.5156 6.77065ZM7.48444 6.77064L7.1657 7.35617L7.16571 7.35617L7.48444 6.77064ZM16.5156 17.2294L16.8343 16.6438H16.8343L16.5156 17.2294ZM7.48444 17.2294L7.80318 17.8149L7.80318 17.8149L7.48444 17.2294ZM11.1515 4.66667H12.8485V3.33333H11.1515V4.66667ZM12.8485 19.3333H11.1515V20.6667H12.8485V19.3333ZM11.1515 19.3333C10.545 19.3333 10.1212 18.8791 10.1212 18.4H8.78787C8.78787 19.6883 9.88361 20.6667 11.1515 20.6667V19.3333ZM13.8788 18.4C13.8788 18.8791 13.455 19.3333 12.8485 19.3333V20.6667C14.1164 20.6667 15.2121 19.6883 15.2121 18.4H13.8788ZM12.8485 4.66667C13.455 4.66667 13.8788 5.12095 13.8788 5.6H15.2121C15.2121 4.31174 14.1164 3.33333 12.8485 3.33333V4.66667ZM11.1515 3.33333C9.88361 3.33333 8.78787 4.31174 8.78787 5.6H10.1212C10.1212 5.12095 10.545 4.66667 11.1515 4.66667V3.33333ZM19.2038 14.959L18.3553 16.3447L19.4924 17.041L20.3409 15.6553L19.2038 14.959ZM4.79618 9.04096L5.64467 7.65532L4.50758 6.95903L3.65909 8.34467L4.79618 9.04096ZM5.64467 7.65532C5.91901 7.20729 6.56049 7.02672 7.0755 7.30707L7.71298 6.136C6.60468 5.53269 5.17045 5.87652 4.50758 6.95903L5.64467 7.65532ZM5.16751 10.2929C4.6733 10.0239 4.53715 9.46396 4.79618 9.04096L3.65909 8.34467C2.9809 9.4522 3.40094 10.8494 4.53003 11.464L5.16751 10.2929ZM18.3553 16.3447C18.081 16.7927 17.4395 16.9733 16.9245 16.6929L16.287 17.864C17.3953 18.4673 18.8296 18.1235 19.4924 17.041L18.3553 16.3447ZM20.3409 15.6553C21.0191 14.5478 20.5991 13.1506 19.47 12.536L18.8325 13.7071C19.3267 13.9761 19.4628 14.536 19.2038 14.959L20.3409 15.6553ZM5.64467 16.3447L4.79618 14.959L3.65909 15.6553L4.50758 17.041L5.64467 16.3447ZM18.3553 7.65533L19.2038 9.04097L20.3409 8.34468L19.4924 6.95904L18.3553 7.65533ZM19.2038 9.04097C19.4628 9.46398 19.3267 10.0239 18.8325 10.2929L19.47 11.464C20.5991 10.8494 21.0191 9.45221 20.3409 8.34468L19.2038 9.04097ZM16.9245 7.30708C17.4395 7.02673 18.081 7.2073 18.3553 7.65533L19.4924 6.95904C18.8296 5.87653 17.3953 5.5327 16.287 6.13601L16.9245 7.30708ZM4.79618 14.959C4.53715 14.536 4.6733 13.9761 5.16751 13.7071L4.53003 12.536C3.40094 13.1506 2.9809 14.5478 3.65909 15.6553L4.79618 14.959ZM4.50758 17.041C5.17045 18.1235 6.60468 18.4673 7.71297 17.864L7.0755 16.6929C6.56049 16.9733 5.91901 16.7927 5.64467 16.3447L4.50758 17.041ZM16.8343 7.35618L16.9245 7.30708L16.287 6.13601L16.1968 6.18511L16.8343 7.35618ZM7.0755 7.30707L7.1657 7.35617L7.80318 6.18511L7.71298 6.136L7.0755 7.30707ZM16.9245 16.6929L16.8343 16.6438L16.1968 17.8149L16.287 17.864L16.9245 16.6929ZM7.16571 16.6438L7.0755 16.6929L7.71297 17.864L7.80318 17.8149L7.16571 16.6438ZM4.53003 11.464C4.9547 11.6952 4.9547 12.3048 4.53003 12.536L5.16751 13.7071C6.51998 12.9709 6.51999 11.0292 5.16751 10.2929L4.53003 11.464ZM7.80318 17.8149C8.2471 17.5732 8.78787 17.8946 8.78787 18.4H10.1212C10.1212 16.883 8.49809 15.9185 7.1657 16.6438L7.80318 17.8149ZM15.2121 18.4C15.2121 17.8946 15.7529 17.5732 16.1968 17.8149L16.8343 16.6438C15.5019 15.9185 13.8788 16.883 13.8788 18.4H15.2121ZM19.47 12.536C19.0453 12.3048 19.0453 11.6952 19.47 11.464L18.8325 10.2929C17.48 11.0292 17.48 12.9708 18.8325 13.7071L19.47 12.536ZM7.16571 7.35617C8.49809 8.08146 10.1212 7.117 10.1212 5.6H8.78787C8.78787 6.10542 8.2471 6.42675 7.80318 6.18511L7.16571 7.35617ZM16.1968 6.18511C15.7529 6.42676 15.2121 6.10543 15.2121 5.6H13.8788C13.8788 7.11701 15.5019 8.08147 16.8343 7.35618L16.1968 6.18511ZM14 12C14 13.1046 13.1046 14 12 14V15.3333C13.841 15.3333 15.3333 13.8409 15.3333 12H14ZM12 14C10.8954 14 10 13.1046 10 12H8.66667C8.66667 13.8409 10.1591 15.3333 12 15.3333V14ZM10 12C10 10.8954 10.8954 10 12 10V8.66667C10.1591 8.66667 8.66667 10.1591 8.66667 12H10ZM12 10C13.1046 10 14 10.8954 14 12H15.3333C15.3333 10.1591 13.841 8.66667 12 8.66667V10Z"
        fill="#5A5B62"
      />
    </svg>
  );
};
export const BrandSettingActive = ({ className, fill }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.1515 4H12.8485C13.7857 4 14.5455 4.71634 14.5455 5.6C14.5455 6.61122 15.6274 7.25412 16.5156 6.77065L16.6058 6.72154C17.4174 6.27972 18.4553 6.54192 18.9239 7.30719L19.7724 8.69283C20.241 9.45809 19.9629 10.4366 19.1512 10.8785C18.2627 11.3622 18.2627 12.6378 19.1512 13.1215C19.9629 13.5634 20.241 14.5419 19.7724 15.3072L18.9239 16.6928C18.4553 17.4581 17.4174 17.7203 16.6058 17.2785L16.5156 17.2294C15.6274 16.7459 14.5455 17.3888 14.5455 18.4C14.5455 19.2837 13.7857 20 12.8485 20H11.1515C10.2143 20 9.45454 19.2837 9.45454 18.4C9.45454 17.3888 8.37259 16.7459 7.48444 17.2294L7.39424 17.2785C6.58258 17.7203 5.54473 17.4581 5.07612 16.6928L4.22763 15.3072C3.75903 14.5419 4.03712 13.5634 4.84877 13.1215C5.73734 12.6378 5.73734 11.3622 4.84877 10.8785C4.03712 10.4366 3.75903 9.45808 4.22764 8.69281L5.07612 7.30717C5.54473 6.54191 6.58259 6.27971 7.39424 6.72153L7.48444 6.77064C8.37259 7.25411 9.45454 6.61121 9.45454 5.6C9.45454 4.71634 10.2143 4 11.1515 4ZM12 14.6667C13.4728 14.6667 14.6667 13.4728 14.6667 12C14.6667 10.5272 13.4728 9.33333 12 9.33333C10.5272 9.33333 9.33334 10.5272 9.33334 12C9.33334 13.4728 10.5272 14.6667 12 14.6667Z"
        fill="#090A14"
      />
      <path
        d="M19.7724 15.3072L19.2038 14.959V14.959L19.7724 15.3072ZM18.9239 16.6928L19.4924 17.041V17.041L18.9239 16.6928ZM4.22764 8.69281L3.65909 8.34467L3.65909 8.34467L4.22764 8.69281ZM5.07612 7.30717L5.64467 7.65532L5.07612 7.30717ZM7.39424 6.72153L7.71298 6.136L7.71298 6.136L7.39424 6.72153ZM4.84877 10.8785L4.53003 11.464H4.53003L4.84877 10.8785ZM16.6058 17.2785L16.287 17.864L16.287 17.864L16.6058 17.2785ZM19.1512 13.1215L18.8325 13.7071L18.8325 13.7071L19.1512 13.1215ZM5.07612 16.6928L4.50758 17.041H4.50758L5.07612 16.6928ZM4.22763 15.3072L4.79618 14.959H4.79618L4.22763 15.3072ZM18.9239 7.30719L19.4924 6.95904V6.95904L18.9239 7.30719ZM19.7724 8.69283L19.2038 9.04097V9.04097L19.7724 8.69283ZM19.1512 10.8785L19.47 11.464H19.47L19.1512 10.8785ZM16.6058 6.72154L16.287 6.13601V6.13601L16.6058 6.72154ZM4.84877 13.1215L5.16751 13.7071H5.16751L4.84877 13.1215ZM7.39424 17.2785L7.0755 16.6929L7.0755 16.6929L7.39424 17.2785ZM16.5156 6.77065L16.8343 7.35618L16.8343 7.35618L16.5156 6.77065ZM7.48444 6.77064L7.1657 7.35617L7.16571 7.35617L7.48444 6.77064ZM16.5156 17.2294L16.8343 16.6438L16.8343 16.6438L16.5156 17.2294ZM7.48444 17.2294L7.80318 17.8149L7.80318 17.8149L7.48444 17.2294ZM11.1515 4.66667H12.8485V3.33333H11.1515V4.66667ZM12.8485 19.3333H11.1515V20.6667H12.8485V19.3333ZM11.1515 19.3333C10.545 19.3333 10.1212 18.8791 10.1212 18.4H8.78787C8.78787 19.6883 9.88361 20.6667 11.1515 20.6667V19.3333ZM13.8788 18.4C13.8788 18.8791 13.455 19.3333 12.8485 19.3333V20.6667C14.1164 20.6667 15.2121 19.6883 15.2121 18.4H13.8788ZM12.8485 4.66667C13.455 4.66667 13.8788 5.12095 13.8788 5.6H15.2121C15.2121 4.31174 14.1164 3.33333 12.8485 3.33333V4.66667ZM11.1515 3.33333C9.88361 3.33333 8.78787 4.31174 8.78787 5.6H10.1212C10.1212 5.12095 10.545 4.66667 11.1515 4.66667V3.33333ZM19.2038 14.959L18.3553 16.3447L19.4924 17.041L20.3409 15.6553L19.2038 14.959ZM4.79618 9.04096L5.64467 7.65532L4.50758 6.95903L3.65909 8.34467L4.79618 9.04096ZM5.64467 7.65532C5.91901 7.20729 6.56049 7.02672 7.0755 7.30707L7.71298 6.136C6.60468 5.53269 5.17045 5.87652 4.50758 6.95903L5.64467 7.65532ZM5.16751 10.2929C4.6733 10.0239 4.53715 9.46396 4.79618 9.04096L3.65909 8.34467C2.9809 9.4522 3.40094 10.8494 4.53003 11.464L5.16751 10.2929ZM18.3553 16.3447C18.081 16.7927 17.4395 16.9733 16.9245 16.6929L16.287 17.864C17.3953 18.4673 18.8296 18.1235 19.4924 17.041L18.3553 16.3447ZM20.3409 15.6553C21.0191 14.5478 20.5991 13.1506 19.47 12.536L18.8325 13.7071C19.3267 13.9761 19.4628 14.536 19.2038 14.959L20.3409 15.6553ZM5.64467 16.3447L4.79618 14.959L3.65909 15.6553L4.50758 17.041L5.64467 16.3447ZM18.3553 7.65533L19.2038 9.04097L20.3409 8.34468L19.4924 6.95904L18.3553 7.65533ZM19.2038 9.04097C19.4628 9.46398 19.3267 10.0239 18.8325 10.2929L19.47 11.464C20.5991 10.8494 21.0191 9.45221 20.3409 8.34468L19.2038 9.04097ZM16.9245 7.30708C17.4395 7.02673 18.081 7.2073 18.3553 7.65533L19.4924 6.95904C18.8296 5.87653 17.3953 5.5327 16.287 6.13601L16.9245 7.30708ZM4.79618 14.959C4.53715 14.536 4.6733 13.9761 5.16751 13.7071L4.53003 12.536C3.40094 13.1506 2.9809 14.5478 3.65909 15.6553L4.79618 14.959ZM4.50758 17.041C5.17045 18.1235 6.60468 18.4673 7.71297 17.864L7.0755 16.6929C6.56049 16.9733 5.91901 16.7927 5.64467 16.3447L4.50758 17.041ZM16.8343 7.35618L16.9245 7.30708L16.287 6.13601L16.1968 6.18511L16.8343 7.35618ZM7.0755 7.30707L7.1657 7.35617L7.80318 6.18511L7.71298 6.136L7.0755 7.30707ZM16.9245 16.6929L16.8343 16.6438L16.1968 17.8149L16.287 17.864L16.9245 16.6929ZM7.16571 16.6438L7.0755 16.6929L7.71297 17.864L7.80318 17.8149L7.16571 16.6438ZM4.53003 11.464C4.9547 11.6952 4.9547 12.3048 4.53003 12.536L5.16751 13.7071C6.51998 12.9709 6.51999 11.0292 5.16751 10.2929L4.53003 11.464ZM7.80318 17.8149C8.2471 17.5732 8.78787 17.8946 8.78787 18.4H10.1212C10.1212 16.883 8.49809 15.9185 7.16571 16.6438L7.80318 17.8149ZM15.2121 18.4C15.2121 17.8946 15.7529 17.5732 16.1968 17.8149L16.8343 16.6438C15.5019 15.9185 13.8788 16.883 13.8788 18.4H15.2121ZM19.47 12.536C19.0453 12.3048 19.0453 11.6952 19.47 11.464L18.8325 10.2929C17.48 11.0292 17.48 12.9708 18.8325 13.7071L19.47 12.536ZM7.16571 7.35617C8.49809 8.08146 10.1212 7.117 10.1212 5.6H8.78787C8.78787 6.10542 8.2471 6.42675 7.80318 6.18511L7.16571 7.35617ZM16.1968 6.18511C15.7529 6.42676 15.2121 6.10543 15.2121 5.6H13.8788C13.8788 7.11701 15.5019 8.08147 16.8343 7.35618L16.1968 6.18511ZM14 12C14 13.1046 13.1046 14 12 14V15.3333C13.841 15.3333 15.3333 13.8409 15.3333 12H14ZM12 14C10.8954 14 10 13.1046 10 12H8.66667C8.66667 13.8409 10.1591 15.3333 12 15.3333V14ZM10 12C10 10.8954 10.8954 10 12 10V8.66667C10.1591 8.66667 8.66667 10.1591 8.66667 12H10ZM12 10C13.1046 10 14 10.8954 14 12H15.3333C15.3333 10.1591 13.841 8.66667 12 8.66667V10Z"
        fill="#090A14"
      />
    </svg>
  );
};

export const CompanyIcon = ({ className, fill }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M17.2143 10.7143H15.4286V6.78571C15.4286 6.31211 15.2404 5.85791 14.9055 5.52302C14.5707 5.18814 14.1165 5 13.6429 5H9.35714C8.88354 5 8.42934 5.18814 8.09445 5.52302C7.75957 5.85791 7.57143 6.31211 7.57143 6.78571V8.57143H5.78571C5.31211 8.57143 4.85791 8.75957 4.52302 9.09445C4.18814 9.42934 4 9.88354 4 10.3571V19.6429C4 19.7376 4.03763 19.8284 4.1046 19.8954C4.17158 19.9624 4.26242 20 4.35714 20H18.6429C18.7376 20 18.8284 19.9624 18.8954 19.8954C18.9624 19.8284 19 19.7376 19 19.6429V12.5C19 12.0264 18.8119 11.5722 18.477 11.2373C18.1421 10.9024 17.6879 10.7143 17.2143 10.7143ZM4.71429 10.3571C4.71429 10.073 4.82717 9.80046 5.0281 9.59953C5.22903 9.3986 5.50155 9.28571 5.78571 9.28571H7.57143V19.2857H4.71429V10.3571ZM8.28571 8.92857V6.78571C8.28571 6.50155 8.3986 6.22903 8.59953 6.0281C8.80046 5.82717 9.07298 5.71429 9.35714 5.71429H13.6429C13.927 5.71429 14.1995 5.82717 14.4005 6.0281C14.6014 6.22903 14.7143 6.50155 14.7143 6.78571V19.2857H13.2857V16.0714C13.2857 15.7873 13.1728 15.5147 12.9719 15.3138C12.771 15.1129 12.4984 15 12.2143 15H10.7857C10.5016 15 10.229 15.1129 10.0281 15.3138C9.82717 15.5147 9.71429 15.7873 9.71429 16.0714V19.2857H8.28571V8.92857ZM10.4286 19.2857V16.0714C10.4286 15.9767 10.4662 15.8859 10.5332 15.8189C10.6002 15.7519 10.691 15.7143 10.7857 15.7143H12.2143C12.309 15.7143 12.3998 15.7519 12.4668 15.8189C12.5338 15.8859 12.5714 15.9767 12.5714 16.0714V19.2857H10.4286ZM18.2857 19.2857H15.4286V11.4286H17.2143C17.4984 11.4286 17.771 11.5415 17.9719 11.7424C18.1728 11.9433 18.2857 12.2158 18.2857 12.5V19.2857Z"
        fill="#5A5B62"
        stroke="#5A5B62"
        strokeWidth="0.5"
      />
    </svg>
  );
};
export const CompanyIconActive = ({ className, fill }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M17.2143 10.7143H15.4286V6.78571C15.4286 6.31211 15.2404 5.85791 14.9055 5.52302C14.5707 5.18814 14.1165 5 13.6429 5H9.35714C8.88354 5 8.42934 5.18814 8.09445 5.52302C7.75957 5.85791 7.57143 6.31211 7.57143 6.78571V8.57143H5.78571C5.31211 8.57143 4.85791 8.75957 4.52302 9.09445C4.18814 9.42934 4 9.88354 4 10.3571V19.6429C4 19.7376 4.03763 19.8284 4.1046 19.8954C4.17158 19.9624 4.26242 20 4.35714 20H18.6429C18.7376 20 18.8284 19.9624 18.8954 19.8954C18.9624 19.8284 19 19.7376 19 19.6429V12.5C19 12.0264 18.8119 11.5722 18.477 11.2373C18.1421 10.9024 17.6879 10.7143 17.2143 10.7143ZM4.71429 10.3571C4.71429 10.073 4.82717 9.80046 5.0281 9.59953C5.22903 9.3986 5.50155 9.28571 5.78571 9.28571H7.57143V19.2857H4.71429V10.3571ZM8.28571 8.92857V6.78571C8.28571 6.50155 8.3986 6.22903 8.59953 6.0281C8.80046 5.82717 9.07298 5.71429 9.35714 5.71429H13.6429C13.927 5.71429 14.1995 5.82717 14.4005 6.0281C14.6014 6.22903 14.7143 6.50155 14.7143 6.78571V19.2857H13.2857V16.0714C13.2857 15.7873 13.1728 15.5147 12.9719 15.3138C12.771 15.1129 12.4984 15 12.2143 15H10.7857C10.5016 15 10.229 15.1129 10.0281 15.3138C9.82717 15.5147 9.71429 15.7873 9.71429 16.0714V19.2857H8.28571V8.92857ZM10.4286 19.2857V16.0714C10.4286 15.9767 10.4662 15.8859 10.5332 15.8189C10.6002 15.7519 10.691 15.7143 10.7857 15.7143H12.2143C12.309 15.7143 12.3998 15.7519 12.4668 15.8189C12.5338 15.8859 12.5714 15.9767 12.5714 16.0714V19.2857H10.4286ZM18.2857 19.2857H15.4286V11.4286H17.2143C17.4984 11.4286 17.771 11.5415 17.9719 11.7424C18.1728 11.9433 18.2857 12.2158 18.2857 12.5V19.2857Z"
        fill="#090A14"
      />
      <path
        d="M8.28571 8.92857V6.78571C8.28571 6.50155 8.3986 6.22903 8.59953 6.0281C8.80046 5.82717 9.07298 5.71429 9.35714 5.71429H13.6429C13.927 5.71429 14.1995 5.82717 14.4005 6.0281C14.6014 6.22903 14.7143 6.50155 14.7143 6.78571V19.2857H13.2857V16.0714C13.2857 15.7873 13.1728 15.5147 12.9719 15.3138C12.771 15.1129 12.4984 15 12.2143 15H10.7857C10.5016 15 10.229 15.1129 10.0281 15.3138C9.82717 15.5147 9.71429 15.7873 9.71429 16.0714V19.2857H8.28571V8.92857Z"
        fill="#090A14"
      />
      <path
        d="M17.2143 10.7143H15.4286V6.78571C15.4286 6.31211 15.2404 5.85791 14.9055 5.52302C14.5707 5.18814 14.1165 5 13.6429 5H9.35714C8.88354 5 8.42934 5.18814 8.09445 5.52302C7.75957 5.85791 7.57143 6.31211 7.57143 6.78571V8.57143H5.78571C5.31211 8.57143 4.85791 8.75957 4.52302 9.09445C4.18814 9.42934 4 9.88354 4 10.3571V19.6429C4 19.7376 4.03763 19.8284 4.1046 19.8954C4.17158 19.9624 4.26242 20 4.35714 20H18.6429C18.7376 20 18.8284 19.9624 18.8954 19.8954C18.9624 19.8284 19 19.7376 19 19.6429V12.5C19 12.0264 18.8119 11.5722 18.477 11.2373C18.1421 10.9024 17.6879 10.7143 17.2143 10.7143ZM4.71429 10.3571C4.71429 10.073 4.82717 9.80046 5.0281 9.59953C5.22903 9.3986 5.50155 9.28571 5.78571 9.28571H7.57143V19.2857H4.71429V10.3571ZM8.28571 8.92857V6.78571C8.28571 6.50155 8.3986 6.22903 8.59953 6.0281C8.80046 5.82717 9.07298 5.71429 9.35714 5.71429H13.6429C13.927 5.71429 14.1995 5.82717 14.4005 6.0281C14.6014 6.22903 14.7143 6.50155 14.7143 6.78571V19.2857H13.2857V16.0714C13.2857 15.7873 13.1728 15.5147 12.9719 15.3138C12.771 15.1129 12.4984 15 12.2143 15H10.7857C10.5016 15 10.229 15.1129 10.0281 15.3138C9.82717 15.5147 9.71429 15.7873 9.71429 16.0714V19.2857H8.28571V8.92857ZM10.4286 19.2857V16.0714C10.4286 15.9767 10.4662 15.8859 10.5332 15.8189C10.6002 15.7519 10.691 15.7143 10.7857 15.7143H12.2143C12.309 15.7143 12.3998 15.7519 12.4668 15.8189C12.5338 15.8859 12.5714 15.9767 12.5714 16.0714V19.2857H10.4286ZM18.2857 19.2857H15.4286V11.4286H17.2143C17.4984 11.4286 17.771 11.5415 17.9719 11.7424C18.1728 11.9433 18.2857 12.2158 18.2857 12.5V19.2857Z"
        stroke="#090A14"
        strokeWidth="0.5"
      />
      <path
        d="M8.28571 8.92857V6.78571C8.28571 6.50155 8.3986 6.22903 8.59953 6.0281C8.80046 5.82717 9.07298 5.71429 9.35714 5.71429H13.6429C13.927 5.71429 14.1995 5.82717 14.4005 6.0281C14.6014 6.22903 14.7143 6.50155 14.7143 6.78571V19.2857H13.2857V16.0714C13.2857 15.7873 13.1728 15.5147 12.9719 15.3138C12.771 15.1129 12.4984 15 12.2143 15H10.7857C10.5016 15 10.229 15.1129 10.0281 15.3138C9.82717 15.5147 9.71429 15.7873 9.71429 16.0714V19.2857H8.28571V8.92857Z"
        stroke="#090A14"
        strokeWidth="0.5"
      />
    </svg>
  );
};
export const UserProfileIcon = ({ className, fill }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.60465 6.97674C9.60465 5.47402 10.8229 4.25581 12.3256 4.25581C13.8283 4.25581 15.0465 5.47402 15.0465 6.97674C15.0465 8.47947 13.8283 9.69767 12.3256 9.69767C10.8229 9.69767 9.60465 8.47947 9.60465 6.97674ZM12.3256 3C10.1293 3 8.34884 4.78045 8.34884 6.97674C8.34884 9.17304 10.1293 10.9535 12.3256 10.9535C14.5219 10.9535 16.3023 9.17304 16.3023 6.97674C16.3023 4.78045 14.5219 3 12.3256 3ZM9.64651 13.0465C7.08031 13.0465 5 15.1268 5 17.693C5 19.5194 6.48058 21 8.30698 21H16.3442C18.1706 21 19.6512 19.5194 19.6512 17.693C19.6512 15.1268 17.5708 13.0465 15.0047 13.0465H9.64651ZM6.25581 17.693C6.25581 15.8204 7.77388 14.3023 9.64651 14.3023H15.0047C16.8773 14.3023 18.3953 15.8204 18.3953 17.693C18.3953 18.8258 17.477 19.7442 16.3442 19.7442H8.30698C7.17415 19.7442 6.25581 18.8258 6.25581 17.693Z"
        fill="#5A5B62"
      />
    </svg>
  );
};
export const UserProfileIconActive = ({ className, fill }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.3257 10.3256C14.1752 10.3256 15.6745 8.82626 15.6745 6.97674C15.6745 5.12723 14.1752 3.62791 12.3257 3.62791C10.4762 3.62791 8.97686 5.12723 8.97686 6.97674C8.97686 8.82626 10.4762 10.3256 12.3257 10.3256ZM9.64663 13.6744C7.42721 13.6744 5.62802 15.4736 5.62802 17.693C5.62802 19.1726 6.82748 20.3721 8.30709 20.3721H16.3443C17.8239 20.3721 19.0234 19.1726 19.0234 17.693C19.0234 15.4736 17.2242 13.6744 15.0048 13.6744H9.64663Z"
        fill="#090A14"
      />
    </svg>
  );
};
export const AssignmentIcon = ({ className, fill }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M18.4801 16.7836H16.0961M17.2881 15.6156V18.0076M20.4881 16.7996C20.4881 17.3996 20.3201 17.9676 20.0241 18.4476C19.8561 18.7356 19.6401 18.9916 19.3921 19.1996C18.8321 19.7036 18.0961 19.9996 17.2881 19.9996C16.3121 19.9996 15.4401 19.5596 14.8641 18.8716C14.8481 18.8476 14.8241 18.8316 14.8081 18.8076C14.7121 18.6956 14.6241 18.5756 14.5521 18.4476C14.2476 17.9519 14.087 17.3813 14.0881 16.7996C14.0881 15.7916 14.5521 14.8876 15.2881 14.3036C15.8401 13.8636 16.5361 13.5996 17.2881 13.5996C18.0881 13.5996 18.8081 13.8876 19.3681 14.3756C19.4641 14.4476 19.5521 14.5356 19.6321 14.6236C20.1601 15.1996 20.4881 15.9596 20.4881 16.7996Z"
        stroke="#5A5B62"
        strokeWidth="1.2"
        stroke-miterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.62402 8.35254L11.688 12.4405L18.704 8.37654M11.688 19.6885V12.4325"
        stroke="#5A5B62"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.376 9.736V14.264C19.376 14.304 19.376 14.336 19.368 14.376C18.808 13.888 18.088 13.6 17.288 13.6C16.536 13.6 15.84 13.864 15.288 14.304C14.9125 14.6024 14.6094 14.982 14.4016 15.4143C14.1938 15.8466 14.0866 16.3203 14.088 16.8C14.088 17.4 14.256 17.968 14.552 18.448C14.624 18.576 14.712 18.696 14.808 18.808L13.344 19.616C12.432 20.128 10.944 20.128 10.032 19.616L5.76 17.248C4.792 16.712 4 15.368 4 14.264V9.736C4 8.632 4.792 7.288 5.76 6.752L10.032 4.384C10.944 3.872 12.432 3.872 13.344 4.384L17.616 6.752C18.584 7.288 19.376 8.632 19.376 9.736Z"
        stroke="#5A5B62"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const AssignmentIconActive = ({ className, fill }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="24"
      height="24"
      color="#000000"
      fill="none">
      <path
        d="M7.99805 16H11.998M7.99805 11H15.998"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M7.5 3.5C5.9442 3.54667 5.01661 3.71984 4.37477 4.36227C3.49609 5.24177 3.49609 6.6573 3.49609 9.48836L3.49609 15.9944C3.49609 18.8255 3.49609 20.241 4.37477 21.1205C5.25345 22 6.66767 22 9.49609 22L14.4961 22C17.3245 22 18.7387 22 19.6174 21.1205C20.4961 20.241 20.4961 18.8255 20.4961 15.9944V9.48836C20.4961 6.6573 20.4961 5.24177 19.6174 4.36228C18.9756 3.71984 18.048 3.54667 16.4922 3.5"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path
        d="M7.49609 3.75C7.49609 2.7835 8.2796 2 9.24609 2H14.7461C15.7126 2 16.4961 2.7835 16.4961 3.75C16.4961 4.7165 15.7126 5.5 14.7461 5.5H9.24609C8.2796 5.5 7.49609 4.7165 7.49609 3.75Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const SearchFilterIcon = (fill) => {
  return;
};

export const youtubeNewIcon = (fill) => {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <rect
        x="24"
        y="0.5"
        width="24"
        height="24"
        rx="4"
        transform="rotate(90 24 0.5)"
        fill="#FF3000"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.1889 7.13139C18.9033 7.32432 19.4649 7.88728 19.6547 8.60088C20 9.89593 20 12.5997 20 12.5997C20 12.5997 20 15.3035 19.6547 16.5985C19.4622 17.3148 18.9007 17.8777 18.1889 18.068C16.8972 18.4142 11.7143 18.4142 11.7143 18.4142C11.7143 18.4142 6.53408 18.4142 5.23969 18.068C4.52527 17.8751 3.96375 17.3121 3.77394 16.5985C3.42859 15.3035 3.42859 12.5997 3.42859 12.5997C3.42859 12.5997 3.42859 9.89593 3.77394 8.60088C3.96638 7.88463 4.5279 7.32168 5.23969 7.13139C6.53408 6.78516 11.7143 6.78516 11.7143 6.78516C11.7143 6.78516 16.8972 6.78516 18.1889 7.13139ZM14.3637 12.5997L10.0587 15.092V10.1074L14.3637 12.5997Z"
        fill="white"
      />
    </svg>
  );
};

export const xAppNewIcon = (fill) => {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_3255_3878)">
        <path
          d="M4 0.5C1.79086 0.5 0 2.29086 0 4.5V20.5C0 22.7091 1.79086 24.5 4 24.5H20C22.2091 24.5 24 22.7091 24 20.5V4.5C24 2.29086 22.2091 0.5 20 0.5H4ZM5.19197 5.64286H9.72768L12.9487 10.2199L16.8571 5.64286H18.2857L13.5938 11.1362L19.3795 19.3571H14.8449L11.1071 14.0469L6.57143 19.3571H5.14286L10.4621 13.1306L5.19197 5.64286ZM7.37946 6.78571L15.4408 18.2143H17.192L9.13058 6.78571H7.37946Z"
          fill="#090A14"
        />
      </g>
      <defs>
        <clipPath id="clip0_3255_3878">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(0 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const facebookNewIcon = (fill) => {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <rect
        x="24"
        y="0.5"
        width="24"
        height="24"
        rx="4"
        transform="rotate(90 24 0.5)"
        fill="#337FFF"
      />
      <path
        d="M15.8184 13.797L16.2921 10.7897H13.3739V8.83499C13.3739 8.0127 13.7813 7.2092 15.0841 7.2092H16.4295V4.64834C15.646 4.52351 14.8543 4.45598 14.0608 4.44629C11.659 4.44629 10.091 5.88883 10.091 8.49668V10.7897H7.42859V13.797H10.091V21.0707H13.3739V13.797H15.8184Z"
        fill="white"
      />
    </svg>
  );
};

export const instagramNewIcon = (fill) => {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <rect
        x="24"
        y="0.5"
        width="24"
        height="24"
        rx="4"
        transform="rotate(90 24 0.5)"
        fill="url(#paint0_linear_3255_3787)"
      />
      <path
        d="M9.26263 12.6738C9.26263 11.064 10.5681 9.75856 12.179 9.75856C13.7898 9.75856 15.096 11.064 15.096 12.6738C15.096 14.2837 13.7898 15.5891 12.179 15.5891C10.5681 15.5891 9.26263 14.2837 9.26263 12.6738ZM7.68575 12.6738C7.68575 15.1539 9.69735 17.1643 12.179 17.1643C14.6606 17.1643 16.6722 15.1539 16.6722 12.6738C16.6722 10.1937 14.6606 8.18332 12.179 8.18332C9.69735 8.18332 7.68575 10.1937 7.68575 12.6738ZM15.8 8.00527C15.7999 8.21282 15.8614 8.41574 15.9767 8.58836C16.092 8.76098 16.256 8.89555 16.4478 8.97506C16.6397 9.05456 16.8508 9.07543 17.0545 9.03502C17.2582 8.99461 17.4453 8.89474 17.5922 8.74803C17.7391 8.60133 17.8392 8.41438 17.8798 8.21083C17.9204 8.00728 17.8997 7.79627 17.8203 7.60448C17.7409 7.41269 17.6064 7.24874 17.4338 7.13336C17.2611 7.01798 17.0581 6.95635 16.8505 6.95627H16.85C16.5717 6.9564 16.3047 7.06695 16.1078 7.26363C15.911 7.46032 15.8002 7.72706 15.8 8.00527ZM8.64381 19.7921C7.79068 19.7533 7.32698 19.6113 7.01883 19.4913C6.61029 19.3324 6.3188 19.1431 6.01233 18.8372C5.70585 18.5313 5.51615 18.2403 5.3578 17.832C5.23767 17.5242 5.09557 17.0606 5.05679 16.208C5.01437 15.2862 5.0059 15.0093 5.0059 12.6739C5.0059 10.3385 5.01507 10.0624 5.05679 9.13982C5.09564 8.28721 5.23879 7.82456 5.3578 7.51582C5.51685 7.10753 5.70627 6.81621 6.01233 6.50992C6.31838 6.20363 6.60959 6.01404 7.01883 5.85579C7.32684 5.73573 7.79068 5.59371 8.64381 5.55495C9.56617 5.51256 9.84324 5.50409 12.179 5.50409C14.5147 5.50409 14.792 5.51326 15.7152 5.55495C16.5683 5.59378 17.0312 5.73685 17.3401 5.85579C17.7487 6.01404 18.0402 6.20405 18.3466 6.50992C18.6531 6.81579 18.8421 7.10753 19.0012 7.51582C19.1213 7.82365 19.2634 8.28721 19.3022 9.13982C19.3446 10.0624 19.3531 10.3385 19.3531 12.6739C19.3531 15.0093 19.3446 15.2854 19.3022 16.208C19.2633 17.0606 19.1205 17.524 19.0012 17.832C18.8421 18.2403 18.6527 18.5316 18.3466 18.8372C18.0406 19.1428 17.7487 19.3324 17.3401 19.4913C17.0321 19.6114 16.5683 19.7534 15.7152 19.7921C14.7928 19.8345 14.5157 19.843 12.179 19.843C9.84219 19.843 9.56589 19.8345 8.64381 19.7921ZM8.57135 3.98167C7.63983 4.02407 7.00329 4.17169 6.4474 4.38786C5.87169 4.61111 5.38433 4.91061 4.89732 5.39656C4.41031 5.88251 4.1114 6.37035 3.88802 6.94571C3.67171 7.50162 3.524 8.13742 3.48158 9.06839C3.43846 10.0008 3.42859 10.2989 3.42859 12.6738C3.42859 15.0487 3.43846 15.3468 3.48158 16.2793C3.524 17.2103 3.67171 17.846 3.88802 18.402C4.1114 18.977 4.41038 19.4654 4.89732 19.9511C5.38426 20.4368 5.87169 20.7359 6.4474 20.9598C7.00434 21.176 7.63983 21.3236 8.57135 21.366C9.50484 21.4084 9.80264 21.419 12.179 21.419C14.5553 21.419 14.8536 21.4091 15.7866 21.366C16.7182 21.3236 17.3543 21.176 17.9105 20.9598C18.4859 20.7359 18.9736 20.437 19.4606 19.9511C19.9476 19.4652 20.2459 18.977 20.4699 18.402C20.6862 17.846 20.8346 17.2102 20.8763 16.2793C20.9188 15.3461 20.9286 15.0487 20.9286 12.6738C20.9286 10.2989 20.9188 10.0008 20.8763 9.06839C20.8339 8.13735 20.6862 7.50127 20.4699 6.94571C20.2459 6.3707 19.9468 5.88328 19.4606 5.39656C18.9743 4.90984 18.4859 4.61111 17.9112 4.38786C17.3543 4.17169 16.7181 4.02337 15.7873 3.98167C14.8543 3.93928 14.556 3.92871 12.1797 3.92871C9.80334 3.92871 9.50484 3.93858 8.57135 3.98167Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id="paint0_linear_3255_3787"
          x1="47.5387"
          y1="24.5"
          x2="23.5387"
          y2="0.499994"
          gradientUnits="userSpaceOnUse">
          <stop stop-color="#FBE18A" />
          <stop offset="0.21" stop-color="#FCBB45" />
          <stop offset="0.38" stop-color="#F75274" />
          <stop offset="0.52" stop-color="#D53692" />
          <stop offset="0.74" stop-color="#8F39CE" />
          <stop offset="1" stop-color="#5B4FE9" />
        </linearGradient>
      </defs>
    </svg>
  );
};
export const GroupLoginPageIcon = (fill) => {
  return;
};

export const greenTickIcon = (fill) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="12" r="9" fill="#0BBA20" />
      <path
        d="M11.0352 15.6446C10.7696 15.6446 10.5135 15.5403 10.3239 15.3506L7.79164 12.8184C7.40279 12.4295 7.40279 11.7941 7.79164 11.4053C8.1805 11.0164 8.81591 11.0164 9.20477 11.4053L11.0067 13.2072L14.7624 9.11015C15.1322 8.70238 15.7676 8.67386 16.1755 9.05326C16.5833 9.42313 16.6118 10.0585 16.2324 10.4664L11.7749 15.3222C11.5947 15.5214 11.3292 15.6446 11.0542 15.6446L11.0352 15.6446Z"
        fill="white"
      />
    </svg>
  );
};

export const pendingTimeIcon = (fill) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="12" r="9" fill="#FFAC05" />
      <path
        d="M12 8.39844V11.9984H15.6"
        stroke="white"
        strokeWidth="0.9"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 18C15.3137 18 18 15.3137 18 12C18 8.68629 15.3137 6 12 6C8.68629 6 6 8.68629 6 12C6 15.3137 8.68629 18 12 18Z"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const sendButtonActive = (fill) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10.8151 10.1978L3.28308 11.4538C3.19649 11.4683 3.11522 11.5053 3.04746 11.5611C2.97971 11.6169 2.92784 11.6896 2.89708 11.7718L0.30008 18.7288C0.0520799 19.3688 0.72108 19.9788 1.33508 19.6718L19.3351 10.6718C19.4598 10.6096 19.5646 10.5138 19.6379 10.3953C19.7112 10.2768 19.75 10.1402 19.75 10.0008C19.75 9.86146 19.7112 9.72487 19.6379 9.60635C19.5646 9.48783 19.4598 9.39207 19.3351 9.32982L1.33508 0.329816C0.72108 0.0228162 0.0520799 0.633816 0.30008 1.27282L2.89808 8.22982C2.92869 8.31223 2.9805 8.38511 3.04827 8.44112C3.11604 8.49713 3.19737 8.53427 3.28408 8.54882L10.8161 9.80382C10.8624 9.81194 10.9044 9.83614 10.9347 9.87217C10.965 9.90821 10.9816 9.95376 10.9816 10.0008C10.9816 10.0479 10.965 10.0934 10.9347 10.1295C10.9044 10.1655 10.8624 10.1897 10.8161 10.1978H10.8151Z"
        fill="#090A14"
      />
    </svg>
  );
};

export const contentInstagramIcon = (fill) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <rect
        x="1.5"
        y="1.5"
        width="21"
        height="21"
        rx="4.5"
        fill="url(#paint0_radial_3701_2328)"
      />
      <rect
        x="1.5"
        y="1.5"
        width="21"
        height="21"
        rx="4.5"
        fill="url(#paint1_radial_3701_2328)"
      />
      <rect
        x="1.5"
        y="1.5"
        width="21"
        height="21"
        rx="4.5"
        fill="url(#paint2_radial_3701_2328)"
      />
      <path
        d="M17.25 7.875C17.25 8.49632 16.7463 9 16.125 9C15.5037 9 15 8.49632 15 7.875C15 7.25368 15.5037 6.75 16.125 6.75C16.7463 6.75 17.25 7.25368 17.25 7.875Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 15.75C14.0711 15.75 15.75 14.0711 15.75 12C15.75 9.92893 14.0711 8.25 12 8.25C9.92893 8.25 8.25 9.92893 8.25 12C8.25 14.0711 9.92893 15.75 12 15.75ZM12 14.25C13.2426 14.25 14.25 13.2426 14.25 12C14.25 10.7574 13.2426 9.75 12 9.75C10.7574 9.75 9.75 10.7574 9.75 12C9.75 13.2426 10.7574 14.25 12 14.25Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.5 11.7C4.5 9.17976 4.5 7.91965 4.99047 6.95704C5.4219 6.11031 6.11031 5.4219 6.95704 4.99047C7.91965 4.5 9.17976 4.5 11.7 4.5H12.3C14.8202 4.5 16.0804 4.5 17.043 4.99047C17.8897 5.4219 18.5781 6.11031 19.0095 6.95704C19.5 7.91965 19.5 9.17976 19.5 11.7V12.3C19.5 14.8202 19.5 16.0804 19.0095 17.043C18.5781 17.8897 17.8897 18.5781 17.043 19.0095C16.0804 19.5 14.8202 19.5 12.3 19.5H11.7C9.17976 19.5 7.91965 19.5 6.95704 19.0095C6.11031 18.5781 5.4219 17.8897 4.99047 17.043C4.5 16.0804 4.5 14.8202 4.5 12.3V11.7ZM11.7 6H12.3C13.5849 6 14.4583 6.00117 15.1334 6.05633C15.7911 6.11006 16.1274 6.20745 16.362 6.32698C16.9265 6.6146 17.3854 7.07354 17.673 7.63803C17.7926 7.87263 17.8899 8.20893 17.9437 8.86656C17.9988 9.54169 18 10.4151 18 11.7V12.3C18 13.5849 17.9988 14.4583 17.9437 15.1334C17.8899 15.7911 17.7926 16.1274 17.673 16.362C17.3854 16.9265 16.9265 17.3854 16.362 17.673C16.1274 17.7926 15.7911 17.8899 15.1334 17.9437C14.4583 17.9988 13.5849 18 12.3 18H11.7C10.4151 18 9.54169 17.9988 8.86656 17.9437C8.20893 17.8899 7.87263 17.7926 7.63803 17.673C7.07354 17.3854 6.6146 16.9265 6.32698 16.362C6.20745 16.1274 6.11006 15.7911 6.05633 15.1334C6.00117 14.4583 6 13.5849 6 12.3V11.7C6 10.4151 6.00117 9.54169 6.05633 8.86656C6.11006 8.20893 6.20745 7.87263 6.32698 7.63803C6.6146 7.07354 7.07354 6.6146 7.63803 6.32698C7.87263 6.20745 8.20893 6.11006 8.86656 6.05633C9.54169 6.00117 10.4151 6 11.7 6Z"
        fill="white"
      />
      <defs>
        <radialGradient
          id="paint0_radial_3701_2328"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(9 17.25) rotate(-55.3758) scale(19.1397)">
          <stop stop-color="#B13589" />
          <stop offset="0.79309" stop-color="#C62F94" />
          <stop offset="1" stop-color="#8A3AC8" />
        </radialGradient>
        <radialGradient
          id="paint1_radial_3701_2328"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(8.25 23.25) rotate(-65.1363) scale(16.9457)">
          <stop stop-color="#E0E8B7" />
          <stop offset="0.444662" stop-color="#FB8A2E" />
          <stop offset="0.71474" stop-color="#E2425C" />
          <stop offset="1" stop-color="#E2425C" stop-opacity="0" />
        </radialGradient>
        <radialGradient
          id="paint2_radial_3701_2328"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(0.375001 2.25) rotate(-8.1301) scale(29.1682 6.23877)">
          <stop offset="0.156701" stop-color="#406ADC" />
          <stop offset="0.467799" stop-color="#6A45BE" />
          <stop offset="1" stop-color="#6A45BE" stop-opacity="0" />
        </radialGradient>
      </defs>
    </svg>
  );
};
export const contentStatusCheckIcon = (fill) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="12" r="9" fill="#009A29" />
      <path
        d="M11.0352 15.6441C10.7696 15.6441 10.5135 15.5398 10.3239 15.3501L7.79164 12.8179C7.40279 12.429 7.40279 11.7936 7.79164 11.4048C8.1805 11.0159 8.81591 11.0159 9.20477 11.4048L11.0067 13.2067L14.7624 9.10966C15.1322 8.70189 15.7676 8.67337 16.1755 9.05277C16.5833 9.42264 16.6118 10.0581 16.2324 10.4659L11.7749 15.3217C11.5947 15.5209 11.3292 15.6441 11.0542 15.6441L11.0352 15.6441Z"
        fill="white"
      />
    </svg>
  );
};
export const contentStatusRejectIcon = (fill) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="12" r="9" fill="#F04248" />
      <path
        d="M12 11.6992V14.6992"
        stroke="white"
        strokeWidth="0.9"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 9.30549L12.006 9.29883"
        stroke="white"
        strokeWidth="0.9"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 18C15.3137 18 18 15.3137 18 12C18 8.68629 15.3137 6 12 6C8.68629 6 6 8.68629 6 12C6 15.3137 8.68629 18 12 18Z"
        stroke="white"
        strokeWidth="0.9"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const icChat = (fill) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6.55 5H16.45C17.8562 5 19 6.14375 19 7.55V13.6437C19 15.05 17.8562 16.1938 16.45 16.1938H15.8313L16.075 18.3125C16.15 18.7625 15.9438 19.1938 15.5688 19.4188C15.4 19.5125 15.2125 19.5688 15.025 19.5688C14.7812 19.5688 14.5375 19.4938 14.3125 19.325L11.125 16.1938H6.55C5.14375 16.1938 4 15.05 4 13.6437V7.55C4 6.14375 5.14375 5 6.55 5Z"
        fill="white"
      />
      <path
        d="M15.3062 9.16211C16.0937 9.16211 16.75 9.79961 16.75 10.6059C16.75 11.3934 16.1125 12.0496 15.3062 12.0496C14.5 12.0496 13.8625 11.4121 13.8625 10.6059C13.8625 9.79961 14.5 9.16211 15.3062 9.16211Z"
        fill="#090A14"
      />
      <path
        d="M11.5 9.16211C12.2875 9.16211 12.9437 9.79961 12.9437 10.6059C12.9437 11.3934 12.3062 12.0496 11.5 12.0496C10.7125 12.0496 10.0562 11.4121 10.0562 10.6059C10.0562 9.79961 10.7125 9.16211 11.5 9.16211Z"
        fill="#090A14"
      />
      <path
        d="M7.6937 9.16211C8.4812 9.16211 9.13745 9.79961 9.13745 10.6059C9.13745 11.3934 8.49995 12.0496 7.6937 12.0496C6.88745 12.0496 6.24995 11.4121 6.24995 10.6059C6.2687 9.79961 6.9062 9.16211 7.6937 9.16211Z"
        fill="#090A14"
      />
    </svg>
  );
};

export const sendButtonNonActive = (fill) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10.815 10.1978L3.28296 11.4538C3.19636 11.4683 3.1151 11.5053 3.04734 11.5611C2.97958 11.6169 2.92772 11.6896 2.89696 11.7718L0.299958 18.7288C0.0519578 19.3688 0.720958 19.9788 1.33496 19.6718L19.335 10.6718C19.4596 10.6096 19.5645 10.5138 19.6378 10.3953C19.7111 10.2768 19.7499 10.1402 19.7499 10.0008C19.7499 9.86146 19.7111 9.72487 19.6378 9.60635C19.5645 9.48783 19.4596 9.39207 19.335 9.32982L1.33496 0.329816C0.720958 0.0228162 0.0519578 0.633816 0.299958 1.27282L2.89796 8.22982C2.92857 8.31223 2.98038 8.38511 3.04815 8.44112C3.11591 8.49713 3.19725 8.53427 3.28396 8.54882L10.816 9.80382C10.8623 9.81194 10.9043 9.83614 10.9346 9.87217C10.9649 9.90821 10.9814 9.95376 10.9814 10.0008C10.9814 10.0479 10.9649 10.0934 10.9346 10.1295C10.9043 10.1655 10.8623 10.1897 10.816 10.1978H10.815Z"
        fill="#B3B3B6"
      />
    </svg>
  );
};

export const messageFallBack = (fill) => {
  return (
    <svg
      width="114"
      height="112"
      viewBox="0 0 114 112"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M113.449 105.314C113.451 106.136 113.292 106.951 112.979 107.712C112.666 108.472 112.207 109.164 111.626 109.746C111.046 110.329 110.356 110.792 109.596 111.107C108.837 111.423 108.023 111.585 107.2 111.586L6.97534 111.789C6.15308 111.791 5.33846 111.631 4.57808 111.318C3.81771 111.005 3.12649 110.546 2.54396 109.965C1.96144 109.385 1.49904 108.695 1.18321 107.936C0.86738 107.177 0.704318 106.363 0.703346 105.541L0.5625 35.07L56.0386 0.241779C56.2868 0.0851728 56.574 0.00140355 56.8675 1.74829e-05C57.1609 -0.00136859 57.4489 0.0796886 57.6986 0.233943L112.008 34.0361L113.308 34.8426V35.9702L113.449 105.314Z"
        fill="#B8D5FB"
      />
      <path
        d="M105.271 6.30664H8.00264C7.77068 6.30664 7.58264 6.49468 7.58264 6.72664V110.81C7.58264 111.042 7.77068 111.23 8.00264 111.23H105.271C105.503 111.23 105.691 111.042 105.691 110.81V6.72664C105.691 6.49468 105.503 6.30664 105.271 6.30664Z"
        fill="white"
      />
      <path
        d="M107.1 111.487L57.3535 73.5571C57.3135 73.5265 57.2812 73.4869 57.2595 73.4415C57.2377 73.396 57.227 73.3461 57.2283 73.2957C57.2296 73.2454 57.2428 73.196 57.2669 73.1518C57.291 73.1075 57.3252 73.0696 57.3668 73.0412L112.807 35.1492C112.855 35.1166 112.91 35.0976 112.968 35.0943C113.026 35.091 113.083 35.1035 113.135 35.1304C113.186 35.1574 113.229 35.1978 113.259 35.2473C113.289 35.2968 113.305 35.3535 113.305 35.4114L113.445 105.28C113.448 106.922 112.807 108.499 111.659 109.672C110.512 110.846 108.95 111.522 107.309 111.556C107.233 111.557 107.16 111.532 107.1 111.487Z"
        fill="#B8D5FB"
      />
      <path
        d="M7.05951 111.685L56.6539 73.5573C56.6939 73.5266 56.7259 73.4868 56.7475 73.4413C56.7691 73.3958 56.7796 73.3458 56.7781 73.2954C56.7766 73.245 56.7631 73.1958 56.7389 73.1516C56.7146 73.1075 56.6802 73.0697 56.6385 73.0414L1.04819 35.3712C1.00029 35.3387 0.944448 35.3199 0.886676 35.3169C0.828904 35.3138 0.771387 35.3265 0.720298 35.3536C0.66921 35.3808 0.626482 35.4213 0.596713 35.471C0.566944 35.5206 0.551253 35.5773 0.551331 35.6352L0.691331 105.504C0.694625 107.145 1.34185 108.72 2.4938 109.889C3.64574 111.057 5.21041 111.728 6.85133 111.755C6.92659 111.756 6.9999 111.731 7.05951 111.685Z"
        fill="#B8D5FB"
      />
      <path
        d="M107.192 111.557L6.96764 111.757C5.45143 111.756 3.98688 111.206 2.84436 110.21C1.70185 109.213 0.958532 107.836 0.751637 106.334C0.717562 106.078 0.747183 105.818 0.837881 105.576C0.928579 105.334 1.07755 105.118 1.2716 104.948L55.9346 56.5865C56.2201 56.3339 56.5879 56.1941 56.9691 56.1934C57.3503 56.1926 57.7187 56.3309 58.0052 56.5823L112.86 104.724C113.055 104.894 113.205 105.109 113.297 105.351C113.388 105.592 113.419 105.853 113.386 106.109C113.185 107.612 112.447 108.991 111.309 109.993C110.171 110.994 108.708 111.549 107.192 111.557Z"
        fill="#95C0F9"
      />
      <path
        d="M32.4801 32.146C34.4261 32.146 36.0036 30.0426 36.0036 27.448C36.0036 24.8534 34.4261 22.75 32.4801 22.75C30.5341 22.75 28.9566 24.8534 28.9566 27.448C28.9566 30.0426 30.5341 32.146 32.4801 32.146Z"
        fill="#95C0F9"
      />
      <path
        d="M81.81 32.146C83.756 32.146 85.3335 30.0426 85.3335 27.448C85.3335 24.8534 83.756 22.75 81.81 22.75C79.864 22.75 78.2865 24.8534 78.2865 27.448C78.2865 30.0426 79.864 32.146 81.81 32.146Z"
        fill="#95C0F9"
      />
      <path
        d="M70.457 47.7233C70.3381 47.7234 70.2211 47.6933 70.1171 47.6357C70.0131 47.5781 69.9255 47.495 69.8625 47.3942C69.8257 47.3358 65.9936 41.4162 57.0871 40.6742C53.38 40.3655 49.862 41.3977 46.6348 43.7434C45.1955 44.7769 43.917 46.0176 42.8408 47.4254C42.7338 47.5761 42.5714 47.6783 42.3892 47.7098C42.2071 47.7412 42.0198 47.6993 41.8685 47.5932C41.7171 47.4871 41.6138 47.3254 41.5812 47.1435C41.5486 46.9615 41.5892 46.774 41.6944 46.6219C41.753 46.5379 43.1613 44.5473 45.7699 42.641C49.2376 40.107 53.1915 38.945 57.2032 39.2786C66.8381 40.0815 70.8823 46.3845 71.0492 46.6523C71.1154 46.7582 71.1521 46.8799 71.1554 47.0048C71.1587 47.1297 71.1286 47.2532 71.0681 47.3625C71.0076 47.4717 70.919 47.5628 70.8114 47.6263C70.7038 47.6898 70.5812 47.7233 70.4563 47.7234L70.457 47.7233Z"
        fill="#95C0F9"
      />
    </svg>
  );
};

export const chatIConsSideBar = ({ fill, className }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.45 5H6.55C5.14375 5 4 6.14375 4 7.55V13.6437C4 15.05 5.14375 16.1938 6.55 16.1938H11.125L14.3125 19.325C14.5375 19.4938 14.7812 19.5688 15.025 19.5688C15.2125 19.5688 15.4 19.5125 15.5688 19.4188C15.9438 19.1938 16.15 18.7625 16.075 18.3125L15.8313 16.1938H16.45C17.8562 16.1938 19 15.05 19 13.6437V7.55C19 6.14375 17.8562 5 16.45 5ZM16.75 10.6059C16.75 9.79961 16.0937 9.16211 15.3062 9.16211C14.5 9.16211 13.8625 9.79961 13.8625 10.6059C13.8625 11.4121 14.5 12.0496 15.3062 12.0496C16.1125 12.0496 16.75 11.3934 16.75 10.6059ZM11.5 9.16211C12.2875 9.16211 12.9437 9.79961 12.9437 10.6059C12.9437 11.3934 12.3062 12.0496 11.5 12.0496C10.7125 12.0496 10.0562 11.4121 10.0562 10.6059C10.0562 9.79961 10.7125 9.16211 11.5 9.16211ZM9.13745 10.6059C9.13745 9.79961 8.4812 9.16211 7.6937 9.16211C6.9062 9.16211 6.2687 9.79961 6.24995 10.6059C6.24995 11.4121 6.88745 12.0496 7.6937 12.0496C8.49995 12.0496 9.13745 11.3934 9.13745 10.6059Z"
        fill="#090A14"
      />
    </svg>
  );
};

export const chatInactiveSideBarIcon = (fill) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6.55 5H16.45C17.8562 5 19 6.14375 19 7.55V13.6437C19 15.05 17.8562 16.1938 16.45 16.1938H15.8313L16.075 18.3125C16.15 18.7625 15.9438 19.1938 15.5688 19.4188C15.4 19.5125 15.2125 19.5688 15.025 19.5688C14.7812 19.5688 14.5375 19.4938 14.3125 19.325L11.125 16.1938H6.55C5.14375 16.1938 4 15.05 4 13.6437V7.55C4 6.14375 5.14375 5 6.55 5ZM4.73125 13.6437C4.73125 14.6375 5.5375 15.4625 6.55 15.4625H11.2563C11.35 15.4625 11.4625 15.4813 11.5375 15.5563L14.7812 18.7812C14.9688 18.9125 15.1375 18.8375 15.1938 18.8C15.25 18.7625 15.4 18.65 15.3625 18.4062L15.0625 15.875C15.0625 15.8562 15.0625 15.8563 15.0625 15.8375C15.0625 15.8188 15.0813 15.7812 15.0813 15.7625C15.0813 15.7438 15.0813 15.7438 15.0813 15.725C15.1 15.6875 15.1 15.6688 15.1187 15.65C15.1375 15.6313 15.1375 15.6125 15.1562 15.6125C15.175 15.5938 15.1937 15.575 15.2125 15.575C15.2312 15.5563 15.25 15.5375 15.2688 15.5375C15.2875 15.5375 15.3062 15.5187 15.3062 15.5187C15.325 15.5187 15.3438 15.5 15.3813 15.5C15.4 15.5 15.4 15.5 15.4187 15.5H16.45C17.4437 15.5 18.2688 14.6938 18.2688 13.6813V7.55C18.2688 6.55625 17.4625 5.73125 16.45 5.73125H6.53125C5.5375 5.73125 4.7125 6.5375 4.7125 7.55V13.6437H4.73125Z"
        fill="#5A5B62"
        stroke="#5A5B62"
        strokeWidth="0.5"
      />
      <path
        d="M15.3062 9.16211C16.0937 9.16211 16.75 9.79961 16.75 10.6059C16.75 11.3934 16.1125 12.0496 15.3062 12.0496C14.5 12.0496 13.8625 11.4121 13.8625 10.6059C13.8625 9.79961 14.5 9.16211 15.3062 9.16211ZM15.3062 11.3184C15.7 11.3184 16.0188 10.9996 16.0188 10.6059C16.0188 10.2121 15.7 9.89336 15.3062 9.89336C14.9125 9.89336 14.5938 10.2121 14.5938 10.6059C14.575 10.9996 14.9125 11.3184 15.3062 11.3184Z"
        fill="#5A5B62"
      />
      <path
        d="M11.5 9.16211C12.2875 9.16211 12.9437 9.79961 12.9437 10.6059C12.9437 11.3934 12.3062 12.0496 11.5 12.0496C10.7125 12.0496 10.0562 11.4121 10.0562 10.6059C10.0562 9.79961 10.7125 9.16211 11.5 9.16211ZM11.5 11.3184C11.8937 11.3184 12.2125 10.9996 12.2125 10.6059C12.2125 10.2121 11.8937 9.89336 11.5 9.89336C11.1062 9.89336 10.7875 10.2121 10.7875 10.6059C10.7875 10.9996 11.1062 11.3184 11.5 11.3184Z"
        fill="#5A5B62"
      />
      <path
        d="M7.6937 9.16211C8.4812 9.16211 9.13745 9.79961 9.13745 10.6059C9.13745 11.3934 8.49995 12.0496 7.6937 12.0496C6.88745 12.0496 6.24995 11.4121 6.24995 10.6059C6.2687 9.79961 6.9062 9.16211 7.6937 9.16211ZM7.6937 11.3184C8.08745 11.3184 8.4062 10.9996 8.4062 10.6059C8.4062 10.2121 8.08745 9.89336 7.6937 9.89336C7.29995 9.89336 6.9812 10.2121 6.9812 10.6059C6.9812 10.9996 7.29995 11.3184 7.6937 11.3184Z"
        fill="#5A5B62"
      />
    </svg>
  );
};

export const bidSearchIcon = (fill) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <ellipse
        cx="8.82491"
        cy="8.8254"
        rx="6.74142"
        ry="6.74142"
        stroke="#090A14"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.5137 13.8652L16.1568 16.5014"
        stroke="#090A14"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const SearchFallBackIcon = (fill) => {
  return (
    <svg
      width="269"
      height="140"
      viewBox="0 0 269 140"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M257.037 1C263.23 1 268.25 6.02004 268.25 12.2126C268.25 18.4051 263.23 23.4251 257.037 23.4251H192.966C199.158 23.4251 204.178 28.4452 204.178 34.6377C204.178 40.8303 199.158 45.8503 192.966 45.8503H228.205C234.398 45.8503 239.418 50.8703 239.418 57.0629C239.418 63.2554 234.398 68.2755 228.205 68.2755H211.909C204.101 68.2755 197.771 73.2955 197.771 79.488C197.771 83.6164 200.975 87.3539 207.382 90.7006C213.574 90.7006 218.594 95.7206 218.594 101.913C218.594 108.106 213.574 113.126 207.382 113.126H74.4326C68.2401 113.126 63.2201 108.106 63.2201 101.913C63.2201 95.7206 68.2401 90.7006 74.4326 90.7006H11.9626C5.77004 90.7006 0.75 85.6806 0.75 79.488C0.75 73.2955 5.77004 68.2755 11.9626 68.2755H76.0344C82.227 68.2755 87.247 63.2554 87.247 57.0629C87.247 50.8703 82.227 45.8503 76.0344 45.8503H35.9895C29.797 45.8503 24.7769 40.8303 24.7769 34.6377C24.7769 28.4452 29.797 23.4251 35.9895 23.4251H100.061C93.8688 23.4251 88.8488 18.4051 88.8488 12.2126C88.8488 6.02004 93.8688 1 100.061 1H257.037ZM257.037 45.8503C263.23 45.8503 268.25 50.8703 268.25 57.0629C268.25 63.2554 263.23 68.2755 257.037 68.2755C250.845 68.2755 245.825 63.2554 245.825 57.0629C245.825 50.8703 250.845 45.8503 257.037 45.8503Z"
        fill="white"
      />
      <path
        d="M118.482 109.922C148.118 109.922 172.142 85.8974 172.142 56.2617C172.142 26.626 148.118 2.60156 118.482 2.60156C88.8463 2.60156 64.8218 26.626 64.8218 56.2617C64.8218 85.8974 88.8463 109.922 118.482 109.922Z"
        fill="#F3F7FF"
        stroke="#65A4F6"
        strokeWidth="4.00449"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M109.884 97.899C112.701 98.419 115.567 98.6892 118.482 98.7097C141.925 98.7097 160.93 79.7052 160.93 56.2621C160.93 32.8189 141.925 13.8145 118.482 13.8145C112.46 13.8145 106.731 15.0685 101.541 17.3298C92.5233 21.2594 85.1354 28.2305 80.6735 36.9474C77.7078 42.7412 76.0347 49.3062 76.0347 56.2621C76.0347 62.5731 77.412 68.5625 79.8824 73.9461C81.6461 77.7895 83.967 81.3242 86.7416 84.4466"
        fill="white"
      />
      <path
        d="M109.884 97.899C112.701 98.419 115.567 98.6892 118.482 98.7097C141.925 98.7097 160.93 79.7052 160.93 56.2621C160.93 32.8189 141.925 13.8145 118.482 13.8145C112.46 13.8145 106.731 15.0685 101.541 17.3298C92.5233 21.2594 85.1354 28.2305 80.6735 36.9474C77.7078 42.7412 76.0347 49.3062 76.0347 56.2621C76.0347 62.5731 77.412 68.5625 79.8824 73.9461C81.6461 77.7895 83.967 81.3242 86.7416 84.4466"
        stroke="#65A4F6"
        strokeWidth="4.00449"
        strokeLinecap="round"
      />
      <path
        d="M91.728 89.2188C95.1689 92.0155 99.0562 94.2841 103.266 95.9013"
        stroke="#65A4F6"
        strokeWidth="4.00449"
        strokeLinecap="round"
      />
      <path
        d="M162.531 98.709L172.142 108.32"
        stroke="#65A4F6"
        strokeWidth="4.00449"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M170.589 106.766C167.557 109.798 167.557 114.713 170.589 117.745L188.346 135.501C191.377 138.533 196.293 138.533 199.325 135.501C202.356 132.47 202.356 127.554 199.325 124.522L181.568 106.766C178.536 103.734 173.621 103.734 170.589 106.766Z"
        fill="#E8F0FE"
        stroke="#65A4F6"
        strokeWidth="4.00449"
      />
      <path
        d="M178.549 109.922L196.169 127.542"
        stroke="white"
        strokeWidth="4.00449"
        strokeLinecap="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M108.07 37.8407C108.07 56.4183 123.13 71.4785 141.708 71.4785C145.357 71.4785 148.871 70.8973 152.162 69.8224C146.791 83.1508 133.735 92.5592 118.482 92.5592C98.4352 92.5592 82.1841 76.3081 82.1841 56.2614C82.1841 38.0963 95.5276 23.0477 112.948 20.3828C109.853 25.4737 108.07 31.449 108.07 37.8407Z"
        fill="#E8F0FE"
      />
      <path
        d="M119.283 26.6289C117.243 26.6289 115.25 26.8296 113.323 27.2122M107.501 28.9933C96.5434 33.598 88.8486 44.4319 88.8486 57.063"
        stroke="#B8D5FB"
        strokeWidth="4.00449"
        strokeLinecap="round"
      />
      <path
        d="M204.46 56.7058H191.364M214.59 44.248H187.078H214.59ZM225.802 44.248H222.244H225.802Z"
        stroke="#B8D5FB"
        strokeWidth="4.00449"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M60.299 91.9462H47.2031M52.8093 77.8867H25.2972H52.8093ZM15.968 77.8867H9.20654H15.968Z"
        stroke="#B8D5FB"
        strokeWidth="4.00449"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const LikeCount = (fill) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.0005 2.00098V4.00098M21.0005 5.00098L19.5005 6.50098M3.00046 5.00098L4.50046 6.50098M12.0005 22.001C15.6047 22.001 18.8139 19.6555 20.8777 17.6799C22.3748 16.2468 22.3748 13.7552 20.8777 12.3221C18.8139 10.3465 15.6047 8.00098 12.0005 8.00098C8.39628 8.00098 5.1871 10.3465 3.12329 12.3221C1.62622 13.7552 1.62622 16.2468 3.12329 17.6799C5.1871 19.6555 8.39628 22.001 12.0005 22.001ZM15.0005 15.001C15.0005 16.6578 13.6573 18.001 12.0005 18.001C10.3436 18.001 9.00046 16.6578 9.00046 15.001C9.00046 13.3441 10.3436 12.001 12.0005 12.001C13.6573 12.001 15.0005 13.3441 15.0005 15.001Z"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
};

export const SeenCount = (fill) => {
  return (
    <svg
      width="22"
      height="19"
      viewBox="0 0 22 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M20.8252 8.26246C20.4236 7.41721 19.5987 7.40178 18.7711 7.41795C17.4893 7.44343 16.2065 7.41795 14.925 7.41623C14.7645 7.41623 14.6039 7.39712 14.4587 7.38757C14.4394 7.31235 14.4229 7.2854 14.4278 7.26213C14.4557 7.12738 14.4814 6.99165 14.5217 6.86058C14.8237 5.88034 14.9529 4.84596 14.7398 3.83535C14.5792 3.0761 14.3031 2.08557 13.7242 1.526C12.8588 0.688594 10.9082 0.785859 10.9166 2.29235C10.9203 2.93963 10.9309 3.5879 10.9255 4.23445C10.924 4.39419 10.9095 4.5794 10.8302 4.7095C10.1298 5.86148 9.42539 7.01076 8.69509 8.14437C8.47726 8.48124 8.2162 8.68091 7.75708 8.70149L8.58395 17.005C8.95317 17.3019 9.3466 17.4391 9.82795 17.4344C12.2473 17.409 14.6674 17.4264 17.087 17.4224C18.4417 17.42 19.4002 16.3153 19.2248 14.9901C19.2055 14.8441 19.2611 14.6444 19.3567 14.5334C19.7686 14.0562 19.8684 13.5181 19.7961 12.913C19.7761 12.7405 19.8306 12.5124 19.9381 12.3799C20.2994 11.9345 20.5355 11.4308 20.3653 10.891C20.247 10.5167 20.3601 10.3315 20.5733 10.0759C21.0243 9.53326 21.1337 8.91293 20.8252 8.26246Z"
        stroke="white"
        strokeWidth="1.1987"
      />
      <path
        d="M1.92737 8.34851C0.85946 8.34851 1.0069 10.1407 1.0069 10.1407C1.05235 10.7154 1.08939 11.2454 1.12841 11.7755C1.18942 12.6056 1.25067 13.4344 1.3134 14.2645C1.38132 15.1697 1.43935 16.0772 1.5379 16.98C1.59766 17.5251 1.81796 17.6841 2.36402 17.6841C4.04665 17.6859 5.72978 17.6841 7.41266 17.6841C7.68309 17.6841 7.87302 17.6746 8.00959 17.6332L7.08789 8.3735C5.36994 8.32229 3.64779 8.34851 1.92737 8.34851Z"
        stroke="white"
        strokeWidth="1.1987"
      />
    </svg>
  );
};

export const InviteIcon = (fill) => {
  return (
    <svg
      width="11"
      height="10"
      viewBox="0 0 11 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.92637 0.208886C9.90079 0.163348 9.86299 0.12609 9.81671 0.101769C8.71969 -0.472627 2.30087 1.52896 0.65227 2.4925C0.222755 2.74347 0.0360771 3.03843 0.098199 3.36754C0.277438 4.32073 2.87042 5.04312 4.2756 5.36654L6.82902 2.7502C6.97696 2.59858 7.2233 2.59858 7.37927 2.7502C7.53523 2.90182 7.54173 3.14762 7.39379 3.29924L4.81561 5.94042C5.18528 7.34847 5.96739 9.8401 6.91163 9.9912C6.94705 9.99689 6.9824 10 7.01714 10C7.30445 10 7.55856 9.80336 7.77285 9.41525C8.69437 7.7464 10.5311 1.28989 9.92637 0.208886Z"
        fill="white"
      />
    </svg>
  );
};

export const infoIcon = (fill) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8.98 17C6.86 17 4.82 16.16 3.34 14.64C0.22 11.52 0.22 6.44 3.34 3.32C4.82 1.84 6.86 1 8.98 1C11.1 1 13.14 1.84 14.62 3.36C17.74 6.48 17.74 11.56 14.62 14.68C13.14 16.16 11.1 17 8.98 17ZM8.98 1.8C7.06 1.8 5.26 2.56 3.9 3.92C1.1 6.72 1.1 11.28 3.9 14.12C5.26 15.44 7.06 16.2 8.98 16.2C10.9 16.2 12.7 15.44 14.06 14.08C16.86 11.28 16.86 6.72 14.06 3.88C12.7 2.56 10.9 1.8 8.98 1.8ZM9.58 6C9.42 6.16 9.26 6.2 9.06 6.2C8.86 6.2 8.66 6.12 8.54 6C8.38 5.84 8.34 5.68 8.34 5.48C8.34 5.28 8.42 5.08 8.54 4.96C8.7 4.8 8.86 4.76 9.06 4.76C9.26 4.76 9.42 4.84 9.58 4.96C9.74 5.12 9.78 5.28 9.78 5.48C9.78 5.68 9.74 5.88 9.58 6ZM8.5 12.84V7.44C8.5 7.36 8.58 7.28 8.66 7.28H9.46C9.54 7.28 9.62 7.36 9.62 7.44V12.88C9.62 12.96 9.54 13.04 9.46 13.04H8.66C8.58 13 8.5 12.92 8.5 12.84Z"
        fill="#5A5B62"
        stroke="#5A5B62"
        strokeWidth="0.2"
      />
    </svg>
  );
};

export const AuctionBased = (fill) => {
  return (
    <svg
      width="97"
      height="84"
      viewBox="0 0 97 84"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M39.6609 67.4587H31.8266V64.3362C35.1954 62.1314 37.4226 58.3373 37.4226 54.0285H38.5417C40.3884 54.0285 41.8993 52.5176 41.8993 50.6709V47.3133C41.8993 46.3285 41.4628 45.4443 40.7801 44.8287V37.2407C40.7801 31.6895 36.2586 27.168 30.7074 27.168H20.6347C19.1798 27.168 17.9487 28.1081 17.4786 29.4063H17.2772C12.9571 29.4063 9.44288 32.9206 9.44288 37.2407V44.8287C8.76017 45.4443 8.32369 46.3285 8.32369 47.3133V50.6709C8.32369 52.5176 9.83459 54.0285 11.6813 54.0285H12.8004C12.8004 58.3373 15.0276 62.1314 18.3964 64.3362V67.4587H10.5621C5.0109 67.4587 0.48938 71.9802 0.48938 77.5314V82.0081C0.48938 82.6237 0.993014 83.1273 1.60857 83.1273C2.22412 83.1273 2.72775 82.6237 2.72775 82.0081V77.5314C2.72775 73.2113 6.242 69.6971 10.5621 69.6971H18.4971C19.0343 72.8644 21.7875 75.293 25.1115 75.293C28.4355 75.293 31.1887 72.8644 31.7259 69.6971H39.6609C43.981 69.6971 47.4952 73.2113 47.4952 77.5314V82.0081C47.4952 82.6237 47.9989 83.1273 48.6144 83.1273C49.23 83.1273 49.7336 82.6237 49.7336 82.0081V77.5314C49.7336 71.9802 45.2121 67.4587 39.6609 67.4587ZM39.6609 47.3133V50.6709C39.6609 51.2864 39.1573 51.7901 38.5417 51.7901H37.4226V46.1941H38.5417C39.1573 46.1941 39.6609 46.6978 39.6609 47.3133ZM19.5156 30.5255C19.5156 29.91 20.0192 29.4063 20.6347 29.4063H30.7074C35.0275 29.4063 38.5417 32.9206 38.5417 37.2407V43.9558H25.1115C22.0225 43.9558 19.5156 41.4488 19.5156 38.3598V30.5255ZM12.8004 51.7901H11.6813C11.0657 51.7901 10.5621 51.2864 10.5621 50.6709V47.3133C10.5621 46.6978 11.0657 46.1941 11.6813 46.1941H12.8004V51.7901ZM12.8004 42.8366V43.9558H11.6813V37.2407C11.6813 34.1517 14.1882 31.6447 17.2772 31.6447V37.3526C14.7254 37.8674 12.8004 40.1282 12.8004 42.8366ZM29.5882 68.5779C29.5882 71.0513 27.5849 73.0546 25.1115 73.0546C22.6381 73.0546 20.6347 71.0513 20.6347 68.5779V65.4889C22.0225 66.0373 23.5334 66.3395 25.1115 66.3395C26.6895 66.3395 28.2005 66.0261 29.5882 65.4889V68.5779ZM25.1115 64.1011C19.5603 64.1011 15.0388 59.5796 15.0388 54.0285V42.8366C15.0388 41.3369 16.0349 40.0834 17.3891 39.6469C18.0047 43.3514 21.2279 46.1941 25.1115 46.1941H35.1842V54.0285C35.1842 59.5796 30.6627 64.1011 25.1115 64.1011Z"
        fill="#090A14"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M78.3158 30.2234L79.6846 29.5015C80.59 29.0247 81.3365 28.1764 81.7338 27.1747C82.1658 26.0846 82.1323 24.924 81.6409 23.9906L80.0797 21.0259C78.9974 18.9722 76.2398 18.5984 74.4401 19.5452L73.0713 20.2659L69.6265 13.7265C69.1441 12.811 68.2756 12.2515 67.2437 12.1888C66.2107 12.1261 65.2818 12.5794 64.6931 13.4288L54.4346 28.2547L46.4548 34.5054C44.1818 36.286 43.4935 39.2306 44.7816 41.6659C45.7094 43.4208 47.4173 44.3856 49.4084 44.3856C49.9747 44.3856 50.5656 44.3016 51.1677 44.1416L52.7077 46.0822L56.9584 51.3849C57.3389 51.7229 57.828 51.8998 58.3428 51.8998C58.8319 51.8998 59.3423 51.7431 59.8 51.4241C60.8084 50.719 61.1173 49.5137 60.5331 48.559L56.7536 42.3788L61.1374 40.9821L79.1978 40.9877H79.2C80.2364 40.9877 81.1373 40.4785 81.6734 39.5921C82.2095 38.7046 82.2397 37.6693 81.7562 36.7516L78.3158 30.2234ZM77.9543 22.1462C77.6007 21.4736 76.392 21.234 75.5615 21.6716L74.1928 22.3924L77.1967 28.0958L78.5654 27.3739C78.965 27.1635 79.3153 26.7584 79.5011 26.2883C79.6745 25.8518 79.6801 25.422 79.5156 25.1109L77.9543 22.1462ZM57.4173 48.1505L57.6265 48.4135L54.3943 43.1298L53.6255 43.3749L57.4128 48.146C57.4138 48.1465 57.4146 48.147 57.4153 48.1477C57.416 48.1484 57.4167 48.1493 57.4173 48.1505ZM46.907 40.5445C47.6009 41.8573 49.0536 42.3095 50.7917 41.7555L59.2169 39.0694L54.926 30.924L47.9366 36.399C46.372 37.6257 46.306 39.4074 46.907 40.5445ZM79.1978 38.5837C79.3858 38.5837 79.5178 38.5087 79.6141 38.3487C79.7104 38.1875 79.7148 38.0353 79.6286 37.8696L75.6309 30.2804V30.2793L67.5023 14.848C67.415 14.6834 67.2874 14.6006 67.1005 14.5894C66.9147 14.5782 66.7781 14.6443 66.6718 14.7976L56.7234 29.1758L61.6758 38.5781L79.1978 38.5837Z"
        fill="#090A14"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M88.628 19.4613C88.1893 19.4613 87.7674 19.2206 87.5547 18.8032C87.2548 18.2111 87.4909 17.4881 88.083 17.1882L93.1753 14.6062C93.7673 14.3063 94.4903 14.5424 94.7903 15.1345C95.0902 15.7265 94.8541 16.4495 94.262 16.7495L89.1697 19.3314C88.9962 19.4198 88.8105 19.4613 88.628 19.4613ZM74.5957 6.40594L76.3707 0.979C76.5766 0.347779 77.256 0.00418852 77.8861 0.210119C78.5173 0.416049 78.8609 1.0954 78.655 1.7255L76.8799 7.15244C76.7143 7.65943 76.2431 7.98063 75.7384 7.98063C75.6141 7.98063 75.4888 7.96161 75.3645 7.9202C74.7333 7.71539 74.3886 7.03716 74.5957 6.40594ZM96.3773 35.9637C96.2116 36.4707 95.7405 36.7919 95.2357 36.7919C95.1115 36.7919 94.9861 36.7728 94.8619 36.7314L89.435 34.9575C88.8037 34.7516 88.4602 34.0722 88.6661 33.4421C88.872 32.8109 89.5514 32.4673 90.1815 32.6733L95.6084 34.4483C96.2396 34.6542 96.5843 35.3336 96.3773 35.9637Z"
        fill="#090A14"
      />
    </svg>
  );
};
export const InviteOnly = (fill) => {
  return (
    <svg
      width="68"
      height="48"
      viewBox="0 0 68 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M61.3829 0.0214844H6.61698C3.37327 0.0214844 0.808472 2.78191 0.808472 6.0791V41.1212C0.808472 44.4951 3.37327 47.2555 6.61698 47.2555H61.3829C64.6267 47.2555 67.1915 44.4951 67.1915 41.1212V6.0791C67.1915 2.78191 64.6267 0.0214844 61.3829 0.0214844ZM6.61698 1.70841H61.3829C62.439 1.70841 63.3443 2.09181 64.0986 2.78191L44.6363 21.5682C44.6363 21.4148 44.6363 21.2615 44.6363 21.1081C44.6363 18.041 42.0715 15.5872 39.0541 15.5872C36.8665 15.5872 34.9052 17.0441 34 18.9611C33.5473 17.9643 32.8684 17.1208 31.9632 16.5074C31.058 15.894 30.0019 15.5872 28.9458 15.5872C25.9284 15.5872 23.3636 18.041 23.3636 21.1081C23.3636 21.2615 23.3636 21.4148 23.3636 21.5682L3.90132 2.78191C4.65567 2.16849 5.56089 1.70841 6.61698 1.70841ZM2.46805 41.1212V6.0791C2.46805 5.38899 2.61892 4.69888 2.92066 4.16213L23.439 23.9452L3.52414 44.1117C2.84522 43.3449 2.46805 42.2714 2.46805 41.1212ZM61.3829 45.5686H6.61698C6.0135 45.5686 5.41002 45.4152 4.88197 45.1085L24.5706 25.1721C27.3617 30.3095 34 34.8336 34 34.8336C34 34.8336 40.6383 30.1562 43.4294 25.0954L63.118 45.1085C62.5899 45.4152 61.9864 45.5686 61.3829 45.5686ZM65.5319 41.1212C65.5319 42.2714 65.1547 43.3449 64.4758 44.1117L44.6363 23.8685L65.0793 4.16213C65.381 4.77556 65.5319 5.38899 65.5319 6.0791V41.1212Z"
        fill="#090A14"
      />
    </svg>
  );
};

export const InReviewContent = (fill) => {
  return (
    <svg
      width="116"
      height="71"
      viewBox="0 0 116 71"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M60.9438 16.0977C60.9438 16.0977 30.2203 50.6081 29.8652 54.4351C29.8652 54.4351 31.253 55.05 32.8009 56.8442C34.5926 58.921 36.7398 59.7136 37.815 59.1287C39.3641 58.2866 39.2311 57.127 39.2311 57.127L62.9427 65.7162C62.9427 65.7162 71.3167 63.0906 88.2992 45.3885L92.8163 38.9342L60.9438 16.0977Z"
        fill="#65A4F6"
      />
      <path
        d="M25.7363 21.0842C25.7363 21.0842 29.5178 23.7968 34.0369 21.2397L48.2504 13.0816C48.2504 13.0816 53.0898 9.50997 58.0666 12.9456C58.0666 12.9456 53.5449 23.9289 62.8605 25.8085C62.8605 25.8085 71.952 29.975 76.7624 34.2524C79.1811 36.4043 84.3543 40.054 86.8141 42.1151C87.4741 42.6674 88.8245 43.4932 89.5096 44.321C90.4612 45.4707 92.2794 47.9776 89.362 50.4096C89.362 50.4096 87.4175 52.6937 83.5218 50.2898C79.9011 48.0554 73.5888 42.8729 69.7628 40.4622C69.5552 40.3315 68.6071 40.1383 69.9296 41.4284C71.5611 43.0188 79.1805 48.651 79.1805 48.651C79.1805 48.651 82.0305 50.6299 82.7076 51.6345C83.3022 52.5155 84.2179 54.4503 82.5134 56.5515C82.5134 56.5515 80.0929 59.7418 75.9433 57.2067L66.4159 50.5559C66.4159 50.5559 64.3898 49.2481 66.0189 51.157C66.0189 51.157 75.688 57.9505 76.0682 58.9843C77.1522 61.931 75.0547 65.721 70.3429 63.8914L59.4267 57.9229C59.4267 57.9229 58.4291 57.7769 59.2457 58.5729C59.2457 58.5729 69.374 63.7999 70.0757 64.3739C70.9934 65.125 68.765 68.6649 64.1479 67.247C57.5623 65.2254 44.2515 61.586 37.8149 59.1298C35.5503 58.2659 30.8983 55.9575 29.1053 54.8726C29.1053 54.8726 21.9131 50.3465 12.0645 50.1583L19.16 19.9145L25.7363 21.0842Z"
        fill="#B8D5FB"
      />
      <path
        d="M36.7373 61.1673C36.7373 61.1673 38.817 58.4199 40.1027 57.4262C42.7108 55.4108 47.4168 57.3639 47.6454 59.8337C47.6454 59.8337 48.6599 62.2606 44.4528 65.8397C43.675 66.501 41.2035 68.0725 37.5896 65.1027C37.5895 65.103 35.4335 63.1201 36.7373 61.1673Z"
        fill="#95C0F9"
      />
      <path
        d="M40.9053 36.7466C40.9053 36.7466 46.9315 41.5192 53.1697 27.3212C53.1697 27.3212 56.489 28.4778 61.6456 25.4873L62.72 23.8164C62.72 23.8164 52.2468 24.9311 52.2931 25.137C52.3393 25.343 40.9053 36.7466 40.9053 36.7466Z"
        fill="#65A4F6"
      />
      <path
        d="M45.6988 66.5426C45.6247 64.7207 48.179 61.3779 49.2969 60.198C50.6141 58.8076 55.8012 57.4786 56.4038 63.0004C56.4038 63.0004 56.0823 66.8705 53.2009 69.0766C51.8311 70.1259 45.8557 70.4056 45.6988 66.5426Z"
        fill="#95C0F9"
      />
      <path
        d="M57.3256 63.7842C58.2082 62.3802 62.5841 61.7104 62.6818 65.7423C62.7187 67.2692 61.9234 69.7859 59.6561 70.7835C58.0079 71.5085 53.6573 70.3283 54.4844 68.5604C55.0523 67.3451 55.3301 66.9567 57.3256 63.7842Z"
        fill="#95C0F9"
      />
      <path
        d="M29.0053 57.5699C29.3855 56.7341 30.0138 55.9328 31.2684 54.9218C32.0275 54.3107 34.1605 54.0734 35.4432 54.8744C36.3639 55.4498 38.1788 56.798 37.7721 57.9973C36.9983 60.2758 35.6865 63.3629 32.8463 62.4709C32.8462 62.4707 27.3101 61.2959 29.0053 57.5699Z"
        fill="#95C0F9"
      />
      <path
        d="M24.6021 18.1072L18.8055 55.79L0.192383 52.2077L8.44148 13.8203L24.6021 18.1072Z"
        fill="#95C0F9"
      />
      <path
        d="M31.0552 56.2993C31.0552 56.2993 30.1451 58.8813 31.7609 59.9662C31.7609 59.9662 33.8402 62.4614 36.414 58.3396C36.8429 57.6528 35.884 56.4403 34.1852 55.9871C34.1853 55.9871 32.5759 55.3673 31.0552 56.2993Z"
        fill="white"
      />
      <path
        d="M39.2919 60.9417C39.2919 60.9417 40.3513 58.5704 41.2511 58.2063C42.1778 57.8311 44.9618 57.7704 46.1315 60.5052C46.3327 60.9753 45.6061 61.9575 45.279 62.478C44.6762 63.4393 43.1196 64.8779 41.3101 63.8898C41.3099 63.8894 38.995 63.0538 39.2919 60.9417Z"
        fill="white"
      />
      <path
        d="M48.7655 62.9716C49.0169 62.2827 49.9924 61.0274 50.8804 60.9387C52.3409 60.7934 55.7138 61.8764 54.8225 64.0361C54.8225 64.0361 54.0572 65.8671 52.4151 66.2941C52.4151 66.2941 49.5673 67.3154 48.5138 64.6651C48.3553 64.2672 48.6197 63.3736 48.7655 62.9716Z"
        fill="white"
      />
      <path
        d="M56.4979 67.1104C56.9185 68.1593 58.722 69.2434 59.8228 68.2438C60.2691 67.8391 61.1884 66.4851 61.2387 65.8853C61.3229 64.8703 59.326 62.7278 57.5766 64.7231C57.1637 65.1941 56.2649 66.529 56.4979 67.1104Z"
        fill="white"
      />
      <path
        d="M65.0612 11.9693C65.0612 11.9693 58.9706 10.0485 54.3119 14.7258L46.5033 19.507C46.5033 19.507 43.1728 20.6112 42.1425 25.0673L38.5954 32.4425C38.5954 32.4425 35.7296 37.5031 44.0869 36.8101C44.0869 36.8101 48.8701 34.7885 52.6678 27.1077L52.6411 26.1273C52.6411 26.1273 53.1823 27.3368 55.9426 26.8511C55.9426 26.8511 58.7932 25.8644 62.736 24.5587C62.736 24.5587 63.3759 25.3375 67.1635 27.4174C67.1635 27.4174 76.4234 32.2627 78.5762 34.8457L89.6699 43.2891C89.6699 43.2891 91.3921 42.6012 95.6774 35.9372L105.239 32.5385L95.2078 5.17188C95.2078 5.17188 79.9356 11.1529 75.4511 11.6L65.0612 11.9693Z"
        fill="#95C0F9"
      />
      <path
        d="M88.5332 5.83597L101.746 36.9402L115.807 31.4832L101.994 0L88.5332 5.83597Z"
        fill="#65A4F6"
      />
      <path
        d="M40.3572 28.7763C40.3572 28.7763 43.7138 27.5058 44.7035 29.8295C44.7035 29.8295 43.6838 33.9722 42.5365 34.8906C41.6495 35.6016 38.705 35.8925 38.1259 34.3766C38.1259 34.3766 37.7616 32.815 40.3572 28.7763Z"
        fill="white"
      />
      <path
        d="M70.6211 29.3198C70.6211 29.3198 76.865 31.8848 83.1723 26.832C83.1723 26.832 78.8396 32.671 73.0074 30.7295L70.6211 29.3198Z"
        fill="#65A4F6"
      />
      <path
        d="M12.5013 48.532C12.5421 48.9402 12.4609 49.3514 12.268 49.7135C12.0751 50.0755 11.7791 50.3723 11.4176 50.5661C11.056 50.76 10.6451 50.8423 10.2368 50.8026C9.82844 50.7629 9.44105 50.603 9.12359 50.3432C8.80614 50.0833 8.57288 49.7351 8.45332 49.3427C8.33376 48.9502 8.33326 48.5312 8.45189 48.1384C8.57052 47.7457 8.80295 47.397 9.11979 47.1364C9.43663 46.8757 9.82363 46.7149 10.2319 46.6743C10.7791 46.6198 11.3256 46.7849 11.7512 47.1333C12.1768 47.4817 12.4466 47.9848 12.5013 48.532Z"
        fill="white"
      />
      <path
        d="M109 28.4542C109.04 28.8623 108.959 29.2733 108.766 29.6353C108.573 29.9972 108.277 30.2938 107.916 30.4876C107.554 30.6813 107.144 30.7636 106.735 30.7238C106.327 30.6841 105.94 30.5242 105.622 30.2644C105.305 30.0046 105.072 29.6565 104.952 29.2642C104.833 28.8718 104.832 28.4529 104.951 28.0602C105.069 27.6676 105.302 27.3189 105.618 27.0583C105.935 26.7977 106.322 26.6369 106.73 26.5962C107.001 26.5691 107.275 26.5958 107.536 26.6745C107.796 26.7532 108.039 26.8826 108.25 27.0551C108.461 27.2276 108.635 27.44 108.764 27.6801C108.893 27.9201 108.973 28.1832 109 28.4542Z"
        fill="white"
      />
    </svg>
  );
};

export const reelsIconInstagram = (fill) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.74597 8.87193L11.8048 11.6284L7.74597 14.3848V8.87193ZM7.35667 15.1211C7.39486 15.1413 7.43739 15.1519 7.48058 15.1519C7.53439 15.152 7.587 15.136 7.63169 15.106L12.4266 11.8481C12.4627 11.8239 12.4924 11.7912 12.5128 11.7529C12.5333 11.7145 12.544 11.6718 12.544 11.6283C12.544 11.5848 12.5333 11.5421 12.5128 11.5037C12.4924 11.4654 12.4627 11.4327 12.4266 11.4085L7.63018 8.15C7.59016 8.12277 7.54346 8.10699 7.49512 8.10436C7.44679 8.10173 7.39865 8.11235 7.35591 8.13508C7.31317 8.1575 7.27741 8.19124 7.25256 8.23262C7.2277 8.27399 7.21471 8.32141 7.215 8.36968V14.8863C7.21482 14.9346 7.22786 14.982 7.2527 15.0234C7.27754 15.0648 7.31399 15.0986 7.35667 15.1211ZM1.03059 6.28774V13.9141C1.03154 14.724 1.35368 15.5004 1.92634 16.0731C2.49901 16.6458 3.27543 16.9679 4.0853 16.9688H13.9147C14.7246 16.9679 15.501 16.6458 16.0736 16.0731C16.6462 15.5004 16.9683 14.724 16.9692 13.9141V6.28774H1.03059ZM4.0853 1.03134H4.2434L6.80624 5.75659H1.03059V4.08587C1.03164 3.27605 1.35382 2.4997 1.92646 1.92709C2.49911 1.35447 3.27548 1.03234 4.0853 1.03134ZM7.41088 5.75659H13.152L10.5891 1.03134H4.84803L7.41088 5.75659ZM16.9687 4.08587V5.75659H13.7566L11.1938 1.03134H13.9147C14.7245 1.03234 15.5009 1.35448 16.0735 1.9271C16.6461 2.49971 16.9677 3.27606 16.9687 4.08587ZM4.0853 17.5H13.9147C14.8653 17.4988 15.7766 17.1205 16.4487 16.4483C17.1208 15.7761 17.4989 14.8647 17.5 13.9141V4.08587C17.4989 3.13527 17.1208 2.22392 16.4487 1.55169C15.7766 0.879465 14.8653 0.50125 13.9147 0.5H4.0853C3.13471 0.50125 2.22341 0.879465 1.55129 1.55169C0.87917 2.22392 0.5011 3.13527 0.5 4.08587V13.9141C0.5011 14.8647 0.87917 15.7761 1.55129 16.4483C2.22341 17.1205 3.13471 17.4988 4.0853 17.5Z"
        fill="url(#paint0_linear_6129_3797)"
        stroke="url(#paint1_linear_6129_3797)"
        strokeWidth="0.7"
      />
      <defs>
        <linearGradient
          id="paint0_linear_6129_3797"
          x1="17.1733"
          y1="17.5"
          x2="0.173261"
          y2="0.5"
          gradientUnits="userSpaceOnUse">
          <stop stop-color="#FBE18A" />
          <stop offset="0.21" stop-color="#FCBB45" />
          <stop offset="0.38" stop-color="#F75274" />
          <stop offset="0.52" stop-color="#D53692" />
          <stop offset="0.74" stop-color="#8F39CE" />
          <stop offset="1" stop-color="#5B4FE9" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_6129_3797"
          x1="17.1733"
          y1="17.5"
          x2="0.173261"
          y2="0.5"
          gradientUnits="userSpaceOnUse">
          <stop stop-color="#FBE18A" />
          <stop offset="0.21" stop-color="#FCBB45" />
          <stop offset="0.38" stop-color="#F75274" />
          <stop offset="0.52" stop-color="#D53692" />
          <stop offset="0.74" stop-color="#8F39CE" />
          <stop offset="1" stop-color="#5B4FE9" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const postsIconInstagram = (fill) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6.26263 9.17481C6.26263 7.56494 7.56812 6.25953 9.17896 6.25953C10.7898 6.25953 12.096 7.56494 12.096 9.17481C12.096 10.7847 10.7898 12.0901 9.17896 12.0901C7.56812 12.0901 6.26263 10.7847 6.26263 9.17481ZM4.68575 9.17481C4.68575 11.6549 6.69735 13.6653 9.17896 13.6653C11.6606 13.6653 13.6722 11.6549 13.6722 9.17481C13.6722 6.69469 11.6606 4.68429 9.17896 4.68429C6.69735 4.68429 4.68575 6.69469 4.68575 9.17481ZM12.8 4.50624C12.7999 4.7138 12.8614 4.91672 12.9767 5.08934C13.092 5.26196 13.256 5.39653 13.4478 5.47603C13.6397 5.55554 13.8508 5.57641 14.0545 5.53599C14.2582 5.49558 14.4453 5.39571 14.5922 5.24901C14.7391 5.1023 14.8392 4.91536 14.8798 4.7118C14.9204 4.50826 14.8997 4.29724 14.8203 4.10546C14.7409 3.91367 14.6064 3.74972 14.4338 3.63434C14.2611 3.51896 14.0581 3.45733 13.8505 3.45725H13.85C13.5717 3.45738 13.3047 3.56792 13.1078 3.76461C12.911 3.96129 12.8002 4.22803 12.8 4.50624ZM5.64381 16.2931C4.79068 16.2543 4.32698 16.1123 4.01883 15.9923C3.61029 15.8333 3.3188 15.644 3.01233 15.3382C2.70585 15.0323 2.51615 14.7413 2.3578 14.333C2.23767 14.0251 2.09557 13.5616 2.05679 12.709C2.01437 11.7872 2.0059 11.5102 2.0059 9.17488C2.0059 6.83951 2.01507 6.56337 2.05679 5.6408C2.09564 4.78819 2.23879 4.32553 2.3578 4.0168C2.51685 3.6085 2.70627 3.31719 3.01233 3.0109C3.31838 2.70461 3.60959 2.51501 4.01883 2.35676C4.32684 2.23671 4.79068 2.09469 5.64381 2.05593C6.56617 2.01353 6.84324 2.00507 9.17896 2.00507C11.5147 2.00507 11.792 2.01423 12.7152 2.05593C13.5683 2.09476 14.0312 2.23783 14.3401 2.35676C14.7487 2.51501 15.0402 2.70503 15.3466 3.0109C15.6531 3.31677 15.8421 3.6085 16.0012 4.0168C16.1213 4.32462 16.2634 4.78819 16.3022 5.6408C16.3446 6.56337 16.3531 6.83951 16.3531 9.17488C16.3531 11.5102 16.3446 11.7864 16.3022 12.709C16.2633 13.5616 16.1205 14.025 16.0012 14.333C15.8421 14.7413 15.6527 15.0326 15.3466 15.3382C15.0406 15.6437 14.7487 15.8333 14.3401 15.9923C14.0321 16.1123 13.5683 16.2544 12.7152 16.2931C11.7928 16.3355 11.5157 16.344 9.17896 16.344C6.84219 16.344 6.56589 16.3355 5.64381 16.2931ZM5.57135 0.482648C4.63983 0.525044 4.00329 0.672662 3.4474 0.888841C2.87169 1.11209 2.38433 1.41159 1.89732 1.89754C1.41031 2.38349 1.1114 2.87133 0.888018 3.44668C0.671709 4.00259 0.524003 4.6384 0.481581 5.56937C0.438459 6.50181 0.428589 6.79991 0.428589 9.17481C0.428589 11.5497 0.438459 11.8478 0.481581 12.7802C0.524003 13.7113 0.671709 14.347 0.888018 14.9029C1.1114 15.4779 1.41038 15.9663 1.89732 16.4521C2.38426 16.9378 2.87169 17.2369 3.4474 17.4608C4.00434 17.677 4.63983 17.8246 5.57135 17.867C6.50484 17.9094 6.80264 17.9199 9.17896 17.9199C11.5553 17.9199 11.8536 17.9101 12.7866 17.867C13.7182 17.8246 14.3543 17.677 14.9105 17.4608C15.4859 17.2369 15.9736 16.938 16.4606 16.4521C16.9476 15.9661 17.2459 15.4779 17.4699 14.9029C17.6862 14.347 17.8346 13.7112 17.8763 12.7802C17.9188 11.8471 17.9286 11.5497 17.9286 9.17481C17.9286 6.79991 17.9188 6.50181 17.8763 5.56937C17.8339 4.63833 17.6862 4.00224 17.4699 3.44668C17.2459 2.87168 16.9468 2.38426 16.4606 1.89754C15.9743 1.41082 15.4859 1.11209 14.9112 0.888841C14.3543 0.672662 13.7181 0.524345 12.7873 0.482648C11.8543 0.440252 11.556 0.429688 9.17966 0.429688C6.80334 0.429688 6.50484 0.439552 5.57135 0.482648Z"
        fill="url(#paint0_linear_6129_3719)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_6129_3719"
          x1="17.5923"
          y1="17.9199"
          x2="0.102032"
          y2="0.419899"
          gradientUnits="userSpaceOnUse">
          <stop stop-color="#FBE18A" />
          <stop offset="0.21" stop-color="#FCBB45" />
          <stop offset="0.38" stop-color="#F75274" />
          <stop offset="0.52" stop-color="#D53692" />
          <stop offset="0.74" stop-color="#8F39CE" />
          <stop offset="1" stop-color="#5B4FE9" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const downloadIcon = (fill) => {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M18.4001 13.6V10.9255C18.4001 10.2715 18.4001 9.94448 18.2783 9.65045C18.1565 9.35642 17.9253 9.12519 17.4628 8.66274L13.6736 4.8735C13.2745 4.4744 13.075 4.27484 12.8277 4.1566C12.7763 4.132 12.7236 4.11018 12.6699 4.09121C12.4114 4 12.1292 4 11.5647 4C8.96875 4 7.67075 4 6.79156 4.70886C6.61395 4.85206 6.45216 5.01385 6.30895 5.19146C5.6001 6.07065 5.6001 7.36866 5.6001 9.96467V13.6C5.6001 16.617 5.6001 18.1255 6.53735 19.0627C7.47462 20 8.98311 20 12.0001 20M12.8001 4.4V4.8C12.8001 7.06274 12.8001 8.19411 13.5031 8.89706C14.206 9.6 15.3374 9.6 17.6001 9.6H18.0001"
        stroke="#5A5B62"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.8001 15.3984C11.2719 15.8839 12.5279 17.7984 13.2001 17.7984C13.8723 17.7984 15.1283 15.8839 15.6001 15.3984M13.2001 16.9984L13.2001 11.3984"
        stroke="#5A5B62"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const contentView = (fill) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      viewBox="-5.0 -10.0 110.0 135.0"
      width="24px"
      height="24px">
      <g>
        <path d="m60.734 94.141c-0.32812 0-0.65625-0.10938-0.9375-0.32812l-47.516-37.75c-0.3125-0.25-0.51562-0.60938-0.5625-1.0156-0.046875-0.39062 0.0625-0.79688 0.3125-1.1094l37.75-47.516c0.51562-0.65625 1.4688-0.76562 2.125-0.25l47.516 37.75c0.3125 0.25 0.51562 0.60938 0.5625 1.0156 0.046875 0.39062-0.0625 0.79688-0.3125 1.1094l-37.75 47.531c-0.3125 0.375-0.75 0.5625-1.1875 0.5625zm-45.391-39.5 45.141 35.875 35.875-45.141-45.141-35.875z" />
        <path d="m66.062 59.625c-0.078125 0-0.15625 0-0.21875-0.015625l-29.797-4.4375c-0.53125-0.078125-0.98438-0.4375-1.1875-0.9375s-0.10938-1.0781 0.21875-1.5l18.734-23.578c0.34375-0.42188 0.875-0.625 1.4062-0.5625 0.53125 0.078125 0.98438 0.4375 1.1875 0.9375l11.047 28.031c0.20312 0.5 0.10938 1.0781-0.21875 1.5-0.26562 0.35938-0.71875 0.5625-1.1719 0.5625zm-26.969-7.0625 24.609 3.6719-9.125-23.141z" />
        <path d="m15.625 90.328c-0.25 0-0.48438-0.0625-0.71875-0.17188-0.375-0.20312-0.64062-0.53125-0.75-0.9375l-14.109-52.078c-0.10938-0.39062-0.046875-0.8125 0.15625-1.1719s0.54688-0.60938 0.95312-0.70312l32.375-7.875c0.8125-0.20312 1.625 0.29688 1.8281 1.1094s-0.29688 1.625-1.1094 1.8281l-30.859 7.5312 13.281 49 26.688-9.0781c0.79688-0.28125 1.6562 0.15625 1.9219 0.95312s-0.15625 1.6562-0.95312 1.9219l-28.219 9.5938c-0.15625 0.046875-0.3125 0.078125-0.48438 0.078125z" />
      </g>
    </svg>
  );
};

export const heartIcon = (fill) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2.58813 12.4702C2.58813 11.4306 3.43089 10.5879 4.47049 10.5879C6.02988 10.5879 7.29402 11.852 7.29402 13.4114V17.1761C7.29402 18.7356 6.02988 19.9997 4.47049 19.9997C3.43089 19.9997 2.58813 19.1569 2.58813 18.1173V12.4702Z"
        stroke="#5A5B62"
        strokeWidth="1.41176"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.2741 8.05295L15.0235 8.86244C14.8181 9.52575 14.7155 9.8574 14.7944 10.1193C14.8583 10.3312 14.9986 10.5139 15.1897 10.6341C15.426 10.7826 15.7833 10.7826 16.498 10.7826H16.8783C19.2972 10.7826 20.5066 10.7826 21.0779 11.4986C21.1431 11.5804 21.2012 11.6675 21.2515 11.7588C21.6909 12.5573 21.1913 13.633 20.1921 15.7846C19.2751 17.759 18.8165 18.7462 17.9652 19.3272C17.8829 19.3834 17.7982 19.4365 17.7114 19.4862C16.8151 20 15.7047 20 13.4837 20H13.002C10.3113 20 8.96598 20 8.13009 19.1901C7.29419 18.3801 7.29419 17.0766 7.29419 14.4696V13.5532C7.29419 12.1832 7.29419 11.4982 7.53733 10.8712C7.78048 10.2441 8.24605 9.7286 9.17719 8.69753L13.0279 4.43347C13.1245 4.32653 13.1728 4.27305 13.2154 4.236C13.6128 3.89015 14.2261 3.92907 14.5736 4.32221C14.6109 4.36433 14.6516 4.42345 14.7329 4.54169C14.8601 4.72664 14.9237 4.81912 14.9793 4.91073C15.4756 5.73095 15.6259 6.70528 15.3985 7.63026C15.3731 7.73357 15.3401 7.8401 15.2741 8.05295Z"
        stroke="#5A5B62"
        strokeWidth="1.41176"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const commentIcon = (fill) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      viewBox="-5.0 -10.0 110.0 135.0"
      width="24px"
      height="24px">
      <path d="m50 12.801c-20.512 0-37.199 16.691-37.199 37.199 0 20.512 16.691 37.199 37.199 37.199 7.0508 0 13.859-1.9609 19.781-5.6914l14.012 5.5195c0.30078 0.12109 0.60938 0.17188 0.92188 0.17188 0.69922 0 1.3906-0.28906 1.8711-0.83984 0.69922-0.78125 0.82812-1.9219 0.32812-2.8398l-6.6211-12.301c1.8789-3.6484 6.9219-14.102 6.9219-21.219 0-20.512-16.691-37.199-37.199-37.199zm25.262 57.23c-0.42188 0.76953-0.39062 1.6719 0 2.3906l4.0195 7.4609-8.5703-3.3711c-0.80078-0.42969-1.8008-0.41016-2.6016 0.12891-5.3516 3.6406-11.609 5.5703-18.102 5.5703-17.762 0-32.199-14.449-32.199-32.199s14.449-32.199 32.199-32.199 32.199 14.449 32.199 32.199c0 5.6992-4.3594 15.27-6.9414 20.02z" />
    </svg>
  );
};

export const rupeeIcon = (fill) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="24"
      height="24"
      color="#000000"
      fill="none">
      <path
        d="M2 14C2 10.4934 2 8.74003 2.90796 7.55992C3.07418 7.34388 3.25989 7.14579 3.46243 6.96849C4.56878 6 6.21252 6 9.5 6H14.5C17.7875 6 19.4312 6 20.5376 6.96849C20.7401 7.14579 20.9258 7.34388 21.092 7.55992C22 8.74003 22 10.4934 22 14C22 17.5066 22 19.26 21.092 20.4401C20.9258 20.6561 20.7401 20.8542 20.5376 21.0315C19.4312 22 17.7875 22 14.5 22H9.5C6.21252 22 4.56878 22 3.46243 21.0315C3.25989 20.8542 3.07418 20.6561 2.90796 20.4401C2 19.26 2 17.5066 2 14Z"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path
        d="M16 6C16 4.11438 16 3.17157 15.4142 2.58579C14.8284 2 13.8856 2 12 2C10.1144 2 9.17157 2 8.58579 2.58579C8 3.17157 8 4.11438 8 6"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 11C10.8954 11 10 11.6716 10 12.5C10 13.3284 10.8954 14 12 14C13.1046 14 14 14.6716 14 15.5C14 16.3284 13.1046 17 12 17M12 11C12.8708 11 13.6116 11.4174 13.8862 12M12 11V10M12 17C11.1292 17 10.3884 16.5826 10.1138 16M12 17V18"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M6 12H2"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M22 12L18 12"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
};

export const viewEyes = (fill) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="24"
      height="24"
      color="#000000"
      fill="none">
      <path
        d="M21.544 11.045C21.848 11.4713 22 11.6845 22 12C22 12.3155 21.848 12.5287 21.544 12.955C20.1779 14.8706 16.6892 19 12 19C7.31078 19 3.8221 14.8706 2.45604 12.955C2.15201 12.5287 2 12.3155 2 12C2 11.6845 2.15201 11.4713 2.45604 11.045C3.8221 9.12944 7.31078 5 12 5C16.6892 5 20.1779 9.12944 21.544 11.045Z"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path
        d="M15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15C13.6569 15 15 13.6569 15 12Z"
        stroke="currentColor"
        strokeWidth="1.5"
      />
    </svg>
  );
};

export const filterIcon = (fill) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      data-name="Layer 1"
      viewBox="0 0 1024 1280"
      x="0px"
      y="0px"
      width="28px"
      height="30px">
      <path
        fill="#000000"
        d="M237.714286 237.714286v47.177143l214.089143 214.198857A18.285714 18.285714 0 0 1 457.142857 512v208.128l109.714286 54.857143V512a18.285714 18.285714 0 0 1 5.339428-12.909714L786.285714 284.891429V237.714286h-548.571428z m182.857143 281.856L206.482286 305.408a18.285714 18.285714 0 0 1-5.339429-12.909714V219.428571a18.285714 18.285714 0 0 1 18.285714-18.285714h585.142858a18.285714 18.285714 0 0 1 18.285714 18.285714v73.069715a18.285714 18.285714 0 0 1-5.339429 12.909714L603.428571 519.570286V804.571429a18.285714 18.285714 0 0 1-26.477714 16.347428l-146.285714-73.142857A18.285714 18.285714 0 0 1 420.571429 731.428571v-211.858285z"
      />
    </svg>
  );
};

export const heartLikeIcon = (fill) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="24"
      height="24"
      color="#000000"
      fill="none">
      <path
        d="M19 10.5V10C19 6.22876 19 4.34315 17.8284 3.17157C16.6569 2 14.7712 2 11 2C7.22876 2 5.34315 2 4.17157 3.17157C3 4.34315 3 6.22876 3 10V16C3 17.8638 3 18.7956 3.30448 19.5307C3.71046 20.5108 4.48915 21.2895 5.46927 21.6955C6.20435 22 7.13623 22 9 22"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7 7H15M7 11H11"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M15.2825 19.0044C15.2235 18.1157 15.118 17.1658 14.6817 16.0917C14.3095 15.1756 14.4132 13.0205 16.5 13.0205C18.5868 13.0205 18.6664 15.1756 18.2942 16.0917C17.8578 17.1658 17.7765 18.1157 17.7175 19.0044M21 22H12V20.7543C12 20.3078 12.2664 19.9154 12.6528 19.7928L14.9076 19.077C15.0684 19.0259 15.2348 19 15.4021 19H17.5979C17.7652 19 17.9316 19.0259 18.0924 19.077L20.3472 19.7928C20.7336 19.9154 21 20.3078 21 20.7543V22Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const commentCount = (fill) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13.8278 19.4867C17.3503 19.2526 20.1562 16.4069 20.3871 12.8344C20.4322 12.1353 20.4322 11.4113 20.3871 10.7122C20.1562 7.13969 17.3503 4.294 13.8278 4.05985C12.626 3.97997 11.3714 3.98013 10.172 4.05985C6.6495 4.294 3.84362 7.13969 3.61274 10.7122C3.56756 11.4113 3.56756 12.1353 3.61274 12.8344C3.69683 14.1356 4.27227 15.3403 4.94973 16.3576C5.34307 17.0697 5.08348 17.9586 4.67377 18.735C4.37836 19.2948 4.23065 19.5747 4.34925 19.7769C4.46785 19.9791 4.73276 19.9856 5.26258 19.9985C6.31037 20.024 7.0169 19.7269 7.57774 19.3133C7.89582 19.0788 8.05487 18.9615 8.16449 18.948C8.27409 18.9346 8.48982 19.0234 8.92118 19.2011C9.30887 19.3607 9.75903 19.4593 10.172 19.4867C11.3714 19.5665 12.626 19.5666 13.8278 19.4867Z"
        stroke="#5A5B62"
        strokeWidth="1.26316"
        strokeLinejoin="round"
      />
      <path
        d="M11.9952 12H12.0042M15.9907 12H15.9997M7.99976 12H8.00873"
        stroke="#5A5B62"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const rejectedIcon = (fill) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      viewBox="-5.0 -10.0 110.0 135.0"
      width="26px"
      height="26px">
      <path
        d="m76.559 23.441c8.2578 8.2539 12.207 19.883 10.684 31.457-1.5273 11.578-8.3477 21.789-18.457 27.625-10.113 5.8398-22.367 6.6445-33.152 2.1758-10.789-4.4688-18.887-13.699-21.91-24.977-3.0234-11.277-0.625-23.32 6.4805-32.586 7.1094-9.2656 18.121-14.695 29.797-14.695 9.9648-0.015625 19.523 3.9453 26.559 11zm18.441 26.559c0-13.988-6.5078-27.184-17.605-35.699-11.102-8.5195-25.527-11.387-39.043-7.7656-13.512 3.6211-24.574 13.32-29.926 26.246-5.3555 12.926-4.3906 27.605 2.6016 39.719 6.9961 12.117 19.23 20.289 33.098 22.117 13.871 1.8242 27.801-2.9062 37.695-12.797 8.4531-8.4297 13.195-19.883 13.18-31.82zm-29.801-10.152c1.3711-1.4375 1.3438-3.707-0.066407-5.1094l-0.046874-0.050781v0.003906c-1.4102-1.3633-3.6406-1.3711-5.0586-0.019531l-9.3281 9.3828c-0.42188 0.41797-1.1016 0.41797-1.5234 0l-9.375-9.375c-0.69141-0.64063-1.6016-0.99219-2.543-0.98828-0.94531 0-1.8477 0.37891-2.5156 1.0469-1.4062 1.4023-1.4375 3.6719-0.066407 5.1094l9.2656 9.457c0.41406 0.42578 0.41016 1.1016-0.007812 1.5195-3.0742 3.0781-6.1719 6.1367-9.2578 9.1992-1.3711 1.4375-1.3398 3.707 0.066407 5.1094l0.050781 0.050782c0.69141 0.67578 1.6055 1.0742 2.5703 1.125 0.91016 0.046875 1.7969-0.27734 2.4648-0.89453l9.3516-9.3516v-0.003906c0.42187-0.41797 1.1016-0.41797 1.5234 0l0.046875 0.050781 9.2773 9.0898c1.4453 1.3242 3.6758 1.2734 5.0586-0.10938 1.3867-1.3867 1.4375-3.6133 0.11328-5.0586l-9.2578-9.1992v-0.003906c-0.41797-0.41797-0.42188-1.0938-0.007812-1.5156z"
        fillRule="evenodd"
      />
    </svg>
  );
};

export const approvedIcon = (fill) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      viewBox="-5.0 -10.0 110.0 135.0"
      width="26px"
      height="26px">
      <g>
        <path d="m50 7.0312c-23.695 0-42.969 19.273-42.969 42.969s19.273 42.969 42.969 42.969 42.969-19.273 42.969-42.969-19.273-42.969-42.969-42.969zm0 81.25c-21.109 0-38.281-17.172-38.281-38.281s17.172-38.281 38.281-38.281 38.281 17.172 38.281 38.281-17.172 38.281-38.281 38.281z" />
        <path d="m70.219 32.719-29.594 29.594-13.969-13.969c-0.91406-0.91406-2.3984-0.91406-3.3125 0s-0.91406 2.3984 0 3.3125l15.625 15.625c0.45703 0.45703 1.0547 0.6875 1.6562 0.6875s1.1992-0.23047 1.6562-0.6875l31.25-31.25c0.91406-0.91406 0.91406-2.3984 0-3.3125s-2.3984-0.91406-3.3125 0z" />
      </g>
    </svg>
  );
};
export const thumbUpIcon = (fill) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      x="0px"
      y="0px"
      viewBox="0 0 64 80"
      width="26px"
      height="26px">
      <g>
        <g>
          <g>
            <path d="M58.82,32.38H47.07c-2.86,0-5.18-2.32-5.18-5.18s2.32-5.18,5.18-5.18h11.75c2.86,0,5.18,2.32,5.18,5.18     S61.68,32.38,58.82,32.38z M47.07,23.96c-1.79,0-3.24,1.45-3.24,3.24s1.45,3.24,3.24,3.24h11.75c1.79,0,3.24-1.45,3.24-3.24     s-1.45-3.24-3.24-3.24H47.07z" />
          </g>
          <g>
            <path d="M56.21,41.9h-8.6c-3.16,0-5.73-2.57-5.73-5.73c0-3.16,2.57-5.73,5.73-5.73h8.6c3.16,0,5.73,2.57,5.73,5.73     C61.94,39.33,59.37,41.9,56.21,41.9z M47.62,32.38c-2.09,0-3.79,1.7-3.79,3.79c0,2.09,1.7,3.79,3.79,3.79h8.6     c2.09,0,3.79-1.7,3.79-3.79c0-2.09-1.7-3.79-3.79-3.79H47.62z" />
          </g>
          <g>
            <path d="M55.25,50.76h-8.32c-2.98,0-5.4-2.42-5.4-5.4c0-2.98,2.42-5.4,5.4-5.4h8.32c2.98,0,5.4,2.42,5.4,5.4     C60.65,48.34,58.22,50.76,55.25,50.76z M46.93,41.9c-1.91,0-3.46,1.55-3.46,3.46c0,1.91,1.55,3.46,3.46,3.46h8.32     c1.91,0,3.46-1.55,3.46-3.46c0-1.91-1.55-3.46-3.46-3.46H46.93z" />
          </g>
          <g>
            <path d="M52.51,60.16H47.2c-3.13,0-5.67-2.54-5.67-5.67c0-3.13,2.54-5.67,5.67-5.67h5.31c3.13,0,5.67,2.54,5.67,5.67     C58.17,57.62,55.63,60.16,52.51,60.16z M47.2,50.76c-2.06,0-3.73,1.67-3.73,3.73c0,2.06,1.67,3.73,3.73,3.73h5.31     c2.06,0,3.73-1.67,3.73-3.73c0-2.06-1.67-3.73-3.73-3.73H47.2z" />
          </g>
        </g>
        <g>
          <path d="M47.2,60.16H30.3c-5.17,0-10.04-2.76-12.7-7.19l-1.41-2.36c-0.27-0.46-0.12-1.05,0.33-1.33c0.46-0.27,1.05-0.13,1.33,0.33    l1.41,2.36c2.31,3.86,6.54,6.25,11.04,6.25h16.9c0.54,0,0.97,0.43,0.97,0.97C48.17,59.73,47.73,60.16,47.2,60.16z" />
        </g>
        <g>
          <path d="M28.36,41.02c-0.49,0-0.91-0.37-0.96-0.86c-0.06-0.53,0.32-1.01,0.85-1.07c7.4-0.84,11.38-4.51,13.72-12.66    c0.11-0.37,0.21-0.74,0.31-1.12c0.04-0.18,0.13-0.36,0.26-0.49c0.38-0.38,1-0.38,1.38,0c0.26,0.26,0.35,0.64,0.24,0.97    c-0.11,0.41-0.21,0.8-0.32,1.18c-2.56,8.91-7.15,13.12-15.36,14.05C28.43,41.02,28.4,41.02,28.36,41.02z" />
        </g>
        <g>
          <path d="M17.02,26.83c-0.24,0-0.48-0.09-0.66-0.26c-0.39-0.37-0.41-0.98-0.04-1.37c1.61-1.71,3.12-3.16,4.63-4.44    c2.66-2.28,6.04-3.66,9.53-3.89c4.29-0.29,7.65-3.87,7.65-8.17c0-0.26-0.01-0.54-0.04-0.8l-0.02-0.25    c-0.12-1.16,0.29-2.32,1.11-3.16c0.83-0.84,1.97-1.26,3.15-1.17c4.77,0.39,8.5,4.44,8.5,9.21c0,1.15-0.22,2.3-0.65,3.4l-0.11,0.29    c-1.11,2.81-2.16,5.47-3.97,7.76c-0.33,0.42-0.94,0.49-1.36,0.16c-0.42-0.33-0.49-0.94-0.16-1.36c1.64-2.07,2.63-4.59,3.69-7.26    l0.11-0.29c0.34-0.88,0.52-1.78,0.52-2.69c0-3.77-2.95-6.96-6.72-7.28c-0.6-0.05-1.18,0.17-1.6,0.59    C40.14,6.27,39.93,6.86,40,7.46l0.02,0.25c0.03,0.32,0.05,0.66,0.05,0.99c0,5.31-4.16,9.75-9.46,10.1    c-3.08,0.2-6.06,1.42-8.4,3.43c-1.44,1.22-2.94,2.66-4.48,4.29C17.53,26.72,17.27,26.83,17.02,26.83z" />
        </g>
        <g>
          <path d="M15.67,60.69H2.32C1.04,60.69,0,59.66,0,58.38V23.25c0-1.28,1.04-2.32,2.32-2.32h13.35c1.28,0,2.32,1.04,2.32,2.32v35.13    C17.98,59.66,16.95,60.69,15.67,60.69z M2.32,22.87c-0.21,0-0.38,0.17-0.38,0.38v35.13c0,0.21,0.17,0.38,0.38,0.38h13.35    c0.21,0,0.38-0.17,0.38-0.38V23.25c0-0.21-0.17-0.38-0.38-0.38H2.32z" />
        </g>
        <g>
          <path d="M9.45,56.57c-2.14,0-3.87-1.74-3.87-3.87s1.74-3.87,3.87-3.87c2.14,0,3.87,1.74,3.87,3.87S11.59,56.57,9.45,56.57z     M9.45,50.76c-1.07,0-1.93,0.87-1.93,1.93s0.87,1.93,1.93,1.93c1.07,0,1.93-0.87,1.93-1.93S10.52,50.76,9.45,50.76z" />
        </g>
      </g>
    </svg>
  );
};

export const thumbDownIcon = (fill) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 50 62.5"
      x="0px"
      y="0px"
      width="26px"
      height="26px">
      <g data-name="Layer 120">
        <path d="M48.5,20.75024a3.61641,3.61641,0,0,0-1.71-3.06348,3.583,3.583,0,0,0-1.32617-3.94141,3.5424,3.5424,0,0,0,.34179-1.51465,3.59008,3.59008,0,0,0-3.48925-3.57324c-.0293-.00293-.0586-.0039-.08789-.0039H32.05273a8.01681,8.01681,0,0,0-5.33886,2.03418,2.59884,2.59884,0,0,1-1.55078.65039l-4.55561.30676.00873-.28333A2.71071,2.71071,0,0,0,18.11426,8.5725L4.42383,7.50707A2.71151,2.71151,0,0,0,1.5,10.21215V29.88207A2.71308,2.71308,0,0,0,4.21289,32.595a2.58941,2.58941,0,0,0,.28809-.01562l13.16308-1.40625a2.712,2.712,0,0,0,2.083-1.40528l5.044-.51562a2.32866,2.32866,0,0,1,1.624.48633.27334.27334,0,0,0,.03027.01953A8.06706,8.06706,0,0,1,29.68652,35.552a21.23031,21.23031,0,0,1-.11816,3.59375,3.01022,3.01022,0,0,0,4.41113,3A5.34059,5.34059,0,0,0,36.793,37.45238c.00293-.55273.01367-1.13183.02539-1.72949.02832-1.48144.05664-3.01367-.02148-4.55078a2.04281,2.04281,0,0,1,1.69726-2.1416l6.374-.36524a3.4852,3.4852,0,0,0,3.46387-3.499,3.44721,3.44721,0,0,0-.70312-2.07812A3.57034,3.57034,0,0,0,48.5,20.75024ZM17.45117,29.18481,4.28809,30.59106a.71289.71289,0,0,1-.78809-.709V10.21215a.7121.7121,0,0,1,.71-.71289c.01953,0,.03906,0,.05859.002L17.959,10.56664a.71091.71091,0,0,1,.65723.7334l-.52832,17.19727A.71574.71574,0,0,1,17.45117,29.18481Zm28.14649-5.27735a1.44981,1.44981,0,0,1,.73437,1.25879,1.49838,1.49838,0,0,1-1.52051,1.501l-6.51269.375a4.04623,4.04623,0,0,0-3.5,4.23242c.07519,1.4668.04687,2.96289.01953,4.41016-.01172.60644-.02246,1.19628-.02539,1.76269A3.33744,3.33744,0,0,1,33.0332,40.384a.98113.98113,0,0,1-1.03613-.05566,1.01032,1.01032,0,0,1-.44043-.96484,22.96934,22.96934,0,0,0,.123-3.97657,10.06429,10.06429,0,0,0-4.082-7.26367.98968.98968,0,0,0-.085-.05664,4.2303,4.2303,0,0,0-1.87836-.76123c-.10932-.27038-.23432-.593-.36774-.96728a.37529.37529,0,1,0-.707.252c.08771.24609.17108.46716.24988.67065-.07312.0033-.14545-.00586-.21863.00122l-4.47711.45728.43207-14.06494,4.75207-.32007a4.61138,4.61138,0,0,0,2.74707-1.1543,6.0176,6.0176,0,0,1,4.00781-1.52636H42.18555c.0205.00195.042.00293.06347.00293a1.58238,1.58238,0,0,1,1.55664,1.57421,1.55532,1.55532,0,0,1-.52246,1.16114,1.0001,1.0001,0,0,0,.4375,1.71191,1.58074,1.58074,0,0,1,.89942,2.499.99964.99964,0,0,0,.60058,1.57813,1.59347,1.59347,0,0,1,.416,2.97852.99974.99974,0,0,0-.03906,1.748ZM13.6875,11.93578a3,3,0,1,0,3,3A3.00328,3.00328,0,0,0,13.6875,11.93578Zm0,4a1,1,0,1,1,1-1A1.00067,1.00067,0,0,1,13.6875,15.93578Zm10.748,7.56446a.37361.37361,0,0,1-.28125.44921.35783.35783,0,0,1-.084.00977.375.375,0,0,1-.36523-.291c-.15528-.67578-.2793-1.34961-.36719-2.00195a.37648.37648,0,0,1,.32227-.42187.38159.38159,0,0,1,.42187.32226C24.166,22.19652,24.28516,22.84692,24.43555,23.50024Zm-.88575-4.50391a.374.374,0,0,1-.35449-.39356l.01367-.23339a.35035.35035,0,0,1,.39844-.34961.37428.37428,0,0,1,.34961.39843l-.01367.22364a.37434.37434,0,0,1-.374.35547Z" />
      </g>
    </svg>
  );
};

export const playIcon = (fill) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      x="0px"
      y="0px"
      viewBox="0 0 100 125"
      enable-background="new 0 0 100 100"
      width="36px"
      height="36px">
      <g>
        <path d="M64.693,30.714H35.308c-6.255,0-11.344,4.632-11.344,10.324v17.925c0,5.692,5.089,10.323,11.344,10.323h29.385   c6.254,0,11.342-4.631,11.342-10.323V41.038C76.035,35.346,70.947,30.714,64.693,30.714z M74.281,58.963   c0,4.725-4.301,8.568-9.588,8.568H35.308c-5.287,0-9.589-3.844-9.589-8.568V41.038c0-4.725,4.302-8.568,9.589-8.568h29.385   c5.287,0,9.588,3.844,9.588,8.568V58.963z" />
        <path d="M42.106,61.537l19.98-11.536l-19.98-11.535V61.537z M43.861,41.507l14.713,8.494l-14.713,8.495V41.507z" />
      </g>
    </svg>
  );
};

export const commentsIcon = (fill) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      viewBox="-5.0 -10.0 110.0 135.0"
      width="26px"
      height="26px">
      <g>
        <path d="m22.352 92.352c-0.32812 0-0.70703-0.09375-1.0352-0.23437-0.80078-0.375-1.3164-1.2227-1.3164-2.1172v-15.293h-12.941c-3.9062 0-7.0586-3.1523-7.0586-7.0586v-52.941c0-3.9062 3.1523-7.0586 7.0586-7.0586h85.883c3.9062 0 7.0586 3.1523 7.0586 7.0586v52.941c0 3.9062-3.1523 7.0586-7.0586 7.0586h-47.434l-21.695 17.129c-0.42578 0.32812-0.94141 0.51562-1.4609 0.51562zm-15.293-80c-1.3164 0-2.3516 1.0352-2.3516 2.3555v52.941c0 1.3164 1.0352 2.3516 2.3516 2.3516h15.293c1.3164 0 2.3516 1.0352 2.3516 2.3516v12.801l18.543-14.637c0.42188-0.32812 0.94141-0.51953 1.457-0.51953h48.234c1.3164 0 2.3516-1.0352 2.3516-2.3516l0.003907-52.938c0-1.3164-1.0352-2.3516-2.3516-2.3516z" />
        <path d="m77.648 35.883h-52.941c-1.3164 0-2.3516-1.0352-2.3516-2.3516-0.003907-1.3203 1.0312-2.3555 2.3516-2.3555h52.941c1.3164 0 2.3516 1.0352 2.3516 2.3555 0 1.3164-1.0352 2.3516-2.3516 2.3516z" />
        <path d="m77.648 50.375h-52.941c-1.3164 0-2.3516-1.0352-2.3516-2.3516 0-1.3164 1.0352-2.3516 2.3516-2.3516h52.941c1.3164 0 2.3516 1.0352 2.3516 2.3516 0 1.3164-1.0352 2.3516-2.3516 2.3516z" />
      </g>
    </svg>
  );
};

export const liveIcons = (fill) => {
  return (
    <svg
      width="26px"
      height="26px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg">
      <g
        id="页面-1"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd">
        <g
          id="Media"
          transform="translate(-864.000000, -144.000000)"
          fillRule="nonzero">
          <g id="live_photo_fill" transform="translate(864.000000, 144.000000)">
            <path
              d="M24,0 L24,24 L0,24 L0,0 L24,0 Z M12.5934901,23.257841 L12.5819402,23.2595131 L12.5108777,23.2950439 L12.4918791,23.2987469 L12.4918791,23.2987469 L12.4767152,23.2950439 L12.4056548,23.2595131 C12.3958229,23.2563662 12.3870493,23.2590235 12.3821421,23.2649074 L12.3780323,23.275831 L12.360941,23.7031097 L12.3658947,23.7234994 L12.3769048,23.7357139 L12.4804777,23.8096931 L12.4953491,23.8136134 L12.4953491,23.8136134 L12.5071152,23.8096931 L12.6106902,23.7357139 L12.6232938,23.7196733 L12.6232938,23.7196733 L12.6266527,23.7031097 L12.609561,23.275831 C12.6075724,23.2657013 12.6010112,23.2592993 12.5934901,23.257841 L12.5934901,23.257841 Z M12.8583906,23.1452862 L12.8445485,23.1473072 L12.6598443,23.2396597 L12.6498822,23.2499052 L12.6498822,23.2499052 L12.6471943,23.2611114 L12.6650943,23.6906389 L12.6699349,23.7034178 L12.6699349,23.7034178 L12.678386,23.7104931 L12.8793402,23.8032389 C12.8914285,23.8068999 12.9022333,23.8029875 12.9078286,23.7952264 L12.9118235,23.7811639 L12.8776777,23.1665331 C12.8752882,23.1545897 12.8674102,23.1470016 12.8583906,23.1452862 L12.8583906,23.1452862 Z M12.1430473,23.1473072 C12.1332178,23.1423925 12.1221763,23.1452606 12.1156365,23.1525954 L12.1099173,23.1665331 L12.0757714,23.7811639 C12.0751323,23.7926639 12.0828099,23.8018602 12.0926481,23.8045676 L12.108256,23.8032389 L12.3092106,23.7104931 L12.3186497,23.7024347 L12.3186497,23.7024347 L12.3225043,23.6906389 L12.340401,23.2611114 L12.337245,23.2485176 L12.337245,23.2485176 L12.3277531,23.2396597 L12.1430473,23.1473072 Z"
              id="MingCute"
              fillRule="nonzero"></path>
            <path
              d="M12.1914,19.9978 C12.7436,19.9848 13.2016,20.4219 13.2146,20.9741 C13.2275,21.5262 12.7904,21.9843 12.2383,21.9972 L12,22 L12,22 L11.7617,21.9972 L11.7617,21.9972 C11.2096,21.9843 10.7725,21.5262 10.7854,20.9741 C10.7984,20.4219 11.2564,19.9848 11.8086,19.9978 L12,20 L12,20 L12.1914,19.9978 L12.1914,19.9978 Z M16.1635,18.8327 C16.6348,18.5448 17.2503,18.6935 17.5381,19.1649 C17.826,19.6362 17.6773,20.2516 17.206,20.5395 C17.0708,20.6221 16.9334,20.7016 16.794,20.7779 C16.3095,21.043 15.7018,20.8652 15.4367,20.3807 C15.1716,19.8962 15.3494,19.2885 15.8339,19.0234 C15.9454,18.9624 16.0553,18.8988 16.1635,18.8327 Z M6.46185,19.1649 C6.74974,18.6935 7.3652,18.5448 7.83651,18.8327 C7.94472,18.8988 8.0546,18.9624 8.16608,19.0234 C8.65058,19.2885 8.82843,19.8962 8.56332,20.3807 C8.29821,20.8652 7.69054,21.043 7.20604,20.7779 C7.06663,20.7016 6.92924,20.6221 6.79398,20.5395 C6.32267,20.2516 6.17397,19.6362 6.46185,19.1649 Z M12,6 C15.3137,6 18,8.68629 18,12 C18,15.3137 15.3137,18 12,18 C8.68629,18 6,15.3137 6,12 C6,8.68629 8.68629,6 12,6 Z M19.0234,15.8339 C19.2885,15.3494 19.8962,15.1716 20.3807,15.4367 C20.8652,15.7018 21.043,16.3095 20.7779,16.794 C20.7016,16.9334 20.6221,17.0708 20.5395,17.206 C20.2516,17.6773 19.6362,17.826 19.1649,17.5381 C18.6935,17.2503 18.5448,16.6348 18.8327,16.1635 C18.8988,16.0553 18.9624,15.9454 19.0234,15.8339 Z M3.61932,15.4367 C4.10382,15.1716 4.71149,15.3494 4.9766,15.8339 C5.0376,15.9454 5.10118,16.0553 5.16728,16.1635 C5.45516,16.6348 5.30646,17.2503 4.83514,17.5381 C4.36383,17.826 3.74837,17.6773 3.46048,17.206 C3.37787,17.0708 3.29837,16.9334 3.22208,16.794 C2.95697,16.3095 3.13482,15.7018 3.61932,15.4367 Z M12,10 C10.8954,10 10,10.8954 10,12 C10,13.1046 10.8954,14 12,14 C13.1046,14 14,13.1046 14,12 C14,10.8954 13.1046,10 12,10 Z M3.02594,10.7854 C3.57807,10.7984 4.01518,11.2564 4.00224,11.8086 L4.00056125,12.09585 L4.00224,12.1914 C4.01518,12.7436 3.57807,13.2016 3.02594,13.2146 C2.4738,13.2275 2.01572,12.7904 2.00279,12.2383 L2.0006975,11.8807 L2.00279,11.7617 C2.01572,11.2096 2.4738,10.7725 3.02594,10.7854 Z M20.9741,10.7854 C21.5262,10.7725 21.9843,11.2096 21.9972,11.7617 L22,12 L22,12 L21.9972,12.2383 C21.9843,12.7904 21.5262,13.2275 20.9741,13.2146 C20.4219,13.2016 19.9848,12.7436 19.9978,12.1914 L20,12 L20,12 L19.9978,11.8086 C19.9848,11.2564 20.4219,10.7984 20.9741,10.7854 Z M19.1649,6.46185 C19.6362,6.17397 20.2516,6.32267 20.5395,6.79398 C20.6221,6.92924 20.7016,7.06663 20.7779,7.20604 C21.043,7.69054 20.8652,8.29821 20.3807,8.56332 C19.8962,8.82843 19.2885,8.65058 19.0234,8.16608 C18.9624,8.0546 18.8988,7.94472 18.8327,7.83651 C18.5448,7.3652 18.6935,6.74974 19.1649,6.46185 Z M3.46048,6.79398 C3.74837,6.32267 4.36383,6.17397 4.83514,6.46185 C5.30646,6.74974 5.45516,7.3652 5.16727,7.83651 C5.10118,7.94472 5.0376,8.0546 4.9766,8.16608 C4.71149,8.65058 4.10382,8.82843 3.61932,8.56332 C3.13482,8.29821 2.95697,7.69054 3.22208,7.20604 C3.29837,7.06663 3.37787,6.92924 3.46048,6.79398 Z M15.4367,3.61932 C15.7018,3.13482 16.3095,2.95697 16.794,3.22208 C16.9334,3.29837 17.0708,3.37787 17.206,3.46048 C17.6773,3.74837 17.826,4.36383 17.5381,4.83514 C17.2503,5.30646 16.6348,5.45516 16.1635,5.16727 C16.0553,5.10118 15.9454,5.0376 15.8339,4.9766 C15.3494,4.71149 15.1716,4.10382 15.4367,3.61932 Z M7.20604,3.22208 C7.69054,2.95697 8.29821,3.13482 8.56332,3.61932 C8.82843,4.10382 8.65058,4.71149 8.16608,4.9766 C8.0546,5.0376 7.94472,5.10118 7.83651,5.16728 C7.3652,5.45516 6.74974,5.30646 6.46185,4.83514 C6.17397,4.36383 6.32267,3.74837 6.79398,3.46048 C6.92924,3.37787 7.06663,3.29837 7.20604,3.22208 Z M12,2 L12.2383,2.00279 C12.7904,2.01572 13.2275,2.4738 13.2146,3.02594 C13.2016,3.57807 12.7436,4.01518 12.1914,4.00224 L12,4 L12,4 L11.8086,4.00224 L11.8086,4.00224 C11.2564,4.01518 10.7984,3.57807 10.7854,3.02594 C10.7725,2.4738 11.2096,2.01572 11.7617,2.00279 L12,2 L12,2 Z"
              id="形状"
              fill="grey"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export const reachIcon = (fill) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512 640"
      x="0px"
      y="0px"
      width="26px"
      height="26px">
      <g>
        <path d="M506.1,55.441a4,4,0,0,0-5.657,0L451.633,104.25a3.985,3.985,0,0,0-.967,1.563L446.6,118.026a115.437,115.437,0,0,1-45.265,59.263,3.953,3.953,0,0,0-.609.5l-28.294,28.294a11.985,11.985,0,0,1-16.946,0l-.013-.017-.009-.007a11.983,11.983,0,0,1,.033-16.946l36.872-36.735a4,4,0,0,0-.5-6.092L371.928,132.1a4,4,0,0,0-3.895-.418l-79.2,33.941a4,4,0,0,0-1.252.848L245.157,208.9a12,12,0,0,1-16.97-16.971L409.309,10.809a4,4,0,0,0-5.657-5.657l-38.97,38.97c-29.665,1.286-57.263,13.249-79.9,34.672l-28.805,27.259L227.95,79.533C195.593,48.91,153.073,37.667,111.293,48.685c-43.884,11.573-78.542,46.094-92.71,92.342a150.448,150.448,0,0,0-1.535,82.785c7.249,27.28,21.781,51.273,42.025,69.385l40.192,35.96a74.671,74.671,0,0,0-29.822,18.2L4.4,412.4a4,4,0,0,0,5.657,5.657L75.1,353.018a66.669,66.669,0,0,1,40.5-19.159,4,4,0,0,0,2.435-1.152l49.688-49.687a12,12,0,1,1,16.97,16.97l-40.848,40.848A4,4,0,1,0,149.5,346.5l67.883-67.883a12,12,0,1,1,16.97,16.97l-56.568,56.569a4,4,0,0,0,5.656,5.657l67.883-67.88A12,12,0,1,1,268.3,306.9l-5.581,5.582c-.026.025-.054.046-.079.071s-.021.028-.033.04l-42.673,42.673a20.006,20.006,0,0,0-25.176,2.542L169.3,383.265l-2.829-2.828a44.049,44.049,0,0,0-62.225,0,4,4,0,0,0,5.656,5.657,36.041,36.041,0,0,1,50.912,0l5.658,5.656a4,4,0,0,0,5.656,0l28.284-28.284a12,12,0,1,1,16.958,16.983l-40.3,40.652a4.077,4.077,0,0,0-.271.334l-54.16,20.31a3.972,3.972,0,0,0-1.424.917L61.172,502.71a4,4,0,0,0,5.656,5.658l59.437-59.437,61.488-23.058q6.786-2.544,13.211-5.725l52.345,46.833a4,4,0,0,0,5.344-.01l194.792-175.56a140.842,140.842,0,0,0,41.621-69.191,149.947,149.947,0,0,0-1.7-82.381,143.654,143.654,0,0,0-22.111-43.9L506.1,61.1A4,4,0,0,0,506.1,55.441ZM250.813,214.559,292.7,172.677l76.424-32.753L383.36,150.06l-33.514,33.391a19.988,19.988,0,0,0-2.578,25.164l-12.014,12.014a11.939,11.939,0,0,1-19.3-3.339L345,188.249a4,4,0,0,0-5.656-5.658l-43.283,43.283a11.939,11.939,0,0,1-19.286-3.331l46.652-46.651a4,4,0,0,0-5.656-5.658l-61.3,61.3a12,12,0,0,1-20.482-8.491,12.049,12.049,0,0,1,.3-2.642c.129,0,.256.019.386.019A19.868,19.868,0,0,0,250.813,214.559Zm-27.77,171.535a20.008,20.008,0,0,0,2.548-25.168l42.786-42.786a12,12,0,0,1,16.893,17.042l-52.236,52.235a134.1,134.1,0,0,1-37.587,26.515ZM485.722,142.2c16.023,51.989,1.252,108.227-37.632,143.272L255.966,458.624,208.5,416.156a142.331,142.331,0,0,0,30.191-23.082l52.236-52.236a19.976,19.976,0,0,0-12.942-34.083,20,20,0,0,0-32.312-22.484l-.018.018a19.984,19.984,0,0,0-33.924-11.333L195.982,288.7a19.975,19.975,0,0,0-33.913-11.341l-48.691,48.691c-1.6.189-3.183.446-4.759.738L64.407,287.235C25.8,252.689,10.453,194.874,26.231,143.37c13.352-43.583,45.914-76.087,87.1-86.949,39.039-10.3,78.815.245,109.119,28.922l30.775,29.123a4,4,0,0,0,5.5,0l31.554-29.861c18.878-17.865,41.4-28.714,65.657-31.736L222.53,186.274a19.978,19.978,0,0,0,5.95,32.377,20.085,20.085,0,0,0-.49,4.389,20,20,0,0,0,34.138,14.148l8.773-8.773a20.108,20.108,0,0,0,2.54,3.114,19.988,19.988,0,0,0,28.277,0l8.365-8.365a20.018,20.018,0,0,0,30.825,3.125l12.011-12.012a19.994,19.994,0,0,0,25.164-2.536L406.1,183.723a123.477,123.477,0,0,0,48.085-63.167l3.772-11.317,7.575-7.575A135.911,135.911,0,0,1,485.722,142.2Z" />
      </g>
    </svg>
  );
};

export const engagementIcon = (fill) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      x="0px"
      y="0px"
      viewBox="0 0 512 640"
      width="26px"
      height="26px">
      <path d="M343.5,431.9c2.5-1.2,5.5-0.2,6.7,2.3s0.2,5.5-2.3,6.7c-77.1,38-170.4,21.1-229-42c-23.8-25.6-40.5-57.3-47.9-91.9  l-9.1,26.1c-2.2,6.2-11.6,2.9-9.4-3.3l16.4-46.9c1.3-3.7,6-4.5,8.5-1.6l32.5,37.6c1.8,2.1,1.6,5.2-0.5,7c-2.1,1.8-5.2,1.6-7-0.5  l-22.7-26.2c13.5,73.8,70.5,133.1,145.4,148.2C265.6,455.6,307,450,343.5,431.9L343.5,431.9z M461.5,198.9c2.2-6.2,11.6-2.9,9.4,3.3  l-16.4,46.9c-1.2,3.6-6,4.5-8.5,1.6l-32.4-37.6c-1.8-2.1-1.6-5.2,0.5-7c2.1-1.8,5.2-1.6,7,0.5l22.6,26.3  C426.4,137.6,338.2,71.2,241.3,82c-19.3,2.2-37.9,7.3-55.2,15.1c-2.5,1.1-5.5,0-6.6-2.5c-1.1-2.5,0-5.5,2.5-6.6  c76.2-34.1,165.7-16,222.5,45.2c23.8,25.6,40.5,57.3,47.9,91.9L461.5,198.9z M299.5,369.3c-0.5-0.5-1-1-1.4-1.5l-41.2,22.7  c-1.8,1-3.6,1-5.4,0l-113.4-62.4c-1.8-1-2.7-2.8-2.6-4.7v-62.5H31c-2.8,0-5-2.2-5-5v-53.7c0-29.6,24.2-47.1,50.8-54.9  c-8.7-13.2-14-29.6-14-43.3c0-29.3,23.8-53.1,53.1-53.1s53.1,23.8,53.1,53.1c0,13.7-5.3,30.1-14,43.3c12.8,3.7,25.2,9.7,34.6,18.6  l62.3-34.3c1.6-0.9,3.4-0.8,4.8,0l113.7,62.6c1.8,1,2.7,2.8,2.6,4.7v74.7c4.7,2.7,9,6,13,10.1c24-20.3,59.8-19.2,82.3,3.4  c23.8,23.8,23.8,62.2,0,86L389.3,452c-2,1.9-5.1,1.9-7.1,0L299.5,369.3z M291.8,359.9c-17-25.6-12.2-60.5,12-80.4v0  c12-10,27-14.6,41.6-13.9c6,0.3,11.8,1.4,17.5,3.5v-62l-103.7,57.1v113.8L291.8,359.9z M291.8,326.3c0,13,5,26,14.9,35.9l79.1,79.1  l75.4-75.4c19.8-19.8,19.8-52,0-71.9c-20-20-52-19.8-72,0.2l0,0c-2,2.1-5.5,1.9-7.3-0.3c-17.9-21.5-49.9-24.7-71.5-6.8l0,0  C298.2,297.1,291.8,311.6,291.8,326.3L291.8,326.3z M200.6,171.5c-0.1,0-0.1-0.1-0.2-0.1l-49.6,27.3l103.4,56.9l46.7-25.7  L200.6,171.5z M210.6,165.7l100.5,58.4l46.4-25.5l-103.4-56.9L210.6,165.7z M135.5,198.9c-0.1-1.9,0.8-3.7,2.6-4.7l42.1-23.2  c-8.8-7.3-20.4-12.2-31.8-15.1c-20,22.6-45.1,22.6-65.1,0C59.7,162,36,176.2,36,202.2v48.6h29.6v-25.8c0-6.6,10-6.6,10,0v25.8h59.9  V198.9z M145.5,320.8l103.7,57.1V264.1l-103.7-57.1V320.8z M146.2,73.6c-16.8-16.8-44.1-16.8-60.9,0c-7.8,7.8-12.6,18.6-12.6,30.5  c0,13.2,5.8,29.3,14.9,41.5c17.4,23.1,38.9,23.1,56.3,0c9.2-12.2,14.9-28.3,14.9-41.5C158.9,92.2,154,81.4,146.2,73.6L146.2,73.6z" />
    </svg>
  );
};

export const loadingIcon = (fill) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 400 400"
      width="311"
      height="311"
      preserveAspectRatio="xMidYMid meet">
      <defs>
        <clipPath id="__lottie_element_7">
          <rect width="400" height="400" x="0" y="0" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const deleteNewIcon = (fill) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      x="0px"
      y="0px"
      width="26px"
      height="26px"
      viewBox="0 0 100 125"
      enable-background="new 0 0 100 100">
      <g>
        <path d="M63.692,5H36.308c-0.906,0-1.642,0.735-1.642,1.643v7.485H18.053c-0.907,0-1.644,0.735-1.644,1.644v9.127   c0,0.907,0.736,1.643,1.644,1.643h3.026l4.462,66.926C25.598,94.33,26.316,95,27.181,95h45.639c0.864,0,1.583-0.67,1.64-1.533   l4.462-66.926h3.026c0.907,0,1.644-0.735,1.644-1.643v-9.127c0-0.908-0.736-1.644-1.644-1.644H65.334V6.643   C65.334,5.735,64.599,5,63.692,5z M37.951,8.286h24.098v5.842H37.951V8.286z M71.283,91.714H28.717l-4.344-65.173h51.254   L71.283,91.714z M80.305,17.413v5.842H19.695v-5.842h16.612h27.385H80.305z" />
        <path d="M50,85.872c0.907,0,1.643-0.735,1.643-1.644V34.026c0-0.907-0.735-1.643-1.643-1.643s-1.643,0.735-1.643,1.643v50.202   C48.357,85.137,49.093,85.872,50,85.872z" />
        <path d="M61.66,85.871c0.019,0.001,0.036,0.001,0.056,0.001c0.882,0,1.611-0.699,1.641-1.589l1.672-50.202   c0.03-0.906-0.68-1.666-1.587-1.697c-0.911-0.047-1.667,0.681-1.696,1.588l-1.673,50.203C60.042,85.082,60.753,85.841,61.66,85.871   z" />
        <path d="M38.284,85.872c0.02,0,0.038,0,0.056-0.001c0.907-0.03,1.618-0.789,1.588-1.696l-1.673-50.203   c-0.029-0.907-0.829-1.635-1.696-1.588c-0.907,0.031-1.617,0.791-1.587,1.697l1.672,50.202   C36.673,85.173,37.402,85.872,38.284,85.872z" />
      </g>
    </svg>
  );
};

export const collectionIcon = (fill) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      data-name="Layer 1"
      viewBox="0 0 54 67.5"
      x="0px"
      y="0px"
      width="26px"
      height="26px">
      <path d="M51,24H42V15a3,3,0,0,0-3-3H15a3,3,0,0,0-3,3V28H3a1,1,0,0,1-1-1V3A1,1,0,0,1,3,2H27a1,1,0,0,1,1,1v7a1,1,0,0,0,2,0V3a3,3,0,0,0-3-3H3A3,3,0,0,0,0,3V27a3,3,0,0,0,3,3h9v9a3,3,0,0,0,3,3h7a1,1,0,0,0,0-2H15a1,1,0,0,1-1-1V15a1,1,0,0,1,1-1H39a1,1,0,0,1,1,1v9H27a3,3,0,0,0-3,3V51a3,3,0,0,0,3,3H51a3,3,0,0,0,3-3V27A3,3,0,0,0,51,24Zm1,27a1,1,0,0,1-1,1H27a1,1,0,0,1-1-1V27a1,1,0,0,1,1-1H51a1,1,0,0,1,1,1Z" />
      <path d="M44,38H40V34a1,1,0,0,0-2,0v4H34a1,1,0,0,0,0,2h4v4a1,1,0,0,0,2,0V40h4a1,1,0,0,0,0-2Z" />
    </svg>
  );
};

export const discoveryInfluencerIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.8 19.9996H7.6727C6.43639 19.9996 5.45305 19.398 4.57013 18.5569C2.76269 16.8349 5.73024 15.4588 6.86206 14.7849C8.42446 13.8546 10.2342 13.4719 12 13.6369"
        stroke="#5A5B62"
        // strokeWidth="1.3"
        // strokeLinecap="round"
        // strokeLinejoin="round"
      />
      <path
        d="M14.8001 7.6C14.8001 9.58822 13.1883 11.2 11.2001 11.2C9.21187 11.2 7.6001 9.58822 7.6001 7.6C7.6001 5.61178 9.21187 4 11.2001 4C13.1883 4 14.8001 5.61178 14.8001 7.6Z"
        stroke="#5A5B62"
        // strokeWidth="1.3"
      />
      <path
        d="M18.7201 18.7196L20.0001 19.9996M19.3601 16.4796C19.3601 14.889 18.0707 13.5996 16.4801 13.5996C14.8895 13.5996 13.6001 14.889 13.6001 16.4796C13.6001 18.0702 14.8895 19.3596 16.4801 19.3596C18.0707 19.3596 19.3601 18.0702 19.3601 16.4796Z"
        stroke="#5A5B62"
        // strokeWidth="1.3"
        // strokeLinecap="round"
        // strokeLinejoin="round"
      />
    </svg>
  );
};

export const discoveryInfluencerActiveIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.8 19.9996H7.6727C6.43639 19.9996 5.45305 19.398 4.57013 18.5569C2.76269 16.8349 5.73024 15.4588 6.86206 14.7849C8.42446 13.8546 10.2342 13.4719 12 13.6369"
        stroke="#090A14"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.8001 7.6C14.8001 9.58822 13.1883 11.2 11.2001 11.2C9.21187 11.2 7.6001 9.58822 7.6001 7.6C7.6001 5.61178 9.21187 4 11.2001 4C13.1883 4 14.8001 5.61178 14.8001 7.6Z"
        stroke="#090A14"
        strokeWidth="1.3"
      />
      <path
        d="M18.7201 18.7196L20.0001 19.9996L18.7201 18.7196ZM19.3601 16.4796C19.3601 14.889 18.0707 13.5996 16.4801 13.5996C14.8895 13.5996 13.6001 14.889 13.6001 16.4796C13.6001 18.0702 14.8895 19.3596 16.4801 19.3596C18.0707 19.3596 19.3601 18.0702 19.3601 16.4796Z"
        fill="#090A14"
      />
      <path
        d="M18.7201 18.7196L20.0001 19.9996M19.3601 16.4796C19.3601 14.889 18.0707 13.5996 16.4801 13.5996C14.8895 13.5996 13.6001 14.889 13.6001 16.4796C13.6001 18.0702 14.8895 19.3596 16.4801 19.3596C18.0707 19.3596 19.3601 18.0702 19.3601 16.4796Z"
        stroke="#090A14"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const contractIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.8 20.9416C8.02881 20.9416 6.14319 20.9416 4.97163 19.7011C3.80005 18.4606 3.80005 16.4639 3.80005 12.4708C3.80005 8.47762 3.80005 6.48104 4.97163 5.24052C6.14319 4 8.02881 4 11.8 4C15.5712 4 17.4569 4 18.6285 5.24052C19.8 6.48104 19.8 8.47762 19.8 12.4708C19.8 16.4639 19.8 18.4606 18.6285 19.7011C17.4569 20.9416 15.5712 20.9416 11.8 20.9416Z"
        stroke="#5A5B62"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.6994 9.1714C13.6994 10.211 12.8567 11.0538 11.8172 11.0538C10.7775 11.0538 9.93481 10.211 9.93481 9.1714C9.93481 8.13181 10.7775 7.28906 11.8172 7.28906C12.8567 7.28906 13.6994 8.13181 13.6994 9.1714Z"
        stroke="#5A5B62"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.09467 15.9664C9.09077 14.4329 10.6726 13.8582 11.8171 13.8594C12.9616 13.8606 14.4971 14.4329 15.4932 15.9664C15.5576 16.0656 15.5754 16.1877 15.5172 16.2908C15.2842 16.7039 14.561 17.5236 14.0386 17.5792C13.4383 17.643 11.8682 17.6519 11.8184 17.6522C11.7685 17.6519 10.1498 17.643 9.54929 17.5792C9.02688 17.5236 8.3036 16.7039 8.07065 16.2908C8.01253 16.1877 8.03028 16.0656 8.09467 15.9664Z"
        stroke="#5A5B62"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const contractIconActive = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.8 20.9416C8.02881 20.9416 6.14319 20.9416 4.97163 19.7011C3.80005 18.4606 3.80005 16.4639 3.80005 12.4708C3.80005 8.47762 3.80005 6.48104 4.97163 5.24052C6.14319 4 8.02881 4 11.8 4C15.5712 4 17.4569 4 18.6285 5.24052C19.8 6.48104 19.8 8.47762 19.8 12.4708C19.8 16.4639 19.8 18.4606 18.6285 19.7011C17.4569 20.9416 15.5712 20.9416 11.8 20.9416ZM13.6992 9.1714C13.6992 10.211 12.8565 11.0538 11.8169 11.0538C10.7773 11.0538 9.93457 10.211 9.93457 9.1714C9.93457 8.13181 10.7773 7.28906 11.8169 7.28906C12.8565 7.28906 13.6992 8.13181 13.6992 9.1714ZM11.8171 13.8594C10.6726 13.8582 9.09077 14.4329 8.09468 15.9664C8.03028 16.0656 8.01253 16.1877 8.07065 16.2908C8.3036 16.7039 9.02688 17.5236 9.54929 17.5792C10.1479 17.6428 11.7579 17.6519 11.8178 17.6522L11.8184 17.6522C11.8682 17.6519 13.4383 17.643 14.0386 17.5792C14.561 17.5236 15.2842 16.7039 15.5172 16.2908C15.5754 16.1877 15.5576 16.0656 15.4932 15.9664C14.4971 14.4329 12.9616 13.8606 11.8171 13.8594Z"
        fill="#090A14"
      />
    </svg>
  );
};
export const creativesIcons = (fill) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13.9624 12.7154C13.8412 13.2168 13.2685 13.5711 12.1231 14.2798C11.0157 14.9647 10.4621 15.3073 10.0159 15.1696C9.83142 15.1126 9.66335 15.0046 9.52781 14.8556C9.19995 14.4954 9.19995 13.7968 9.19995 12.3996C9.19995 11.0024 9.19995 10.3038 9.52781 9.94357C9.66335 9.79466 9.83142 9.68655 10.0159 9.62963C10.4621 9.49196 11.0157 9.83446 12.1231 10.5194C13.2685 11.2281 13.8412 11.5824 13.9624 12.0838C14.0124 12.2907 14.0124 12.5085 13.9624 12.7154Z"
        stroke="#5A5B62"
        strokeWidth="1.2"
        strokeLinejoin="round"
      />
      <path
        d="M19.1982 11.2008C19.2 11.5769 19.2 11.9762 19.2 12.4008C19.2 15.9834 19.2 17.7748 18.087 18.8878C16.974 20.0008 15.1826 20.0008 11.6 20.0008C8.01733 20.0008 6.22599 20.0008 5.11299 18.8878C4 17.7748 4 15.9834 4 12.4008C4 8.81811 4 7.02677 5.11299 5.91377C6.22599 4.80078 8.01733 4.80078 11.6 4.80078C12.0246 4.80078 12.4239 4.80078 12.8 4.80263"
        stroke="#5A5B62"
        strokeWidth="1.2"
        strokeLinecap="round"
      />
      <path
        d="M17.1999 4L17.4062 4.55762C17.6768 5.28882 17.8121 5.65442 18.0788 5.92111C18.3455 6.18782 18.7111 6.3231 19.4423 6.59366L19.9999 6.8L19.4423 7.00634C18.7111 7.2769 18.3455 7.41219 18.0788 7.67889C17.8121 7.94558 17.6768 8.31118 17.4062 9.04238L17.1999 9.6L16.9936 9.04238C16.723 8.31118 16.5877 7.94558 16.321 7.67889C16.0543 7.41219 15.6887 7.2769 14.9575 7.00634L14.3999 6.8L14.9575 6.59366C15.6887 6.3231 16.0543 6.18782 16.321 5.92111C16.5877 5.65442 16.723 5.28882 16.9936 4.55762L17.1999 4Z"
        stroke="#5A5B62"
        strokeWidth="1.2"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const notificationsIconsActive = (fill) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="24"
      height="24"
      color="#5A5B62"
      fill="none">
      <path
        d="M2.52992 14.394C2.31727 15.7471 3.268 16.6862 4.43205 17.1542C8.89481 18.9486 15.1052 18.9486 19.5679 17.1542C20.732 16.6862 21.6827 15.7471 21.4701 14.394C21.3394 13.5625 20.6932 12.8701 20.2144 12.194C19.5873 11.2975 19.525 10.3197 19.5249 9.27941C19.5249 5.2591 16.1559 2 12 2C7.84413 2 4.47513 5.2591 4.47513 9.27941C4.47503 10.3197 4.41272 11.2975 3.78561 12.194C3.30684 12.8701 2.66061 13.5625 2.52992 14.394Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 21C9.79613 21.6219 10.8475 22 12 22C13.1525 22 14.2039 21.6219 15 21"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const PayoutIconsActive = (fill) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="24"
      height="24"
      color="#5A5B62"
      fill="none">
      <path
        d="M4 18.6458V8.05426C4 5.20025 4 3.77325 4.87868 2.88663C5.75736 2 7.17157 2 10 2H14C16.8284 2 18.2426 2 19.1213 2.88663C20 3.77325 20 5.20025 20 8.05426V18.6458C20 20.1575 20 20.9133 19.538 21.2108C18.7831 21.6971 17.6161 20.6774 17.0291 20.3073C16.5441 20.0014 16.3017 19.8485 16.0325 19.8397C15.7417 19.8301 15.4949 19.9768 14.9709 20.3073L13.06 21.5124C12.5445 21.8374 12.2868 22 12 22C11.7132 22 11.4555 21.8374 10.94 21.5124L9.02913 20.3073C8.54415 20.0014 8.30166 19.8485 8.03253 19.8397C7.74172 19.8301 7.49493 19.9768 6.97087 20.3073C6.38395 20.6774 5.21687 21.6971 4.46195 21.2108C4 20.9133 4 20.1575 4 18.6458Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11 11H8"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14 7L8 7"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const KYCIconsActive = (fill) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="24"
      height="24"
      color="#5A5B62"
      fill="none">
      <path
        d="M14.9805 7.01556C14.9805 7.01556 15.4805 7.51556 15.9805 8.51556C15.9805 8.51556 17.5687 6.01556 18.9805 5.51556"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.99491 2.02134C7.49644 1.91556 5.56618 2.20338 5.56618 2.20338C4.34733 2.29053 2.01152 2.97385 2.01154 6.96454C2.01156 10.9213 1.9857 15.7993 2.01154 17.7439C2.01154 18.932 2.74716 21.7033 5.29332 21.8518C8.38816 22.0324 13.9628 22.0708 16.5205 21.8518C17.2052 21.8132 19.4847 21.2757 19.7732 18.7956C20.0721 16.2263 20.0126 14.4407 20.0126 14.0157"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.9999 7.01556C21.9999 9.77698 19.7592 12.0156 16.9951 12.0156C14.231 12.0156 11.9903 9.77698 11.9903 7.01556C11.9903 4.25414 14.231 2.01556 16.9951 2.01556C19.7592 2.01556 21.9999 4.25414 21.9999 7.01556Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M6.98053 13.0156H10.9805"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M6.98053 17.0156H14.9805"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
};
export const creativesIconsActive = (fill) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13.9624 12.7154C13.8412 13.2168 13.2685 13.5711 12.1231 14.2798C11.0157 14.9647 10.4621 15.3073 10.0159 15.1696C9.83142 15.1126 9.66335 15.0046 9.52781 14.8556C9.19995 14.4954 9.19995 13.7968 9.19995 12.3996C9.19995 11.0024 9.19995 10.3038 9.52781 9.94357C9.66335 9.79466 9.83142 9.68655 10.0159 9.62963C10.4621 9.49196 11.0157 9.83446 12.1231 10.5194C13.2685 11.2281 13.8412 11.5824 13.9624 12.0838C14.0124 12.2907 14.0124 12.5085 13.9624 12.7154Z"
        fill="#090A14"
        stroke="#090A14"
        strokeWidth="1.2"
        strokeLinejoin="round"
      />
      <path
        d="M19.1982 11.2008C19.2 11.5769 19.2 11.9762 19.2 12.4008C19.2 15.9834 19.2 17.7748 18.087 18.8878C16.974 20.0008 15.1826 20.0008 11.6 20.0008C8.01733 20.0008 6.22599 20.0008 5.11299 18.8878C4 17.7748 4 15.9834 4 12.4008C4 8.81811 4 7.02677 5.11299 5.91377C6.22599 4.80078 8.01733 4.80078 11.6 4.80078C12.0246 4.80078 12.4239 4.80078 12.8 4.80263"
        stroke="#090A14"
        strokeWidth="1.2"
        strokeLinecap="round"
      />
      <path
        d="M17.1999 4L17.4062 4.55762C17.6768 5.28882 17.8121 5.65442 18.0788 5.92111C18.3455 6.18782 18.7111 6.3231 19.4423 6.59366L19.9999 6.8L19.4423 7.00634C18.7111 7.2769 18.3455 7.41219 18.0788 7.67889C17.8121 7.94558 17.6768 8.31118 17.4062 9.04238L17.1999 9.6L16.9936 9.04238C16.723 8.31118 16.5877 7.94558 16.321 7.67889C16.0543 7.41219 15.6887 7.2769 14.9575 7.00634L14.3999 6.8L14.9575 6.59366C15.6887 6.3231 16.0543 6.18782 16.321 5.92111C16.5877 5.65442 16.723 5.28882 16.9936 4.55762L17.1999 4Z"
        fill="#090A14"
        stroke="#090A14"
        strokeWidth="1.2"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const collectionIcons = (fill) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M19.1788 16.7258C19.7919 16.7258 20.2795 16.3401 20.7174 15.8006C21.6137 14.6963 20.1421 13.8139 19.5808 13.3818C19.0103 12.9424 18.3732 12.6936 17.7274 12.6351M16.9092 10.9989C18.0389 10.9989 18.9547 10.0831 18.9547 8.95354C18.9547 7.82393 18.0389 6.9082 16.9092 6.9082"
        stroke="#5A5B62"
        strokeWidth="1.3"
        strokeLinecap="round"
      />
      <path
        d="M4.82126 16.7258C4.20818 16.7258 3.72056 16.3401 3.28272 15.8006C2.38643 14.6963 3.85801 13.8139 4.41927 13.3818C4.98982 12.9424 5.62687 12.6936 6.27276 12.6351M6.68186 10.9989C5.55217 10.9989 4.63638 10.0831 4.63638 8.95354C4.63638 7.82393 5.55217 6.9082 6.68186 6.9082"
        stroke="#5A5B62"
        strokeWidth="1.3"
        strokeLinecap="round"
      />
      <path
        d="M8.79568 14.3622C7.95967 14.8791 5.76771 15.9346 7.10277 17.2553C7.75493 17.9005 8.48127 18.3619 9.39445 18.3619H14.6053C15.5185 18.3619 16.2448 17.9005 16.897 17.2553C18.232 15.9346 16.0401 14.8791 15.2041 14.3622C13.2436 13.1501 10.7561 13.1501 8.79568 14.3622Z"
        stroke="#5A5B62"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.8638 8.13495C14.8638 9.71641 13.5817 10.9984 12.0002 10.9984C10.4186 10.9984 9.13647 9.71641 9.13647 8.13495C9.13647 6.5535 10.4186 5.27148 12.0002 5.27148C13.5817 5.27148 14.8638 6.5535 14.8638 8.13495Z"
        stroke="#5A5B62"
        strokeWidth="1.3"
      />
    </svg>
  );
};
export const collectionIconsActive = (fill) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M19.1788 16.7258C19.7919 16.7258 20.2795 16.3401 20.7174 15.8006C21.6137 14.6963 20.1421 13.8139 19.5808 13.3818C19.0103 12.9424 18.3732 12.6936 17.7274 12.6351M16.9092 10.9989C18.0389 10.9989 18.9547 10.0831 18.9547 8.95354C18.9547 7.82393 18.0389 6.9082 16.9092 6.9082"
        stroke="#090A14"
        strokeWidth="1.3"
        strokeLinecap="round"
      />
      <path
        d="M4.82126 16.7258C4.20818 16.7258 3.72056 16.3401 3.28272 15.8006C2.38643 14.6963 3.85801 13.8139 4.41927 13.3818C4.98982 12.9424 5.62687 12.6936 6.27276 12.6351M6.68186 10.9989C5.55217 10.9989 4.63638 10.0831 4.63638 8.95354C4.63638 7.82393 5.55217 6.9082 6.68186 6.9082"
        stroke="#090A14"
        strokeWidth="1.3"
        strokeLinecap="round"
      />
      <path
        d="M8.79568 14.3622C7.95967 14.8791 5.76771 15.9346 7.10277 17.2553C7.75493 17.9005 8.48127 18.3619 9.39445 18.3619H14.6053C15.5185 18.3619 16.2448 17.9005 16.897 17.2553C18.232 15.9346 16.0401 14.8791 15.2041 14.3622C13.2436 13.1501 10.7561 13.1501 8.79568 14.3622Z"
        fill="#090A14"
        stroke="#090A14"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.8638 8.13495C14.8638 9.71641 13.5817 10.9984 12.0002 10.9984C10.4186 10.9984 9.13647 9.71641 9.13647 8.13495C9.13647 6.5535 10.4186 5.27148 12.0002 5.27148C13.5817 5.27148 14.8638 6.5535 14.8638 8.13495Z"
        fill="#090A14"
        stroke="#090A14"
        strokeWidth="1.3"
      />
    </svg>
  );
};

export const crossCloseIcon = (fill) => {
  return (
    <svg
      fill="#000000"
      height="24px"
      width="24px"
      version="1.1"
      id="Capa_1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 490 490">
      <polygon
        points="456.851,0 245,212.564 33.149,0 0.708,32.337 212.669,245.004 0.708,457.678 33.149,490 245,277.443 456.851,490 
   489.292,457.678 277.331,245.004 489.292,32.337 "
      />
    </svg>
  );
};

export const shareIcons = (props) => {
  const stroke =
    (typeof props === "string" && props) ||
    props?.color ||
    props?.fill ||
    "#1977F2";
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.8298 3.75H6.96175C4.50652 3.75 3.2789 3.75 2.51616 4.48223C1.75342 5.21447 1.75342 6.39297 1.75342 8.75V12.0833C1.75342 14.4403 1.75342 15.6188 2.51616 16.3511C3.2789 17.0833 4.50652 17.0833 6.96175 17.0833H10.4673C12.9225 17.0833 14.1501 17.0833 14.9129 16.3511C15.407 15.8767 15.581 15.2149 15.6423 14.1667"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.4723 5.83329V3.21125C13.4723 3.04853 13.6097 2.91663 13.7792 2.91663C13.8605 2.91663 13.9386 2.94767 13.9962 3.00292L17.9396 6.78867C18.1362 6.97731 18.2465 7.23318 18.2465 7.49996C18.2465 7.76674 18.1362 8.02261 17.9396 8.21125L13.9962 11.997C13.9386 12.0523 13.8605 12.0833 13.7792 12.0833C13.6097 12.0833 13.4723 11.9514 13.4723 11.7886V9.16663H10.9298C7.39583 9.16663 6.09375 12.0833 6.09375 12.0833V9.99996C6.09375 7.69878 8.03696 5.83329 10.434 5.83329H13.4723Z"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const regenerateUrlIcon = (fill) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      x="0px"
      y="0px"
      viewBox="0 0 100 125"
      enable-background="new 0 0 100 100"
      width={15}
      height={15}>
      <g>
        <path d="M90.6,64.3c-1-0.4-2.2,0.1-2.6,1.1c-2.1,5.1-5.1,9.6-9,13.6c-7.7,7.7-18,12-29,12s-21.2-4.3-29-12S9,61,9,50   c0-11,4.3-21.2,12-29c7.7-7.7,18-12,29-12s21.2,4.3,29,12c1.6,1.6,3,3.2,4.2,5H66c-1.1,0-2,0.9-2,2s0.9,2,2,2h21c1.1,0,2-0.9,2-2V7   c0-1.1-0.9-2-2-2s-2,0.9-2,2v14.7c-1-1.2-2-2.4-3.2-3.6C73.3,9.7,62,5,50,5S26.7,9.7,18.2,18.2C9.7,26.7,5,38,5,50   c0,12,4.7,23.3,13.2,31.8C26.7,90.3,38,95,50,95c12,0,23.3-4.7,31.8-13.2c4.3-4.3,7.6-9.3,9.9-14.9C92.1,65.9,91.6,64.7,90.6,64.3z   " />
      </g>
    </svg>
  );
};

export const proPlaneIcons = (fill) => {
  return (
    <svg
      width="44"
      height="45"
      viewBox="0 0 44 45"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <rect y="0.5" width="44" height="44" rx="4" fill="#FFF3DC" />
      <path
        d="M29.8763 29.9141H13.405C12.7553 29.9141 12.2285 30.4408 12.2285 31.0906C12.2285 31.7403 12.7553 32.2671 13.405 32.2671H29.8763C30.5261 32.2671 31.0528 31.7403 31.0528 31.0906C31.0528 30.4408 30.5261 29.9141 29.8763 29.9141Z"
        fill="#FFAC05"
      />
      <path
        d="M32.222 15.9256L31.0477 26.5144C30.9801 27.1106 30.4776 27.5611 29.8761 27.5611H13.4058C12.807 27.5611 12.3019 27.1106 12.2368 26.5144L11.06 15.9256C11.0079 15.4596 11.2396 15.0066 11.6458 14.7748C12.0546 14.5431 12.5597 14.5744 12.9346 14.8555L16.7306 17.7013L20.7219 12.7076C20.9458 12.429 21.2843 12.2676 21.641 12.2676C22.0003 12.2676 22.3361 12.429 22.56 12.7076L26.554 17.7013L30.3474 14.8555C30.7223 14.5744 31.23 14.5431 31.6362 14.7748C32.0449 15.0066 32.274 15.4596 32.222 15.9256Z"
        fill="#FFAC05"
      />
    </svg>
  );
};

export const nonFillTick = (fill) => {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <circle cx="8" cy="8.5" r="8" fill="#B3B3B6" />
      <path
        d="M7.62891 11.1864C7.41647 11.1864 7.2116 11.1029 7.05987 10.9512L5.0341 8.92542C4.72301 8.61433 4.72301 8.106 5.0341 7.79492C5.34518 7.48383 5.85351 7.48383 6.1646 7.79492L7.60616 9.23648L10.6107 5.95882C10.9066 5.6326 11.4149 5.60979 11.7412 5.91331C12.0674 6.20921 12.0902 6.71753 11.7867 7.04381L8.22072 10.9284C8.07655 11.0878 7.86413 11.1864 7.64411 11.1864L7.62891 11.1864Z"
        fill="white"
      />
    </svg>
  );
};

export const fillTickIcon = (fill) => {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <circle cx="8" cy="8.5" r="8" fill="#009A29" />
      <path
        d="M7.62891 11.1864C7.41647 11.1864 7.2116 11.1029 7.05987 10.9512L5.0341 8.92542C4.72301 8.61433 4.72301 8.106 5.0341 7.79492C5.34518 7.48383 5.85351 7.48383 6.1646 7.79492L7.60616 9.23648L10.6107 5.95882C10.9066 5.6326 11.4149 5.60979 11.7412 5.91331C12.0674 6.20921 12.0902 6.71753 11.7867 7.04381L8.22072 10.9284C8.07655 11.0878 7.86413 11.1864 7.64411 11.1864L7.62891 11.1864Z"
        fill="white"
      />
    </svg>
  );
};

export const standardPlaneIcon = (fill) => {
  return (
    <svg
      width="45"
      height="45"
      viewBox="0 0 45 45"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <rect x="0.5" y="0.162109" width="44" height="44" rx="4" fill="#EDE4FF" />
      <path
        d="M14.1388 20.219L16.753 21.2982C16.4582 22.0391 16.2231 22.8021 16.0499 23.5801L15.9507 24.0289L19.6984 27.7624L20.1491 27.666C20.9305 27.4935 21.6969 27.2594 22.441 26.9659L23.525 29.5687C23.5356 29.5945 23.5525 29.6172 23.5741 29.6349C23.5958 29.6526 23.6215 29.6646 23.649 29.67C23.6765 29.6753 23.7048 29.6738 23.7316 29.6655C23.7583 29.6572 23.7826 29.6424 23.8022 29.6225L25.4405 27.9913C25.7079 27.7251 25.9162 27.4061 26.0521 27.0548C26.1879 26.7035 26.2483 26.3277 26.2293 25.9517L26.1707 24.9039C29.204 22.6736 32.2733 18.7628 33.1094 11.9373C33.1331 11.7662 33.1168 11.5919 33.0618 11.4281C33.0068 11.2643 32.9145 11.1153 32.7921 10.9928C32.6697 10.8703 32.5206 10.7776 32.3564 10.722C32.1921 10.6663 32.0172 10.6491 31.8452 10.6718C24.992 11.511 21.0618 14.5692 18.8218 17.5803L17.7716 17.5265C17.3948 17.5061 17.0179 17.5644 16.6651 17.6977C16.3123 17.831 15.9914 18.0364 15.7231 18.3006L14.0847 19.9318C14.062 19.951 14.0448 19.9758 14.0349 20.0038C14.0249 20.0318 14.0226 20.0618 14.0281 20.091C14.0336 20.1202 14.0467 20.1473 14.0662 20.1698C14.0856 20.1923 14.1107 20.2093 14.1388 20.219ZM24.6495 16.2431C24.9334 15.9613 25.2948 15.7697 25.6881 15.6924C26.0813 15.615 26.4888 15.6554 26.859 15.8085C27.2292 15.9615 27.5455 16.2203 27.7681 16.5523C27.9906 16.8842 28.1094 17.2743 28.1094 17.6734C28.1094 18.0725 27.9906 18.4627 27.7681 18.7946C27.5455 19.1265 27.2292 19.3854 26.859 19.5384C26.4888 19.6915 26.0813 19.7319 25.6881 19.6545C25.2948 19.5772 24.9334 19.3855 24.6495 19.1038C24.4604 18.9162 24.3104 18.6933 24.208 18.4478C24.1057 18.2024 24.053 17.9392 24.053 17.6734C24.053 17.4077 24.1057 17.1445 24.208 16.899C24.3104 16.6536 24.4604 16.4307 24.6495 16.2431ZM13.6498 28.0609C13.216 27.9093 12.7501 27.8722 12.2976 27.9532C12.2574 27.9618 12.2157 27.9602 12.1763 27.9484C12.1368 27.9367 12.1011 27.9151 12.0723 27.8859C12.0366 27.8505 12.0127 27.805 12.0038 27.7556C11.995 27.7063 12.0016 27.6554 12.0227 27.6099C12.5027 26.5822 13.776 24.5157 16.0814 26.1851C16.0934 26.1958 16.1031 26.209 16.1097 26.2237C16.1163 26.2384 16.1197 26.2543 16.1197 26.2704C16.1197 26.2864 16.1163 26.3024 16.1097 26.3171C16.1031 26.3317 16.0934 26.3449 16.0814 26.3556C15.7728 26.5976 15.5256 26.9086 15.36 27.2633C15.1944 27.618 15.115 28.0065 15.1281 28.3974C15.1298 28.4433 15.1489 28.4869 15.1815 28.5193C15.2141 28.5518 15.2578 28.5708 15.3039 28.5724C15.6949 28.5881 16.0841 28.5122 16.4403 28.3509C16.7964 28.1895 17.1096 27.9473 17.3547 27.6435C17.3655 27.6304 17.379 27.6198 17.3944 27.6125C17.4098 27.6053 17.4266 27.6015 17.4437 27.6015C17.4607 27.6015 17.4776 27.6053 17.493 27.6125C17.5083 27.6198 17.5219 27.6304 17.5327 27.6435C17.8527 28.0227 18.7339 29.2613 17.7581 30.4572C17.3321 30.967 16.7217 31.2894 16.0589 31.3547C15.1124 31.4557 13.3636 31.763 12.6492 32.5753C12.6205 32.6091 12.5832 32.6346 12.5411 32.6489C12.499 32.6633 12.4539 32.666 12.4104 32.6568C12.3669 32.6475 12.3267 32.6267 12.2942 32.5966C12.2616 32.5664 12.2379 32.5281 12.2255 32.4855C11.9731 31.6284 11.581 29.7123 13.6498 28.0609Z"
        fill="#6319F2"
      />
    </svg>
  );
};

export const diamondIcon = (fill) => {
  return (
    <svg
      width="44"
      height="45"
      viewBox="0 0 44 45"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <rect y="0.5" width="44" height="44" rx="4" fill="#E8F1FE" />
      <path
        d="M20.986 32L9.5 16.4448H15.4602L20.986 32ZM27.1519 16.4448L21.6522 31.9282L16.1558 16.4448H27.1519ZM18.7587 12L15.5385 15.7916H9.69922L14.8103 12H18.7587ZM26.9102 15.7916H16.3975L19.6143 12H23.6901L26.9102 15.7916ZM33.6052 15.7916H27.7626L24.5457 12H28.4941L33.6052 15.7916ZM33.8044 16.4448L22.3184 32L27.841 16.4448H33.8044Z"
        fill="#176CDC"
      />
    </svg>
  );
};

export const CrossBtnIcon = (fill) => {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14.9994 15.1621L9 9.16211M9.00064 15.1621L15 9.16211"
        stroke="#8E8E93"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22 12.1621C22 6.63926 17.5228 2.16211 12 2.16211C6.47715 2.16211 2 6.63926 2 12.1621C2 17.6849 6.47715 22.1621 12 22.1621C17.5228 22.1621 22 17.6849 22 12.1621Z"
        stroke="#8E8E93"
        strokeWidth="1.5"
      />
    </svg>
  );
};

export const downloadPdfIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M20 13V10.6569C20 9.83935 20 9.4306 19.8478 9.06306C19.6955 8.69552 19.4065 8.40649 18.8284 7.82843L14.0919 3.09188C13.593 2.593 13.3436 2.34355 13.0345 2.19575C12.9702 2.165 12.9044 2.13772 12.8372 2.11401C12.5141 2 12.1614 2 11.4558 2C8.21082 2 6.58831 2 5.48933 2.88607C5.26731 3.06508 5.06508 3.26731 4.88607 3.48933C4 4.58831 4 6.21082 4 9.45584V13M13 2.5V3C13 5.82843 13 7.24264 13.8787 8.12132C14.7574 9 16.1716 9 19 9H19.5"
        stroke="#5A5B62"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.75 16H17.25C16.6977 16 16.25 16.4477 16.25 17V19M16.25 19V22M16.25 19H19.25M4.25 22V19.5M4.25 19.5V16H6C6.9665 16 7.75 16.7835 7.75 17.75C7.75 18.7165 6.9665 19.5 6 19.5H4.25ZM10.25 16H11.75C12.8546 16 13.75 16.8954 13.75 18V20C13.75 21.1046 12.8546 22 11.75 22H10.25V16Z"
        stroke="#5A5B62"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const orgIcon = () => {
  return (
    <svg
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14.2143 6.71429H12.4286V2.78571C12.4286 2.31211 12.2404 1.85791 11.9055 1.52302C11.5707 1.18814 11.1165 1 10.6429 1H6.35714C5.88354 1 5.42934 1.18814 5.09445 1.52302C4.75957 1.85791 4.57143 2.31211 4.57143 2.78571V4.57143H2.78571C2.31211 4.57143 1.85791 4.75957 1.52302 5.09445C1.18814 5.42934 1 5.88354 1 6.35714V15.6429C1 15.7376 1.03763 15.8284 1.1046 15.8954C1.17158 15.9624 1.26242 16 1.35714 16H15.6429C15.7376 16 15.8284 15.9624 15.8954 15.8954C15.9624 15.8284 16 15.7376 16 15.6429V8.5C16 8.0264 15.8119 7.5722 15.477 7.23731C15.1421 6.90242 14.6879 6.71429 14.2143 6.71429ZM1.71429 6.35714C1.71429 6.07298 1.82717 5.80046 2.0281 5.59953C2.22903 5.3986 2.50155 5.28571 2.78571 5.28571H4.57143V15.2857H1.71429V6.35714ZM5.28571 4.92857V2.78571C5.28571 2.50155 5.3986 2.22903 5.59953 2.0281C5.80046 1.82717 6.07298 1.71429 6.35714 1.71429H10.6429C10.927 1.71429 11.1995 1.82717 11.4005 2.0281C11.6014 2.22903 11.7143 2.50155 11.7143 2.78571V15.2857H10.2857V12.0714C10.2857 11.7873 10.1728 11.5147 9.9719 11.3138C9.77097 11.1129 9.49845 11 9.21429 11H7.78571C7.50155 11 7.22903 11.1129 7.0281 11.3138C6.82717 11.5147 6.71429 11.7873 6.71429 12.0714V15.2857H5.28571V4.92857ZM7.42857 15.2857V12.0714C7.42857 11.9767 7.4662 11.8859 7.53318 11.8189C7.60015 11.7519 7.69099 11.7143 7.78571 11.7143H9.21429C9.30901 11.7143 9.39985 11.7519 9.46682 11.8189C9.5338 11.8859 9.57143 11.9767 9.57143 12.0714V15.2857H7.42857ZM15.2857 15.2857H12.4286V7.42857H14.2143C14.4984 7.42857 14.771 7.54145 14.9719 7.74239C15.1728 7.94332 15.2857 8.21584 15.2857 8.5V15.2857Z"
        fill="#5A5B62"
        stroke="#5A5B62"
        strokeWidth="0.5"
      />
    </svg>
  );
};
export const orgIconActive = () => {
  return (
    <svg
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14.2143 6.71429H12.4286V2.78571C12.4286 2.31211 12.2404 1.85791 11.9055 1.52302C11.5707 1.18814 11.1165 1 10.6429 1H6.35714C5.88354 1 5.42934 1.18814 5.09445 1.52302C4.75957 1.85791 4.57143 2.31211 4.57143 2.78571V4.57143H2.78571C2.31211 4.57143 1.85791 4.75957 1.52302 5.09445C1.18814 5.42934 1 5.88354 1 6.35714V15.6429C1 15.7376 1.03763 15.8284 1.1046 15.8954C1.17158 15.9624 1.26242 16 1.35714 16H15.6429C15.7376 16 15.8284 15.9624 15.8954 15.8954C15.9624 15.8284 16 15.7376 16 15.6429V8.5C16 8.0264 15.8119 7.5722 15.477 7.23731C15.1421 6.90242 14.6879 6.71429 14.2143 6.71429ZM1.71429 6.35714C1.71429 6.07298 1.82717 5.80046 2.0281 5.59953C2.22903 5.3986 2.50155 5.28571 2.78571 5.28571H4.57143V15.2857H1.71429V6.35714ZM5.28571 4.92857V2.78571C5.28571 2.50155 5.3986 2.22903 5.59953 2.0281C5.80046 1.82717 6.07298 1.71429 6.35714 1.71429H10.6429C10.927 1.71429 11.1995 1.82717 11.4005 2.0281C11.6014 2.22903 11.7143 2.50155 11.7143 2.78571V15.2857H10.2857V12.0714C10.2857 11.7873 10.1728 11.5147 9.9719 11.3138C9.77097 11.1129 9.49845 11 9.21429 11H7.78571C7.50155 11 7.22903 11.1129 7.0281 11.3138C6.82717 11.5147 6.71429 11.7873 6.71429 12.0714V15.2857H5.28571V4.92857ZM7.42857 15.2857V12.0714C7.42857 11.9767 7.4662 11.8859 7.53318 11.8189C7.60015 11.7519 7.69099 11.7143 7.78571 11.7143H9.21429C9.30901 11.7143 9.39985 11.7519 9.46682 11.8189C9.5338 11.8859 9.57143 11.9767 9.57143 12.0714V15.2857H7.42857ZM15.2857 15.2857H12.4286V7.42857H14.2143C14.4984 7.42857 14.771 7.54145 14.9719 7.74239C15.1728 7.94332 15.2857 8.21584 15.2857 8.5V15.2857Z"
        fill="#090A14"
      />
      <path
        d="M5.28571 4.92857V2.78571C5.28571 2.50155 5.3986 2.22903 5.59953 2.0281C5.80046 1.82717 6.07298 1.71429 6.35714 1.71429H10.6429C10.927 1.71429 11.1995 1.82717 11.4005 2.0281C11.6014 2.22903 11.7143 2.50155 11.7143 2.78571V15.2857H10.2857V12.0714C10.2857 11.7873 10.1728 11.5147 9.9719 11.3138C9.77097 11.1129 9.49845 11 9.21429 11H7.78571C7.50155 11 7.22903 11.1129 7.0281 11.3138C6.82717 11.5147 6.71429 11.7873 6.71429 12.0714V15.2857H5.28571V4.92857Z"
        fill="#090A14"
      />
      <path
        d="M14.2143 6.71429H12.4286V2.78571C12.4286 2.31211 12.2404 1.85791 11.9055 1.52302C11.5707 1.18814 11.1165 1 10.6429 1H6.35714C5.88354 1 5.42934 1.18814 5.09445 1.52302C4.75957 1.85791 4.57143 2.31211 4.57143 2.78571V4.57143H2.78571C2.31211 4.57143 1.85791 4.75957 1.52302 5.09445C1.18814 5.42934 1 5.88354 1 6.35714V15.6429C1 15.7376 1.03763 15.8284 1.1046 15.8954C1.17158 15.9624 1.26242 16 1.35714 16H15.6429C15.7376 16 15.8284 15.9624 15.8954 15.8954C15.9624 15.8284 16 15.7376 16 15.6429V8.5C16 8.0264 15.8119 7.5722 15.477 7.23731C15.1421 6.90242 14.6879 6.71429 14.2143 6.71429ZM1.71429 6.35714C1.71429 6.07298 1.82717 5.80046 2.0281 5.59953C2.22903 5.3986 2.50155 5.28571 2.78571 5.28571H4.57143V15.2857H1.71429V6.35714ZM5.28571 4.92857V2.78571C5.28571 2.50155 5.3986 2.22903 5.59953 2.0281C5.80046 1.82717 6.07298 1.71429 6.35714 1.71429H10.6429C10.927 1.71429 11.1995 1.82717 11.4005 2.0281C11.6014 2.22903 11.7143 2.50155 11.7143 2.78571V15.2857H10.2857V12.0714C10.2857 11.7873 10.1728 11.5147 9.9719 11.3138C9.77097 11.1129 9.49845 11 9.21429 11H7.78571C7.50155 11 7.22903 11.1129 7.0281 11.3138C6.82717 11.5147 6.71429 11.7873 6.71429 12.0714V15.2857H5.28571V4.92857ZM7.42857 15.2857V12.0714C7.42857 11.9767 7.4662 11.8859 7.53318 11.8189C7.60015 11.7519 7.69099 11.7143 7.78571 11.7143H9.21429C9.30901 11.7143 9.39985 11.7519 9.46682 11.8189C9.5338 11.8859 9.57143 11.9767 9.57143 12.0714V15.2857H7.42857ZM15.2857 15.2857H12.4286V7.42857H14.2143C14.4984 7.42857 14.771 7.54145 14.9719 7.74239C15.1728 7.94332 15.2857 8.21584 15.2857 8.5V15.2857Z"
        stroke="#090A14"
        strokeWidth="0.5"
      />
      <path
        d="M5.28571 4.92857V2.78571C5.28571 2.50155 5.3986 2.22903 5.59953 2.0281C5.80046 1.82717 6.07298 1.71429 6.35714 1.71429H10.6429C10.927 1.71429 11.1995 1.82717 11.4005 2.0281C11.6014 2.22903 11.7143 2.50155 11.7143 2.78571V15.2857H10.2857V12.0714C10.2857 11.7873 10.1728 11.5147 9.9719 11.3138C9.77097 11.1129 9.49845 11 9.21429 11H7.78571C7.50155 11 7.22903 11.1129 7.0281 11.3138C6.82717 11.5147 6.71429 11.7873 6.71429 12.0714V15.2857H5.28571V4.92857Z"
        stroke="#090A14"
        strokeWidth="0.5"
      />
    </svg>
  );
};
export const BackButton = () => {
  return (
    
<svg width="14" height="10" viewBox="0 0 14 10" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0.599854 5H13.3998" stroke="#5A5B62" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M4.59983 9C4.59983 9 0.59987 6.05408 0.599854 5C0.599846 3.94592 4.59985 1 4.59985 1" stroke="#5A5B62" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>

  );
};
export const requestPrice = () => {
  return (
    
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} color={"#000000"} fill={"none"}>
    <path d="M3 13V8H21V13C21 16.7712 21 18.6569 19.8284 19.8284C18.6569 21 16.7712 21 13 21H11C7.22876 21 5.34315 21 4.17157 19.8284C3 18.6569 3 16.7712 3 13Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M3 8L3.86538 6.07692C4.53654 4.58547 4.87211 3.83975 5.55231 3.41987C6.23251 3 7.105 3 8.85 3H15.15C16.895 3 17.7675 3 18.4477 3.41987C19.1279 3.83975 19.4635 4.58547 20.1346 6.07692L21 8" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    <path d="M12 8V3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    <path d="M8.5 13.5H14C15.1046 13.5 16 14.3954 16 15.5C16 16.6046 15.1046 17.5 14 17.5H13M10 11.5L8 13.5L10 15.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
</svg>

  );
};

export const crossIcon = (props) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="24" height="23.9998" rx="11.9999" fill="#E6E7E8" />
      <path
        d="M8 16L11.9999 12M11.9999 12L16.0001 8M11.9999 12L8 8M11.9999 12L16.0001 16"
        stroke="#5A5B62"
        stroke-width="1.33333"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
export const contactCallIcon = (props) => {
  return (
    <svg
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="36" height="36" rx="18" fill="#1977F2" />
      <g clip-path="url(#clip0_8085_5770)">
        <path
          d="M11.3971 15.0471C11.5812 15.9593 11.8863 16.8592 12.5183 17.9613L14.2226 16.0037C14.8448 15.2889 15.156 14.9315 15.2017 14.4927C15.2475 14.0539 15.0168 13.6401 14.5554 12.8123L13.9733 11.7679C13.7154 11.3054 13.2156 11.1839 12.7795 11.5393C11.7478 12.3802 11.125 13.6981 11.3971 15.0471Z"
          fill="white"
        />
        <path
          d="M18.0383 23.4813C19.1404 24.1133 20.0403 24.4185 20.9525 24.6025C22.3015 24.8746 23.6194 24.2518 24.4603 23.2201C24.8157 22.7841 24.6943 22.2842 24.2317 22.0263L23.1873 21.4442C22.3595 20.9828 21.9457 20.7521 21.5069 20.7979C21.0681 20.8436 20.7107 21.1547 19.9959 21.777L18.0383 23.4813Z"
          fill="white"
        />
        <path
          d="M12.5183 17.9613C11.8863 16.8592 11.5812 15.9593 11.3971 15.0471C11.125 13.6981 11.7478 12.3802 12.7795 11.5393C13.2156 11.1839 13.7154 11.3054 13.9733 11.7679L14.5554 12.8123C15.0168 13.6401 15.2475 14.0539 15.2017 14.4927C15.156 14.9315 14.8448 15.2889 14.2226 16.0037L12.5183 17.9613ZM12.5183 17.9613C13.7976 20.1919 15.8051 22.2005 18.0383 23.4813M18.0383 23.4813C19.1404 24.1133 20.0403 24.4185 20.9525 24.6025C22.3015 24.8746 23.6194 24.2518 24.4603 23.2201C24.8157 22.7841 24.6943 22.2842 24.2317 22.0263L23.1873 21.4442C22.3595 20.9828 21.9457 20.7521 21.5069 20.7979C21.0681 20.8436 20.7107 21.1547 19.9959 21.777L18.0383 23.4813Z"
          stroke="white"
          stroke-width="1.33333"
          stroke-linejoin="round"
        />
        <path
          d="M23.1821 12.8182L18.6667 17.3337M23.1821 12.8182C22.8453 12.4814 21.2565 12.8114 20.7767 12.8182M23.1821 12.8182C23.519 13.1551 23.189 14.744 23.1821 15.2237"
          stroke="white"
          stroke-width="1.33333"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_8085_5770">
          <rect
            width="16"
            height="16"
            fill="white"
            transform="translate(10 10)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
export const attachmentIcon = (props) => {
  return (
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M2.5 12C2.5 7.52166 2.5 5.28249 3.89124 3.89124C5.28249 2.5 7.52166 2.5 12 2.5C16.4783 2.5 18.7175 2.5 20.1088 3.89124C21.5 5.28249 21.5 7.52166 21.5 12C21.5 16.4783 21.5 18.7175 20.1088 20.1088C18.7175 21.5 16.4783 21.5 12 21.5C7.52166 21.5 5.28249 21.5 3.89124 20.1088C2.5 18.7175 2.5 16.4783 2.5 12Z" stroke="#B3B3B6" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M16 11.5C16 11.5 13.0541 7.50001 12 7.5C10.9459 7.49999 8 11.5 8 11.5M12 8V16.5" stroke="#B3B3B6" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
  );
};

export const crossIconSmall = (props) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="20" height="20" rx="10" fill="#E6E7E8" />
      <path
        d="M6.66663 13.3337L9.99991 10.0003M9.99991 10.0003L13.3334 6.66699M9.99991 10.0003L6.66663 6.66699M9.99991 10.0003L13.3334 13.3337"
        stroke="#5A5B62"
        stroke-width="1.11111"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const filter_chevron = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M15 7.50004C15 7.50004 11.3176 12.5 10 12.5C8.68233 12.5 5 7.5 5 7.5"
        stroke="#5A5B62"
        stroke-width="1.25"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const smallSearchIcon = (props) => {
  return (
    <svg
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <ellipse
        cx="7.84442"
        cy="7.43671"
        rx="5.99237"
        ry="5.99237"
        stroke="#090A14"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12.0122 11.916L16.1393 16.037"
        stroke="#090A14"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const reelsContentIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width ? props.width : "24"}
      height={props.height ? props.height : "24"}
      viewBox="0 0 24 24"
      fill="none">
      <path
        d="M14.4531 12.8948C14.3016 13.5215 13.5857 13.9644 12.1539 14.8502C10.7697 15.7064 10.0777 16.1346 9.51993 15.9625C9.28934 15.8913 9.07925 15.7562 8.90982 15.57C8.5 15.1198 8.5 14.2465 8.5 12.5C8.5 10.7535 8.5 9.88018 8.90982 9.42995C9.07925 9.24381 9.28934 9.10868 9.51993 9.03753C10.0777 8.86544 10.7697 9.29357 12.1539 10.1498C13.5857 11.0356 14.3016 11.4785 14.4531 12.1052C14.5156 12.3639 14.5156 12.6361 14.4531 12.8948Z"
        stroke="white"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path
        d="M20.9977 11C21 11.4701 21 11.9693 21 12.5C21 16.9783 21 19.2175 19.6088 20.6088C18.2175 22 15.9783 22 11.5 22C7.02166 22 4.78249 22 3.39124 20.6088C2 19.2175 2 16.9783 2 12.5C2 8.02166 2 5.78249 3.39124 4.39124C4.78249 3 7.02166 3 11.5 3C12.0307 3 12.5299 3 13 3.00231"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M18.5 2L18.7579 2.69703C19.0961 3.61102 19.2652 4.06802 19.5986 4.40139C19.932 4.73477 20.389 4.90387 21.303 5.24208L22 5.5L21.303 5.75792C20.389 6.09613 19.932 6.26524 19.5986 6.59861C19.2652 6.93198 19.0961 7.38898 18.7579 8.30297L18.5 9L18.2421 8.30297C17.9039 7.38898 17.7348 6.93198 17.4014 6.59861C17.068 6.26524 16.611 6.09613 15.697 5.75792L15 5.5L15.697 5.24208C16.611 4.90387 17.068 4.73477 17.4014 4.40139C17.7348 4.06802 17.9039 3.61102 18.2421 2.69703L18.5 2Z"
        stroke="white"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const Story = (fill) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none">
      <path
        d="M5.64 5.64A9 9 0 1 1 3.75 8.5"
        stroke="url(#story_instagram_gradient)"
        strokeWidth="2.5"
        strokeLinecap="round"
      />
      <path
        d="M12 7V17M7 12H17"
        stroke="url(#story_instagram_gradient)"
        strokeWidth="2.5"
        strokeLinecap="round"
      />
      <defs>
        <linearGradient
          id="story_instagram_gradient"
          x1="22.9"
          y1="23.3"
          x2="0.2"
          y2="0.7"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#FBE18A" />
          <stop offset="0.21" stopColor="#FCBB45" />
          <stop offset="0.38" stopColor="#F75274" />
          <stop offset="0.52" stopColor="#D53692" />
          <stop offset="0.74" stopColor="#8F39CE" />
          <stop offset="1" stopColor="#5B4FE9" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const Shorts = (fill) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none">
      <path
        d="M17.77 10.3202L18.01 10.1902C19.79 9.17025 20.4 6.90025 19.38 5.12025C18.36 3.34025 16.09 2.73025 14.31 3.75025L5.05001 9.09025C3.76001 9.83025 2.97001 11.2103 2.97001 12.7003C2.97001 14.1903 3.76001 15.5703 5.05001 16.3103L4.81001 16.4403C3.03001 17.4603 2.42001 19.7303 3.44001 21.5103C4.46001 23.2903 6.73001 23.9003 8.51001 22.8803L17.77 17.5403C19.06 16.8003 19.85 15.4203 19.85 13.9303C19.85 12.4403 19.06 11.0603 17.77 10.3202ZM10 16.5603V9.44025L15.19 13.0003L10 16.5603Z"
        fill="#FF0000"
      />
    </svg>
  );
};

export const excelExportIcon = (props) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M16.6667 10.8333V8.88071C16.6667 8.19942 16.6667 7.85879 16.5399 7.55251C16.413 7.24623 16.1721 7.00537 15.6904 6.52365L11.7433 2.57653C11.3275 2.16079 11.1197 1.95292 10.8621 1.82975C10.8085 1.80413 10.7537 1.78139 10.6977 1.76163C10.4285 1.66663 10.1345 1.66663 9.54654 1.66663C6.84239 1.66663 5.4903 1.66663 4.57448 2.40502C4.38947 2.55419 4.22094 2.72272 4.07177 2.90773C3.33337 3.82355 3.33337 5.17564 3.33337 7.87983V10.8333M10.8334 2.08329V2.49996C10.8334 4.85698 10.8334 6.03549 11.5656 6.76773C12.2979 7.49996 13.4764 7.49996 15.8334 7.49996H16.25"
        stroke="#1977F2"
      />
      <path
        d="M8.75 13.3334V16.6667C8.75 17.4524 8.75 17.8452 8.99408 18.0893C9.23817 18.3334 9.631 18.3334 10.4167 18.3334H11.6667"
        stroke="#1977F2"
      />
      <path
        d="M3.33337 13.3334L5.00004 15.8334M5.00004 15.8334L6.66671 18.3334M5.00004 15.8334L6.66671 13.3334M5.00004 15.8334L3.33337 18.3334"
        stroke="#1977F2"
      />
      <path
        d="M16.6668 13.3334H14.5833C14.1231 13.3334 13.75 13.7065 13.75 14.1667V15C13.75 15.4603 14.1231 15.8334 14.5833 15.8334H15.8335C16.2938 15.8334 16.6668 16.2065 16.6668 16.6667V17.5C16.6668 17.9603 16.2938 18.3334 15.8335 18.3334H13.75"
        stroke="#1977F2"
      />
    </svg>
  );
};

export const SyncBlueIcon = (props) => {
  const color = props?.color || "#1977F2";
  const width = props?.width || "20";
  const height = props?.height || "20";
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M21 2V8H15"
        stroke={color}
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3 12C3 9.61305 3.94821 7.32387 5.63604 5.63604C7.32387 3.94821 9.61305 3 12 3C14.3869 3 16.6761 3.94821 18.364 5.63604L21 8"
        stroke={color}
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3 22V16H9"
        stroke={color}
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21 12C21 14.3869 20.0518 16.6761 18.364 18.364C16.6761 20.0518 14.3869 21 12 21C9.61305 21 7.32387 20.0518 5.63604 18.364L3 16"
        stroke={color}
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const SyncBlueIconSmall = (props) => {
  const color = props?.color || "#1977F2";
  return (
    <svg
      width={16}
      height={16}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M21 2V8H15"
        stroke={color}
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3 12C3 9.61305 3.94821 7.32387 5.63604 5.63604C7.32387 3.94821 9.61305 3 12 3C14.3869 3 16.6761 3.94821 18.364 5.63604L21 8"
        stroke={color}
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3 22V16H9"
        stroke={color}
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21 12C21 14.3869 20.0518 16.6761 18.364 18.364C16.6761 20.0518 14.3869 21 12 21C9.61305 21 7.32387 20.0518 5.63604 18.364L3 16"
        stroke={color}
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
